<template>
  <div class="wrap">
    <!-- 顶部标题 -->
    <div class="header_title">
      <div class="header_center">
        <div class="title">
          申报项目:
          <span>{{ $route.query.title }}</span>
        </div>
        <div class="back_page" @click="backpage">返回上一页</div>
      </div>
    </div>
    
    <div v-if="$route.query.title == '贵州省工程建设工法评定' && $route.query.r && reject_reason " style="background-color:#FFFBF4;text-align:left;margin-bottom: 20px;padding: 10px;color:#595959;font-size: 16px;max-width: 1180px;width: 1180px;margin: 0 auto;margin-top: 78px;">
            <div style="font-weight: bold;font-size: 18px;color: #262626;margin-bottom:20px;">驳回原因</div>
            <div>{{reject_reason}}</div>
            <div v-if="return_type === 'expert' && modify_deadline" class="gongfa-return-notice">
              您申报的“贵州省工程建设工法”资料已被专家退回，请根据退回意见要求，于{{ modify_deadline }}日完成修改并重新提交，逾期未提交的审核终止！
            </div>
            <div v-else-if="modify_deadline" class="gongfa-return-notice">
              请在 {{ modify_deadline }} 前完成修订并重新提交。
            </div>
     </div>
     <div v-if="$route.query.title == '贵州省工程建设工法评定' && $route.query.r && reject_reason "  style="text-align:left;margin-bottom: 20px;padding: 10px;color:#595959;font-size: 16px;max-width: 1180px;width: 1180px;margin: 0 auto;color:#FF9DA4">
         *下标红内容为需修订项目,请按驳回建议进行修正后重新提交   
     </div>
            
    <!-- 表单盒子，左边的导航栏nav_left,右边的表单form_rightform_right -->
    <div class="form_box" :style=" ($route.query.title == '贵州省工程建设工法评定' && $route.query.r && reject_reason) ? 'padding-top:10px' : ''">
        
      <div class="nav_left">
        <div class="nav_title">需填写表单申报表</div>
        <div class="nav_list">
          <!-- 导航栏列表 -->
          <div class="list" v-for="(item, index) in lefttitlelist" @click="scrollleft(item.name, item.id)" :key="index">
            <img class="tips" v-if="item.isok" src="../assets/6598@2x.png" alt />
            <img class="tips" v-else src="../assets/6668@2x.png" alt />
            <p>{{ item.name }}</p>
          </div>
        </div>
        <div class="preview">
          <!-- 左边三个按钮 -->
          <el-button v-if="rId == 0 && $route.query.title != '贵州省工程建设工法评定'" class="preservation" icon="el-icon-folder-opened" :plain="true"
            :loading="btnSaveStatus" v-btn-control="SaveDraftleft">保存草稿</el-button>
          <el-button v-if="rId == 0 && $route.query.title != '贵州省工程建设工法评定' " class="online" icon="el-icon-view" :plain="true" @click="printPdf">在线预览</el-button>
          <div class="sumbit" :class="issumbitshow ? 'blue' : ''" v-btn-control="sumbit">
            <img src="../assets/19178@2x.png" alt />
            <p>提交审核</p>
          </div>
        </div>
      </div>
<div class="form_right form_right--green" v-if="$route.query.title == '建筑与市政工程绿色施工评价'" id="exportPdf" ref="exportPdf">
        <div class="form_1" id="info">
          <!-- title提示标题文字,background提示盒子背景色,border提示盒子左边边框颜色 -->
          <Tips title="基本信息" :background="lefttitlelist[0].isok ? '#EDF8F5' : '#FEF8EF'"
            :border="lefttitlelist[0].isok ? '#1ABF98' : '#FFB700'" :states="lefttitlelist[0].isok"></Tips>
          <div class="form_box_content">
            <div class="my_form2">
              <div class="form_title" style="height: 62px">工程名称</div>
              <div class="form_long">
                <input placeholder="请输入工程名称（同一企业申请工程名称不允许重复提交）" type="text" v-model="parameters3.info.msg1" />
              </div>
            </div>
            <div class="my_form2">
              <div class="form_title" style="height: 62px">建设规模和分类</div>
              <div class="form_long" style="display:flex;flex-direction:column; ">
                <input placeholder="请输入" type="text" v-model="parameters3.info.msg2" />
                <div class="el-upload__tip" style="width:100%;text-align:left;padding-left: 26px;">注：规模和分类参照省优质工程要求填写</div>

              </div>
            </div>
            <div class="flex">
              <div class="my_form2">
                <div class="form_title" style="height: 62px">计划开工日期</div>
                <div class="form_content">
                  <el-date-picker type="date" value-format="yyyy-MM-dd" format="yyyy-MM-dd" placeholder="选择日期"
                    class="inpyabeb" v-model="parameters3.info.msg3"></el-date-picker>
                </div>
              </div>
              <div class="my_form2">
                <div class="form_title" style="height: 62px">计划竣工日期</div>
                <div class="form_content">
                  <el-date-picker type="date" value-format="yyyy-MM-dd" format="yyyy-MM-dd" placeholder="选择日期"
                    class="inpyabeb" v-model="parameters3.info.msg4"></el-date-picker>
                </div>
              </div>
            </div>
            <div class="flex">
              <div class="my_form2">
                <div class="form_title" style="height: 62px">结构型式</div>
                <div class="form_long" >
                    <input type="text" placeholder="请输入" v-model="parameters3.info.msg5" />
                </div>

              </div>
            <!--  <div class="my_form2">
                <div class="form_title" style="height: 62px">工程所在地</div>
                <div class="form_content" style="display:flex;flex-direction:column;">
                  <div class="input">
                    <input type="text" placeholder="请输入" v-model="parameters3.info.msg6" />
                  </div>
                  <div class="el-upload__tip"></div>
                </div>
              </div> -->
            </div>
           <!-- <div class="flex">
              <div class="my_form2">
                <div class="form_title" style="height: 62px">联系人</div>
                <div class="form_content">
                  <div class="input">
                    <input type="text" placeholder="请输入" v-model="parameters3.info.linker" />
                  </div>
                </div>
              </div>
              <div class="my_form2">
                <div class="form_title" style="height: 62px">联系电话</div>
                <div class="form_content">
                  <div class="input">
                    <input type="text" placeholder="请输入" v-model="parameters3.info.tel" />
                  </div>
                </div>
              </div>
            </div> -->
            <div class="my_form2">
              <div class="form_title" style="height: 62px">承建单位名称</div>
              <div class="form_long">
                <input placeholder="请输入" type="text" v-model="parameters3.info.msg7" />
              </div>
            </div>
            <div class="my_form2">
              <div class="form_title" style="height: 62px">建设单位名称</div>
              <div class="form_long">
                <input placeholder="请输入" type="text" v-model="parameters3.info.msg8" />
              </div>
            </div>
            <div class="my_form2">
              <div class="form_title" style="height: 62px">设计单位名称</div>
              <div class="form_long">
                <input placeholder="请输入" type="text" v-model="parameters3.info.msg9" />
              </div>
            </div>
            <div class="flex">
              <div class="my_form2">
                <div class="form_title" style="height: 62px">项目详细所在地</div>
                <div class="form_long">
                    <input type="text" placeholder="请输入" v-model="parameters3.info.msg10" />
                </div>
              </div>
            </div>
            <div class="form_title">
              <p>项目经理信息</p>
            </div>
            <div class="flex">
              <div class="my_form2">
                <div class="form_title" style="height: 62px">姓名</div>
                <div class="form_content">
                  <div class="input">
                    <input type="text" placeholder="请输入" v-model="parameters3.info.msg11" />
                  </div>
                </div>
              </div>
              <div class="my_form2">
                <div class="form_title" style="height: 62px">职称</div>
                <div class="form_content">
                  <div class="input">
                    <input type="text" placeholder="请输入" v-model="parameters3.info.msg12" />
                  </div>
                </div>
              </div>
            </div>
            <div class="flex">
              <div class="my_form2">
                <div class="form_title" style="height: 62px">电话</div>
                <div class="form_content">
                  <div class="input">
                    <input type="text" placeholder="请输入" v-model="parameters3.info.msg13" />
                  </div>
                </div>
              </div>
            </div>
            <div class="form_title">
              <p>项目技术负责人信息</p>
            </div>
            <div class="flex">
              <div class="my_form2">
                <div class="form_title" style="height: 62px">姓名</div>
                <div class="form_content">
                  <div class="input">
                    <input type="text" placeholder="请输入" v-model="parameters3.info.msg14" />
                  </div>
                </div>
              </div>
              <div class="my_form2">
                <div class="form_title" style="height: 62px">职称</div>
                <div class="form_content">
                  <div class="input">
                    <input type="text" placeholder="请输入" v-model="parameters3.info.msg15" />
                  </div>
                </div>
              </div>
            </div>
            <div class="flex">
              <div class="my_form2">
                <div class="form_title" style="height: 62px">电话</div>
                <div class="form_content">
                  <div class="input">
                    <input type="text" placeholder="请输入" v-model="parameters3.info.msg16" />
                  </div>
                </div>
              </div>
            </div>
            <div class="form_title">
              <p>工程所在承建单位联系人信息</p>
            </div>
            <div class="flex">
              <div class="my_form2">
                <div class="form_title" style="height: 62px">姓名</div>
                <div class="form_content">
                  <div class="input">
                    <input type="text" placeholder="请输入" v-model="parameters3.info.msg17" />
                  </div>
                </div>
              </div>
              <div class="my_form2">
                <div class="form_title" style="height: 62px">职称</div>
                <div class="form_content">
                  <div class="input">
                    <input type="text" placeholder="请输入" v-model="parameters3.info.msg18" />
                  </div>
                </div>
              </div>
            </div>
            <div class="flex">
              <div class="my_form2">
                <div class="form_title" style="height: 62px">电话</div>
                <div class="form_content" style="flex-direction:column">
                  <div class="input">
                    <input type="text" placeholder="请输入" v-model="parameters3.info.msg19" />
                  </div>
                  <div class="input-tip">该电话用于接收审核结果</div>
                </div>
              </div>
             <!-- <div class="my_form2">
                <div class="form_title" style="height: 62px">电子邮箱</div>
                <div class="form_content">
                  <div class="input">
                    <input type="text" placeholder="请输入" v-model="parameters3.info.msg20" />
                  </div>
                </div>
              </div> -->
            </div>
          </div>
        </div>
        <div class="form_1" id="ProjectOverview">
          <Tips title="工程概况" :background="lefttitlelist[1].isok ? '#EDF8F5' : '#FEF8EF'"
            :border="lefttitlelist[1].isok ? '#1ABF98' : '#FFB700'" :states="lefttitlelist[1].isok"></Tips>
          <div class="form_box_content">
            <div class="my_form">
              <div class="form_title" style="height: 188px; text-align: center">
                工程概况（限800字内，强调重点难点）
              </div>
              <div class="form_textarea">
                <textarea name id cols="30" rows="10" placeholder="请输入（限800字内，强调重点难点）"
                  v-model="parameters3.ProjectOverview.msg1"></textarea>
              </div>
            </div>
          </div>
        </div>
        <div class="form_1" id="Indicators">
          <Tips title="拟完成绿色施工主要指标情况" :background="lefttitlelist[2].isok ? '#EDF8F5' : '#FEF8EF'"
            :border="lefttitlelist[2].isok ? '#1ABF98' : '#FFB700'" :states="lefttitlelist[2].isok"></Tips>
          <div class="form_box_content">
            <div class="my_form">
              <div class="form_title" style="height: 188px; text-align: center">
                环境保护
              </div>
              <div class="form_textarea">
                <textarea name id cols="30" rows="10" placeholder="请输入"
                  v-model="parameters3.Indicators.msg1"></textarea>
              </div>
            </div>
            <div class="my_form">
              <div class="form_title" style="height: 188px; text-align: center">
                资源节约
              </div>
              <div class="form_textarea">
                <textarea name id cols="30" rows="10" placeholder="请输入"
                  v-model="parameters3.Indicators.msg2"></textarea>
              </div>
            </div>
            <div class="my_form">
              <div class="form_title" style="height: 188px; text-align: center">
                人力资源节约和保护
              </div>
              <div class="form_textarea">
                <textarea name id cols="30" rows="10" placeholder="请输入"
                  v-model="parameters3.Indicators.msg3"></textarea>
              </div>
            </div>
            <div class="my_form">
              <div class="form_title" style="height: 188px; text-align: center">
                技术创新
              </div>
              <div class="form_textarea">
                <textarea name id cols="30" rows="10" placeholder="请输入"
                  v-model="parameters3.Indicators.msg4"></textarea>
              </div>
            </div>
            <!-- <div class="my_form">
              <div class="form_title" style="height: 188px; text-align: center">
                节地与土地资源保护
              </div>
              <div class="form_textarea">
                <textarea name id cols="30" rows="10" placeholder="请输入"
                  v-model="parameters3.Indicators.msg5"></textarea>
              </div>
            </div> -->
            <div class="my_form">
              <div class="form_title" style="height: 188px; text-align: center">
                拟组织绿色施工技术攻关和创新的项目及内容（限1000字内）
              </div>
              <div class="form_textarea">
                <textarea name id cols="30" rows="10" placeholder="请输入"
                  v-model="parameters3.Indicators.msg6"></textarea>
              </div>
            </div>
            <div class="my_form">
              <div class="form_title" style="height: 188px; text-align: center">
                工程进度情况
              </div>
              <div class="form_textarea">
                <textarea name id cols="30" rows="10" placeholder="请输入"
                  v-model="parameters3.Indicators.msg7"></textarea>
              </div>
            </div>
            <div class="my_form">
              <div class="form_title" style="height: 188px; text-align: center">
                预期经济效益、社会效益、生态效益
              </div>
              <div class="form_textarea">
                <textarea name id cols="30" rows="10" placeholder="请输入"
                  v-model="parameters3.Indicators.msg8"></textarea>
              </div>
            </div>
            <!-- <div class="my_form">
              <div class="form_title" style="height: 188px; text-align: center">
                绿色施工承建单位意见
              </div>
              <div class="form_textarea">
                <textarea
                  name
                  id
                  cols="30"
                  rows="10"
                  placeholder="请输入"
                  v-model="parameters3.Indicators.msg5"
                ></textarea>
              </div>
            </div>
            <div class="my_form">
              <div class="form_title" style="height: 188px; text-align: center">
                申报单位的主管部门推荐意见
              </div>
              <div class="form_textarea">
                <textarea
                  name
                  id
                  cols="30"
                  rows="10"
                  placeholder="请输入"
                  v-model="parameters3.Indicators.msg9"
                ></textarea>
              </div>
            </div> -->
          </div>
        </div>
        <div class="form_1" id="Upload">
          <Tips title="上传附件" :background="lefttitlelist[3].isok ? '#EDF8F5' : '#FEF8EF'"
            :border="lefttitlelist[3].isok ? '#1ABF98' : '#FFB700'" :states="lefttitlelist[3].isok"></Tips>
          <GreenProjcet @greenPorject="greenPorject" title1="绿色施工专项方案" title2="建筑与市政工程绿色施工评价申报表"
            :parameters3="parameters3.Upload" />
        </div>
      </div>
            <div v-if="$route.query.title == '工程建设质量管理小组竞赛活动'" id="exportPdf" ref="exportPdf">
        <GroupAward ref="groupAward" @changeBasicFull="val => lefttitlelist[0].isok = val"
          @changeUploadFull="val => lefttitlelist[1].isok = val" ></GroupAward>
      </div>
      
      <div class="form_right" v-if="$route.query.title == '贵州省优质工程评价'" id="exportPdf" ref="exportPdf">
        <div class="form_1" id="Contractorinfo">
          <!-- title提示标题文字,background提示盒子背景色,border提示盒子左边边框颜色 -->
          <Tips title="承建单位（申报单位）简况" :background="Contractorinfo.Tipsbackground" :border="Contractorinfo.Tipsborder"
            :states="Contractorinfo.Tipstates"></Tips>
          <div class="form_box_content">
            <div class="my_form2">
              <div class="form_title" style="height: 62px">工程名称</div>
              <div class="form_long">
                <input placeholder="请输入" type="text" v-model="parameters.Contractorinfo.projectNname" />
              </div>
            </div>
            <div class="my_form">
              <div class="form_title" style="height: 62px">推荐单位</div>
              <div class="form_long">
                <input placeholder="请输入" type="text" v-model="parameters.Contractorinfo.RecommendedUnit" />
              </div>
            </div>
            <div class="my_form2">
              <div class="form_title" style="height: 62px">申报单位</div>
              <div class="form_long">
                <input placeholder="请输入" type="text" v-model="parameters.Contractorinfo.ReportingUnit" />
              </div>
            </div>
            <div class="my_form2">
              <div class="form_title" style="height: 62px">申报单位注册地</div>
              <div class="form_long">
                <input placeholder="请输入" type="text" v-model="parameters.Contractorinfo.ReportingUnitAddress" />
              </div>
            </div>
            <div class="my_form">
              <div class="form_title" style="height: 62px">填报日期</div>
              <div class="form_content">
                <el-date-picker type="date" value-format="yyyy-MM-dd" format="yyyy-MM-dd" placeholder="选择日期"
                  v-model="parameters.Contractorinfo.Filling_date" class="inpyabeb"></el-date-picker>
              </div>
            </div>
            <div class="my_form2">
              <div class="form_title" style="height: 62px">承建单位名称</div>
              <div class="form_long">
                <input placeholder="请输入" type="text" v-model="parameters.Contractorinfo.Contractor_name1" />
              </div>
            </div>
            <div class="my_form">
              <div class="form_title" style="height: 62px">通信地址</div>
              <div class="form_long">
                <input placeholder="请输入" type="text" v-model="parameters.Contractorinfo.mailing_address1" />
              </div>
            </div>
            <div class="flex">
              <div class="my_form2">
                <div class="form_title" style="height: 62px">联系电话</div>
                <div class="form_content">
                  <div class="input">
                    <input type="text" placeholder="请输入" v-model="parameters.Contractorinfo.phone11" />
                  </div>
                </div>
              </div>
              <div class="my_form2">
                <div class="form_title" style="height: 62px">邮政编码</div>
                <div class="form_content">
                  <div class="input">
                    <input type="text" placeholder="请输入" v-model="parameters.Contractorinfo.Postal1" />
                  </div>
                </div>
              </div>
            </div>
            <div class="my_form">
              <div class="form_title" style="height: 188px; text-align: center">
                主营范围及其资质等级
              </div>
              <div class="form_textarea">
                <textarea name id cols="30" rows="10" placeholder="请输入"
                  v-model="parameters.Contractorinfo.Qualification_level1"></textarea>
              </div>
            </div>
            <div class="my_form2">
              <div class="form_title" style="height: 188px; text-align: center">
                承建内容
              </div>
              <div class="form_textarea">
                <textarea name id cols="30" rows="10" placeholder="请输入"
                  v-model="parameters.Contractorinfo.Construction_content1"></textarea>
              </div>
            </div>
            <div class="my_form">
              <div class="form_title" style="height: 188px; text-align: center">
                承建单位简介(500字以内)
              </div>
              <div class="form_textarea">
                <textarea name id cols="30" rows="10" placeholder="请输入" maxlength="500"
                  v-model="parameters.Contractorinfo.brief_introduction1" @change="changeText('brief_introduction1',500)"></textarea>
              </div>
            </div>
            <div class="form_title">
              <p style="padding: 20px 0">法定代表人信息</p>
            </div>
            <div class="flex">
              <div class="my_form">
                <div class="form_title" style="height: 62px">姓名</div>
                <div class="form_content">
                  <div class="input">
                    <input type="text" placeholder="请输入" v-model="parameters.Contractorinfo.name21" />
                  </div>
                </div>
              </div>
              <div class="my_form">
                <div class="form_title" style="height: 62px">联系电话</div>
                <div class="form_content">
                  <div class="input">
                    <input type="text" placeholder="请输入" v-model="parameters.Contractorinfo.phone21" />
                  </div>
                </div>
              </div>
            </div>
            <div class="form_title">
              <p style="padding: 20px 0">申报工作联系人</p>
            </div>
            <div class="flex">
              <div class="my_form2">
                <div class="form_title" style="height: 62px">姓名</div>
                <div class="form_content">
                  <div class="input">
                    <input type="text" placeholder="请输入" v-model="parameters.Contractorinfo.name31" />
                  </div>
                </div>
              </div>
              <div class="my_form2">
                <div class="form_title" style="height: 62px">工作部门</div>
                <div class="form_content">
                  <div class="input">
                    <input type="text" placeholder="请输入" v-model="parameters.Contractorinfo.work_department1" />
                  </div>
                </div>
              </div>
            </div>
            <div class="flex">
              <div class="my_form">
                <div class="form_title" style="height: 62px">职务</div>
                <div class="form_content">
                  <div class="input">
                    <input type="text" placeholder="请输入" v-model="parameters.Contractorinfo.postion1" />
                  </div>
                </div>
              </div>
              <div class="my_form">
                <div class="form_title" style="height: 62px">固定电话</div>
                <div class="form_content">
                  <div class="input">
                    <input type="text" placeholder="请输入" v-model="parameters.Contractorinfo.guding_phone1" />
                  </div>
                </div>
              </div>
            </div>
            <div class="flex">
              <div class="my_form2">
                <div class="form_title" style="height: 62px">移动电话</div>
                <div class="form_content">
                  <div class="input">
                    <input type="text" placeholder="请输入" v-model="parameters.Contractorinfo.movephone11" />
                  </div>
                  <div class="input-tip">用于接收审核结果</div>
                </div>
              </div>
            </div>
            <div class="form_title">
              <p style="padding: 20px 0">项目经理</p>
            </div>
            <div class="flex">
              <div class="my_form">
                <div class="form_title" style="height: 62px">姓名</div>
                <div class="form_content">
                  <div class="input">
                    <input type="text" placeholder="请输入" v-model="parameters.Contractorinfo.name41" />
                  </div>
                </div>
              </div>
              <div class="my_form">
                <div class="form_title" style="height: 62px">持证等级</div>
                <div class="form_content">
                  <div class="input">
                    <input type="text" placeholder="请输入" v-model="parameters.Contractorinfo.leave1" />
                  </div>
                </div>
              </div>
            </div>
            <div class="flex">
              <div class="my_form2">
                <div class="form_title" style="height: 62px">联系电话</div>
                <div class="form_content">
                  <div class="input">
                    <input type="text" placeholder="请输入" v-model="parameters.Contractorinfo.phone31" />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="form_1" v-for="(item, index) in parameters.unitinfo" :key="index" :id="'index' + index">
          <!-- title提示标题文字,background提示盒子背景色,border提示盒子左边边框颜色 -->
          <Tips :title="`参建单位信息${index == 0 ? '' : index}`" :delete_form="true" @deleteform="deleteform"
            :background="Informationparticipatingunits.Tipsbackground"
            :border="Informationparticipatingunits.Tipsborder" :states="Informationparticipatingunits.Tipstates"></Tips>
          <div class="form_box_content">
            <div class="flex">
              <div class="my_form">
                <div class="form_title" style="height: 62px">单位名称</div>
                <div class="form_content">
                  <div class="input">
                    <input type="text" placeholder="请输入" v-model="parameters.unitinfo[index].unitname" />
                  </div>
                </div>
              </div>
              <div class="my_form">
                <div class="form_title" style="height: 62px">通信地址</div>
                <div class="form_content">
                  <div class="input">
                    <input type="text" placeholder="请输入" v-model="parameters.unitinfo[index].phoneaddress" />
                  </div>
                </div>
              </div>
            </div>
            <div class="flex">
              <div class="my_form2">
                <div class="form_title" style="height: 62px">邮政编码</div>
                <div class="form_content">
                  <div class="input">
                    <input type="text" placeholder="请输入" v-model="parameters.unitinfo[index].codeyouzheng" />
                  </div>
                </div>
              </div>
              <div class="my_form2">
                <div class="form_title" style="height: 62px">联系电话</div>
                <div class="form_content">
                  <div class="input">
                    <input type="text" placeholder="请输入" v-model="parameters.unitinfo[index].Telephone" />
                  </div>
                </div>
              </div>
            </div>
            <div class="my_form">
              <div class="form_title" style="height: 188px; text-align: center">
                主营范围及其资质等级
              </div>
              <div class="form_textarea">
                <textarea name id cols="30" rows="10" placeholder="请输入"
                  v-model="parameters.unitinfo[index].Qualification_level"></textarea>
              </div>
            </div>
            <div class="my_form2">
              <div class="form_title" style="height: 188px; text-align: center">
                参建内容
              </div>
              <div class="form_textarea">
                <textarea name id cols="30" rows="10" placeholder="请输入"
                  v-model="parameters.unitinfo[index].Construction_content"></textarea>
              </div>
            </div>
            <div class="my_form">
              <div class="form_title" style="height: 188px; text-align: center">
                参建工作量
              </div>
              <div class="form_textarea">
                <textarea name id cols="30" rows="10" placeholder="请输入"
                  v-model="parameters.unitinfo[index].Construction_workload"></textarea>
              </div>
            </div>
            <div class="my_form2">
              <div class="form_title" style="height: 62px">参建比例</div>
              <div class="form_content">
                <div class="input">
                  <input type="text" placeholder="请输入" v-model="parameters.unitinfo[index].Construction_proportion" />
                </div>
              </div>
            </div>
            <div class="my_form">
              <div class="form_title" style="height: 188px; text-align: center">
                参建单位简介(200字以内)
              </div>
              <div class="form_textarea">
                <textarea name id cols="30" rows="10" placeholder="请输入" maxlength="400"
                  v-model="parameters.unitinfo[index].brief_introduction"  @change="changeText('brief_introduction',200,index)"></textarea>
              </div>
            </div>
            <div class="form_title">
              <p style="padding: 20px 0">法定代表人信息</p>
            </div>
            <div class="flex">
              <div class="my_form2">
                <div class="form_title" style="height: 62px">姓名</div>
                <div class="form_content">
                  <div class="input">
                    <input type="text" placeholder="请输入" v-model="parameters.unitinfo[index].name2" />
                  </div>
                </div>
              </div>
              <div class="my_form2">
                <div class="form_title" style="height: 62px">联系电话</div>
                <div class="form_content">
                  <div class="input">
                    <input type="text" placeholder="请输入" v-model="parameters.unitinfo[index].phone2" />
                  </div>
                </div>
              </div>
            </div>
            <div class="form_title">
              <p style="padding: 20px 0">申报工作联系人</p>
            </div>
            <div class="flex">
              <div class="my_form">
                <div class="form_title" style="height: 62px">姓名</div>
                <div class="form_content">
                  <div class="input">
                    <input type="text" placeholder="请输入" v-model="parameters.unitinfo[index].name3" />
                  </div>
                </div>
              </div>
              <div class="my_form">
                <div class="form_title" style="height: 62px">工作部门</div>
                <div class="form_content">
                  <div class="input">
                    <input type="text" placeholder="请输入" v-model="parameters.unitinfo[index].work_department" />
                  </div>
                </div>
              </div>
            </div>
            <div class="flex">
              <div class="my_form2">
                <div class="form_title" style="height: 62px">职务</div>
                <div class="form_content">
                  <div class="input">
                    <input type="text" placeholder="请输入" v-model="parameters.unitinfo[index].postion" />
                  </div>
                </div>
              </div>
              <div class="my_form2">
                <div class="form_title" style="height: 62px">固定电话</div>
                <div class="form_content">
                  <div class="input">
                    <input type="text" placeholder="请输入" v-model="parameters.unitinfo[index].guding_phone" />
                  </div>
                </div>
              </div>
            </div>
            <div class="flex">
              <div class="my_form2">
                <div class="form_title" style="height: 62px">移动电话</div>
                <div class="form_content">
                  <div class="input">
                    <input type="text" placeholder="请输入" v-model="parameters.unitinfo[index].movephone1" />
                  </div>
                </div>
              </div>
            </div>
            <div class="form_title">
              <p style="padding: 20px 0">项目经理</p>
            </div>
            <div class="flex">
              <div class="my_form">
                <div class="form_title" style="height: 62px">姓名</div>
                <div class="form_content">
                  <div class="input">
                    <input type="text" placeholder="请输入" v-model="parameters.unitinfo[index].name4" />
                  </div>
                </div>
              </div>
              <div class="my_form">
                <div class="form_title" style="height: 62px">持证等级</div>
                <div class="form_content">
                  <div class="input">
                    <input type="text" placeholder="请输入" v-model="parameters.unitinfo[index].leave" />
                  </div>
                </div>
              </div>
            </div>
            <div class="flex">
              <div class="my_form2">
                <div class="form_title" style="height: 62px">联系电话</div>
                <div class="form_content">
                  <div class="input">
                    <input type="text" placeholder="请输入" v-model="parameters.unitinfo[index].phone3" />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- <div class="form_1" >
          <Tips
            title="参建单位信息1"
            background="#FEF8EF"
            border="#FFB700"
            :states="false"
            :delete_form="true"
            @deleteform="deleteform"
          ></Tips>
          <div class="form_box_content">
            <MyForm class="my_form2" title="承建单位名称" :long="true" v-model="parameters.Contractor_name"></MyForm>
            <MyForm class="my_form" title="通信地址" :long="true" v-model="parameters.mailing_address"></MyForm>
            <MyForm class="my_form2" title="联系电话" title2="邮政编码" :text="true" :small="true" v-model="parameters.Postal_phone"></MyForm>
            <MyForm class="my_form" title="主营范围及其资质等级" :left_height="188" :textarea="true" v-model="parameters.Qualification_level"></MyForm>
            <MyForm class="my_form2" title="承建内容" :left_height="188" :textarea="true" v-model="parameters.Construction_content"></MyForm>
            <MyForm class="my_form" title="承建单位简介(500字以内)" :left_height="188" :textarea="true" v-model="parameters.brief_introduction"></MyForm>
            <div class="form_title">
              <p>法定代表人信息</p>
            </div>
            <MyForm class="my_form2" title="姓名" title2="联系电话" :text="true" :small="true" v-model="parameters.phone_name1"></MyForm>
            <div class="form_title">
              <p>申报工作联系人</p>
            </div>
            <MyForm class="my_form" title="姓名" title2="工作部门" :text="true" :small="true" v-model="parameters.work_name"></MyForm>
            <MyForm class="my_form2" title="职务" title2="固定电话" :text="true" :small="true" v-model="parameters.phone_postion"></MyForm>
            <MyForm class="my_form" title="移动电话" :title2="false" :text="true" :small="true" v-model="parameters.movephone1"></MyForm>
            <div class="form_title">
              <p>项目经理</p>
            </div>
            <MyForm class="my_form2" title="姓名" title2="持证等级" :text="true" :small="true" v-model="parameters.name_leave"></MyForm>
            <MyForm class="my_form" title="联系电话" :title2="false" :text="true" :small="true" v-model="parameters.movephone2"></MyForm>
          </div>
        </div>-->
        <div class="form_1">
          <div class="newlybuild" @click="addnew">
            <img src="../assets/6622@2x.png" alt />
            <p>新增参建单位信息表</p>
          </div>
        </div>
        <div class="form_1" id="ProjectOverview">
          <Tips title="申报工程概况" :background="ProjectOverview.Tipsbackground" :border="ProjectOverview.Tipsborder"
            :states="ProjectOverview.Tipstates"></Tips>
          <div class="form_box_content">
            <div class="my_form2">
              <div class="form_title" style="height: 62px">工程名称</div>
              <div class="form_long">
                <input type="text" placeholder="请输入" v-model="parameters.Contractorinfo.nprojectNname" />
              </div>
            </div>

            <div class="my_form">
              <div class="form_title" style="height: 62px">建设地点</div>
              <div class="form_long">
                <input type="text" placeholder="请输入" v-model="parameters.ProjectOverview.Construction_site" />
              </div>
            </div>
            <div class="flex">
              <div class="my_form2">
                <div class="form_title" style="height: 62px">工程类别</div>
                <div class="form_content">
                  <el-select v-model="parameters.ProjectOverview.workscategory" placeholder="请选择企业性质" class="inpyabeb"
                    size="small">
                    <el-option label="住宅工程" value="住宅工程"></el-option>
                    <el-option label="公共建筑工程" value="公共建筑工程"></el-option>
                    <el-option label="工业交通水利工程" value="工业交通水利工程"></el-option>
                    <el-option label="市政园林工程" value="市政园林工程"></el-option>
                  </el-select>
                </div>
              </div>
              <div class="my_form2">
                <div class="form_title" style="height: 62px">使用功能</div>
                <div class="form_content">
                  <div class="input">
                    <input type="text" placeholder="请输入" v-model="parameters.ProjectOverview.functi" />
                  </div>
                </div>
              </div>
            </div>
            <div class="flex">
              <div class="my_form">
                <div class="form_title" style="height: 62px">建设规模</div>
                <div class="form_content">
                  <div class="input">
                    <input type="text" placeholder="请输入" v-model="parameters.ProjectOverview.build" />
                  </div>
                </div>
              </div>
              <div class="my_form">
                <div class="form_title" style="height: 62px">结构类型</div>
                <div class="form_content">
                  <div class="input">
                    <input type="text" placeholder="请输入" v-model="parameters.ProjectOverview.structure" />
                  </div>
                </div>
              </div>
            </div>
            <div class="flex">
              <div class="my_form2">
                <div class="form_title" style="height: 62px">申报范围</div>
                <div class="form_content">
                  <div class="input">
                    <input type="text" placeholder="请输入" v-model="parameters.ProjectOverview.declare" />
                  </div>
                </div>
              </div>
              <div class="my_form2">
                <div class="form_title" style="height: 62px">工程合同额</div>
                <div class="form_content">
                  <div class="input">
                    <input type="text" placeholder="请输入" v-model="parameters.ProjectOverview.engineering" />
                  </div>
                </div>
              </div>
            </div>
            <div class="flex">
              <div class="my_form">
                <div class="form_title" style="height: 62px">开工时间</div>
                <div class="form_content">
                  <el-date-picker type="date" value-format="yyyy-MM-dd" format="yyyy-MM-dd" placeholder="选择日期"
                    v-model="parameters.ProjectOverview.worktime" class="inpyabeb"></el-date-picker>
                </div>
              </div>
             <div class="my_form">
                <div class="form_title" style="height: 62px">验收时间</div>
                <div class="form_content">
                  <el-date-picker type="date" value-format="yyyy-MM-dd" format="yyyy-MM-dd" placeholder="选择日期"
                    v-model="parameters.ProjectOverview.acceptance" class="inpyabeb"></el-date-picker>
                </div>
              </div>
            </div>
            <!-- <div class="flex">
              <div class="my_form2">
                <div class="form_title" style="height: 62px">验收时间</div>
                <div class="form_content">
                  <el-date-picker type="date" value-format="yyyy-MM-dd" format="yyyy-MM-dd" placeholder="选择日期"
                    v-model="parameters.ProjectOverview.acceptance" class="inpyabeb"></el-date-picker>
                </div>
              </div>
            </div> -->
            <div class="my_form">
              <div class="form_title" style="height: 62px">验收单位</div>
              <div class="form_long">
                <input placeholder="请输入" type="text" v-model="parameters.ProjectOverview.acceptance_unit" />
              </div>
            </div>
            <div class="my_form2">
              <div class="form_title" style="height: 62px">勘察单位</div>
              <div class="form_long">
                <input placeholder="请输入" type="text" v-model="parameters.ProjectOverview.survey_unit" />
              </div>
            </div>
            <div class="my_form">
              <div class="form_title" style="height: 62px">建设单位</div>
              <div class="form_long">
                <input placeholder="请输入" type="text" v-model="parameters.ProjectOverview.Construction_unit" />
              </div>
            </div>
            <div class="my_form2">
              <div class="form_title" style="height: 62px">使用单位</div>
              <div class="form_long">
                <input placeholder="请输入" type="text" v-model="parameters.ProjectOverview.User_unit" />
              </div>
            </div>
            <div class="my_form">
              <div class="form_title" style="height: 62px">设计单位</div>
              <div class="form_long">
                <input placeholder="请输入" type="text" v-model="parameters.ProjectOverview.Design_unit" />
              </div>
            </div>
            <div class="my_form2">
              <div class="form_title" style="height: 62px">监理单位</div>
              <div class="form_long">
                <input placeholder="请输入" type="text" v-model="parameters.ProjectOverview.control_unit" />
              </div>
            </div>
            <div class="my_form2">
              <div class="form_title" style="height: 62px">质量监督单位</div>
              <div class="form_long">
                <input placeholder="请输入" type="text" v-model="parameters.ProjectOverview.pro_control_unit" />
              </div>
            </div>
            <div class="my_form">
              <div class="form_title" style="height: 188px; text-align: center">
                工程简介（800字以内）
              </div>
              <div class="form_textarea">
                <textarea name id cols="30" rows="10" placeholder="请输入" maxlength="800"
                  v-model="parameters.ProjectOverview.project_info"  @change="changeText('project_info',800)"></textarea>
              </div>
            </div>
          </div>
        </div>
        <div class="form_1" id="Explain_the_reason">
          <Tips title="申报理由" :background="
            parameters.Explain_the_reason != '' ? '#EDF8F5' : '#FEF8EF'
          " :border="
  parameters.Explain_the_reason != '' ? '#1ABF98' : '#FFB700'
" :states="parameters.Explain_the_reason == '' ? false : true"></Tips>
          <div class="form_box_content">
            <div class="my_form">
              <div class="form_title" style="height: 188px; text-align: center">
                参照申报条件阐述理由
              </div>
              <div class="form_textarea">
                <textarea name id cols="30" rows="10" placeholder="请输入"
                  v-model="parameters.Explain_the_reason"></textarea>
              </div>
            </div>
          </div>
        </div>
        <div class="form_1" id="Explain_the_opinion">
          <Tips title="有关单位意见"></Tips>
          <div class="form_box_content" style="text-align: left;color:red;">
            有关单位意见请线下填写
          </div>
        </div>
        <div class="form_1" id="SupplementaryContent">
          <Tips title="申报登记表需补充内容" :background="SupplementaryContent.Tipsbackground"
            :border="SupplementaryContent.Tipsborder" :states="SupplementaryContent.Tipstates"></Tips>
          <div class="form_box_content">
            <div class="my_form2">
              <div class="form_title" style="height: 62px">申报联系人邮箱</div>
              <div class="form_long">
                <input type="text" placeholder="请输入" v-model="parameters.SupplementaryContent.Contactemail" />
              </div>
            </div>
            <div class="flex">
              <div class="my_form2">
                <div class="form_title" style="height: 62px">
                  推荐单位联系人
                </div>
                <div class="form_content">
                  <div class="input">
                    <input type="text" placeholder="请输入" v-model="parameters.SupplementaryContent.Unitcontact" />
                  </div>
                </div>
              </div>
              <div class="my_form2">
                <div class="form_title" style="height: 62px">联系电话</div>
                <div class="form_content">
                  <div class="input">
                    <input type="text" placeholder="请输入" v-model="parameters.SupplementaryContent.contactnumber" />
                  </div>
                </div>
              </div>
            </div>
            <!-- <MyForm class="my_form" title="工程立项复批" :certificatePdf="true" :left_height="100" @filechange="filechange"
              @isuploadshow="(value) => isuploadshow('1', value)"
              :filechangelist="parameters.SupplementaryContent.is1arr"
              :isuploadisshow="parameters.SupplementaryContent.is1"></MyForm>
            <MyForm class="my_form2" title="土地使用证" :certificatePdf="true" :left_height="100" @filechange="filechange"
              @isuploadshow="(value) => isuploadshow('2', value)"
              :filechangelist="parameters.SupplementaryContent.is2arr"
              :isuploadisshow="parameters.SupplementaryContent.is2"></MyForm>
            <MyForm class="my_form" title="建设工程规划许可证" :certificatePdf="true" :left_height="100" @filechange="filechange"
              @isuploadshow="(value) => isuploadshow('3', value)"
              :filechangelist="parameters.SupplementaryContent.is3arr"
              :isuploadisshow="parameters.SupplementaryContent.is3"></MyForm>
            <MyForm class="my_form2" title="工程创优策划书" :certificatePdf="true" :left_height="100" @filechange="filechange"
              @isuploadshow="(value) => isuploadshow('4', value)"
              :filechangelist="parameters.SupplementaryContent.is4arr"
              :isuploadisshow="parameters.SupplementaryContent.is4"></MyForm>
            <MyForm class="my_form" title="工程施工图设计文件审查合格书或审批文件(电力工程按行业规定)" :certificatePdf="true" :left_height="100"
              @filechange="filechange" @isuploadshow="(value) => isuploadshow('5', value)"
              :filechangelist="parameters.SupplementaryContent.is5arr"
              :isuploadisshow="parameters.SupplementaryContent.is5"></MyForm>
            <MyForm class="my_form2" title="工程施工合同" :certificatePdf="true" :left_height="100" @filechange="filechange"
              @isuploadshow="(value) => isuploadshow('6', value)"
              :filechangelist="parameters.SupplementaryContent.is6arr"
              :isuploadisshow="parameters.SupplementaryContent.is6"></MyForm>
            <MyForm class="my_form" title="施工许可证或批准开工报告" :certificatePdf="true" :left_height="100"
              @filechange="filechange" @isuploadshow="(value) => isuploadshow('7', value)"
              :filechangelist="parameters.SupplementaryContent.is7arr"
              :isuploadisshow="parameters.SupplementaryContent.is7"></MyForm>
            <MyForm class="my_form2" title="建设工程消防验收意见书(涉及消防工程)" :certificatePdf="true" :left_height="100"
              @filechange="filechange" @isuploadshow="(value) => isuploadshow('8', value)"
              :filechangelist="parameters.SupplementaryContent.is8arr"
              :isuploadisshow="parameters.SupplementaryContent.is8"></MyForm>
            <MyForm class="my_form" title="工程“竣工验收报告”(交通工程提交“交工验收证书”,电力工程提交“投运备案证明书”,水利工程提交“工程合同完工验收文件”)"
              :certificatePdf="true" :left_height="100" @filechange="filechange"
              @isuploadshow="(value) => isuploadshow('9', value)"
              :filechangelist="parameters.SupplementaryContent.is9arr"
              :isuploadisshow="parameters.SupplementaryContent.is9"></MyForm>
            <MyForm class="my_form2" title="“投入使用时间和使用效果证明”(建设单位出具)" :certificatePdf="true" :left_height="100"
              @filechange="filechange" @isuploadshow="(value) => isuploadshow('10', value)"
              :filechangelist="parameters.SupplementaryContent.is10arr"
              :isuploadisshow="parameters.SupplementaryContent.is10"></MyForm>
            <MyForm class="my_form" title="“建筑业10项新技术应用证明”(监理单位出具)" :certificatePdf="true" :left_height="100"
              @filechange="filechange" @isuploadshow="(value) => isuploadshow('11', value)"
              :filechangelist="parameters.SupplementaryContent.is11arr"
              :isuploadisshow="parameters.SupplementaryContent.is11"></MyForm>
            <MyForm class="my_form2" title="工业交通水利工程其“技术指标、经济效益及社会效益应达到本专业工程省内领先水平证明”(建设单位出具)" :certificatePdf="true"
              :left_height="100" @filechange="filechange" @isuploadshow="(value) => isuploadshow('12', value)"
              :filechangelist="parameters.SupplementaryContent.is12arr"
              :isuploadisshow="parameters.SupplementaryContent.is12"></MyForm>
            <MyForm class="my_form" title="建筑业新技术应用示范工程或绿色施工示范工程证书" :certificatePdf="true" :left_height="100"
              @filechange="filechange" @isuploadshow="(value) => isuploadshow('13', value)"
              :filechangelist="parameters.SupplementaryContent.is13arr"
              :isuploadisshow="parameters.SupplementaryContent.is13"></MyForm>
            <MyForm class="my_form2" title="“贵州省建筑工程优质质量结构工程”评定文件(住宅工程、公共建筑工程、市政桥梁)" :certificatePdf="true"
              :left_height="100" @filechange="filechange" @isuploadshow="(value) => isuploadshow('14', value)"
              :filechangelist="parameters.SupplementaryContent.is14arr"
              :isuploadisshow="parameters.SupplementaryContent.is14"></MyForm>
            <MyForm class="my_form" title="“贵州省建筑安全文明施工样板工地”评定文件(住宅工程、公共建筑工程、市政园林工程)" :certificatePdf="true"
              :left_height="100" @filechange="filechange" @isuploadshow="(value) => isuploadshow('15', value)"
              :filechangelist="parameters.SupplementaryContent.is15arr"
              :isuploadisshow="parameters.SupplementaryContent.is15"></MyForm>
            <MyForm class="my_form2" title="无质量安全事故承诺" :certificatePdf="true" :left_height="100"
              @filechange="filechange" @isuploadshow="(value) => isuploadshow('16', value)"
              :filechangelist="parameters.SupplementaryContent.is16arr"
              :isuploadisshow="parameters.SupplementaryContent.is16"></MyForm> -->
            <!--              <MyForm-->
            <!--                  class="my_form2"-->
            <!--                  title="无质量安全事故承诺补充材料"-->
            <!--                  :certificatePdf="true"-->
            <!--                  :left_height="100"-->
            <!--                  @filechange="filechange"-->
            <!--                  @isuploadshow="(value) => isuploadshow('17', value)"-->
            <!--                  :filechangelist="parameters.SupplementaryContent.is17arr"-->
            <!--                  :isuploadisshow="parameters.SupplementaryContent.is17"-->
            <!--              ></MyForm>-->
            <!-- <MyForm class="my_form2" title="无拖欠农民工工资承诺" :certificatePdf="true" :left_height="100"
              @filechange="filechange" @isuploadshow="(value) => isuploadshow('18', value)"
              :filechangelist="parameters.SupplementaryContent.is18arr"
              :isuploadisshow="parameters.SupplementaryContent.is18"></MyForm> -->
            <!--              <MyForm-->
            <!--                  class="my_form"-->
            <!--                  title="无拖欠农民工工资承诺补充材料"-->
            <!--                  :certificatePdf="true"-->
            <!--                  :left_height="100"-->
            <!--                  @filechange="filechange"-->
            <!--                  @isuploadshow="(value) => isuploadshow('19', value)"-->
            <!--                  :filechangelist="parameters.SupplementaryContent.is19arr"-->
            <!--                  :isuploadisshow="parameters.SupplementaryContent.is19"-->
            <!--              ></MyForm>-->
            <!--  -->
            <!-- 备注
            <div class="my_form">
              <div class="form_title" style="height: 188px; text-align: center">
                备注
          </div>
              <div class="form_textarea">
                <textarea
                  name
                  id
                  cols="30"
                  rows="10"
                  placeholder="请输入"
                  v-model="parameters.remarks"
                ></textarea>
              </div>
            </div> -->

            <MyForm class="my_form" title="“施工许可证”或“施工许可文件”" :certificatePdf="true" :left_height="100"
              @filechange="filechange" @fileSplice="fileSplice" @isuploadshow="(value) => isuploadshow('23', value)"
              :filechangelist="parameters.SupplementaryContent.is23arr"
              :isuploadisshow="parameters.SupplementaryContent.is23"></MyForm>
            <MyForm class="my_form2" title="工程“创优”策划书" :certificatePdf="true" :left_height="100"
              @filechange="filechange" @fileSplice="fileSplice" @isuploadshow="(value) => isuploadshow('24', value)"
              :filechangelist="parameters.SupplementaryContent.is24arr"
              :isuploadisshow="parameters.SupplementaryContent.is24"></MyForm>
            <MyForm class="my_form" title="<div style='text-align:left'>1.建筑市政工程提交“竣工验收报告”；<br/>2.工业、交通工程提交“交工验收证书”或“静态验收报告（铁路工程）”；<br/>3.电力工程提交“竣工验收报告”；<br/>4.水利工程提交“工程合同完工验收文件”；</div>" :certificatePdf="true"  :left_height="100"
              @filechange="filechange" @fileSplice="fileSplice" @isuploadshow="(value) => isuploadshow('25', value)"
              :filechangelist="parameters.SupplementaryContent.is25arr"
              :isuploadisshow="parameters.SupplementaryContent.is25"></MyForm>
            <MyForm class="my_form2" title="建设工程“消防验收意见书”（涉及消防工程）" :certificatePdf="true" :left_height="100"
                  @filechange="filechange" @fileSplice="fileSplice" @isuploadshow="(value) => isuploadshow('26', value)"
                  :filechangelist="parameters.SupplementaryContent.is26arr"
                  :isuploadisshow="parameters.SupplementaryContent.is26"></MyForm>
            <MyForm class="my_form" title="“投入使用时间和使用效果证明”（建设单位出具）" :certificatePdf="true" :left_height="100"
                  @filechange="filechange" @fileSplice="fileSplice" @isuploadshow="(value) => isuploadshow('27', value)"
                  :filechangelist="parameters.SupplementaryContent.is27arr"
                  :isuploadisshow="parameters.SupplementaryContent.is27"></MyForm>
            <MyForm class="my_form2" title="“建筑业10项新技术应用证明”（监理单位出具）" :certificatePdf="true" :left_height="100"
                  @filechange="filechange" @fileSplice="fileSplice" @isuploadshow="(value) => isuploadshow('28', value)"
                  :filechangelist="parameters.SupplementaryContent.is28arr"
                  :isuploadisshow="parameters.SupplementaryContent.is28"></MyForm>
            <MyForm class="my_form" title="工业交通水利工程其“技术指标、经济效益及社会效益应达到本专业工程省内领先水平”证明（监理单位出具）" :certificatePdf="true"  :left_height="100"
                  @filechange="filechange" @fileSplice="fileSplice" @isuploadshow="(value) => isuploadshow('29', value)"
                  :filechangelist="parameters.SupplementaryContent.is29arr"
                  :isuploadisshow="parameters.SupplementaryContent.is29"></MyForm>
            <MyForm class="my_form2" title="住宅工程需提供入住率达到50％的证明（建设单位出具）" :certificatePdf="true" :left_height="100"
                  @filechange="filechange" @fileSplice="fileSplice" @isuploadshow="(value) => isuploadshow('30', value)"
                  :filechangelist="parameters.SupplementaryContent.is30arr"
                  :isuploadisshow="parameters.SupplementaryContent.is30"></MyForm>
            <MyForm class="my_form" title="工程在施工过程中开展绿色施工并经评价合格" :certificatePdf="true" :left_height="100"
                  @filechange="filechange" @fileSplice="fileSplice" @isuploadshow="(value) => isuploadshow('31', value)"
                  :filechangelist="parameters.SupplementaryContent.is31arr"
                  :isuploadisshow="parameters.SupplementaryContent.is31"></MyForm>
            <MyForm class="my_form2" title="建筑工程提供省（部）级结构优或满足《建筑工程施工质量评价标准》GB／T50375优良评价报告（监理单位或有资质的检测单位出具）" :certificatePdf="true" :left_height="100"
                  @filechange="filechange" @fileSplice="fileSplice" @isuploadshow="(value) => isuploadshow('32', value)"
                  :filechangelist="parameters.SupplementaryContent.is32arr"
                  :isuploadisshow="parameters.SupplementaryContent.is32"></MyForm>
            <MyForm class="my_form" title="无质量安全事故和无拖欠农民工工资承诺。（申报单位和参建单位都应提供）" :certificatePdf="true" :left_height="100"
                       @filechange="filechange" @fileSplice="fileSplice" @isuploadshow="(value) => isuploadshow('33', value)"
                       :filechangelist="parameters.SupplementaryContent.is33arr"
                       :isuploadisshow="parameters.SupplementaryContent.is33"></MyForm>
             <!--<MyForm class="my_form" title="贵州省优质工程申报汇总表（PDF盖章版）" :certificatePdf="true" :left_height="100"-->
             <!--          @filechange="filechange" @fileSplice="fileSplice" @isuploadshow="(value) => isuploadshow('37', value)"-->
             <!--          :filechangelist="parameters.SupplementaryContent.is37arr"-->
             <!--          :isuploadisshow="parameters.SupplementaryContent.is37"></MyForm>-->
               <MyForm class="my_form2" title="贵州省优质工程申报汇总表（XLSX格式）" demopath="/user/附件2：2025年度贵州省优质工程申报汇总表.xlsx" :certificateExcel="true"  :left_height="100"
                     @filechange="filechange" @isuploadshow="(value) => isuploadshow('34', value)"
                     :filechangelist="parameters.SupplementaryContent.is34arr"
                     :isuploadisshow="parameters.SupplementaryContent.is34"></MyForm>
              <MyForm class="my_form" title="贵州省优质工程申报汇总表（PDF盖章版）" :certificatePdf="true"  :left_height="100"
                          @filechange="filechange" @isuploadshow="(value) => isuploadshow('35', value)"
                          :filechangelist="parameters.SupplementaryContent.is35arr"
                          :isuploadisshow="parameters.SupplementaryContent.is35"></MyForm>        
                
           <MyForm class="my_form" title="反映工程概况和质量状况的彩色照片15张" :certificatefour="true" :limit_num="15" :left_height="100"
             @filechange="filechange" @fileSplice="fileSplice" @isuploadshow="(value) => isuploadshow('20', value)"
             :filechangelist="parameters.SupplementaryContent.is20arr"
             :isuploadisshow="parameters.SupplementaryContent.is20"></MyForm>
           <MyForm class="my_form2" title="5分钟影像或PPT资料" :certificatethree="true" :left_height="100"
             @filechange="filechange" @isuploadshow="(value) => isuploadshow('21', value)"
             :filechangelist="parameters.SupplementaryContent.is21arr"
             :isuploadisshow="parameters.SupplementaryContent.is21"></MyForm>
            <MyForm class="my_form2" title="无质量安全事故承诺书" :certificatePdf="true" :left_height="100"
             @filechange="filechange" @isuploadshow="(value) => isuploadshow('36', value)"
             :filechangelist="parameters.SupplementaryContent.is36arr"
             :isuploadisshow="parameters.SupplementaryContent.is36"></MyForm>

           <MyForm class="my_form2" title="贵州省优质工程申报表（盖章后扫描件）"  demopath="/user/附件1：贵州省优质工程申报表.docx" :certificatePdf="true" :left_height="100"
             @filechange="filechange" @isuploadshow="(value) => isuploadshow('22', value)"
             :filechangelist="parameters.SupplementaryContent.is22arr"
             :isuploadisshow="parameters.SupplementaryContent.is22"></MyForm>
          </div>
        </div>
        <div class="form_1" id="DeclarationSummary">
          <Tips title="申报汇总表需补充内容" :background="DeclarationSummary.Tipsbackground"
            :border="DeclarationSummary.Tipsborder" :states="DeclarationSummary.Tipstates"></Tips>
          <div class="form_box_content">
            <div class="flex">
              <div class="my_form2">
                <div class="form_title" style="height: 62px">
                  承建单位工程技术负责人
                </div>
                <div class="form_content">
                  <div class="input">
                    <input type="text" placeholder="请输入" v-model="parameters.DeclarationSummary.Technicaldirector" />
                  </div>
                </div>
              </div>
              <div class="my_form2">
                <div class="form_title" style="height: 62px">
                  参建单位工程技术负责人
                </div>
                <div class="form_content">
                  <div class="input">
                    <input type="text" placeholder="请输入" v-model="parameters.DeclarationSummary.engineering" />
                  </div>
                </div>
              </div>
            </div>
            <div class="flex">
              <div class="my_form">
                <div class="form_title" style="height: 62px">
                  建设单位主要负责人
                </div>
                <div class="form_content">
                  <div class="input">
                    <input type="text" placeholder="请输入" v-model="parameters.DeclarationSummary.Construction_unit" />
                  </div>
                </div>
              </div>
              <div class="my_form">
                <div class="form_title" style="height: 62px">
                  设计单位主要负责人
                </div>
                <div class="form_content">
                  <div class="input">
                    <input type="text" placeholder="请输入" v-model="parameters.DeclarationSummary.Design_unit" />
                  </div>
                </div>
              </div>
            </div>
            <div class="flex">
              <div class="my_form2">
                <div class="form_title" style="height: 62px">质量监督单位</div>
                <div class="form_content">
                  <div class="input">
                    <input type="text" placeholder="请输入" v-model="parameters.DeclarationSummary.supervisionunit" />
                  </div>
                </div>
              </div>
              <div class="my_form2">
                <div class="form_title" style="height: 62px">
                  质量监督单位主要负责人
                </div>
                <div class="form_content">
                  <div class="input">
                    <input type="text" placeholder="请输入" v-model="parameters.DeclarationSummary.Principaloftheunit" />
                  </div>
                </div>
              </div>
            </div>
            <div class="flex">
              <div class="my_form">
                <div class="form_title" style="height: 62px">
                  监理单位总监工程师
                </div>
                <div class="form_content">
                  <div class="input">
                    <input type="text" placeholder="请输入" v-model="parameters.DeclarationSummary.Chiefengineer" />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!--        <div class="form_1" id="Recommendationform">-->
        <!--          <Tips-->
        <!--            title="推荐表"-->
        <!--            :background="Recommendationform? '#EDF8F5' : '#FEF8EF'"-->
        <!--            :border="Recommendationform? '#1ABF98' : '#FFB700'"-->
        <!--            :states="Recommendationform"-->
        <!--          ></Tips>-->
        <!--          <div class="form_box_content">-->
        <!--            <MyForm-->
        <!--              class="my_form2"-->
        <!--              :left_height="100"-->
        <!--              title="优质工程推荐表(按类型选择表格下载填写后上传)"-->
        <!--              :isDowninpu="true"-->
        <!--              @onChange2="onChange2"-->
        <!--              :wordfile="parameters.Recommendationform"-->
        <!--            ></MyForm>-->
        <!--          </div>-->
        <!--        </div>-->
        <!-- <div class="form_1">
          <Tips
            title="有关单位意见"
            background="#FEF8EF"
            border="#FFB700"
            :states="false"
          ></Tips>
          <div class="form_box_content">
            <div class="form_title">
              <p>建设单位意见</p>
            </div>
            <div class="my_form">
              <div class="form_title" style="height: 188px; text-align: center">
                意见综述
              </div>
              <div class="form_textarea">
                <textarea
                  name
                  id
                  cols="30"
                  rows="10"
                  placeholder="请输入"
                  v-model="parameters.Opinion_summary"
                ></textarea>
              </div>
            </div>
            <div class="flex">
              <MyForm
                class="my_form"
                title="总体满意程度评价"
                :choice="true"
                :choice_list="['非常满意', '满意', '比较满意']"
                v-model="parameters.isOpinion_summary"
              ></MyForm>
              <MyForm
                class="my_form"
                title="建设单位主要负责人"
                :text="true"
                :small="true"
                v-model="parameters.ResponsiblePerson"
              ></MyForm>
            </div>
            <div class="form_title">
              <p>使用单位意见</p>
            </div>
            <MyForm
              class="my_form2"
              title="意见综述"
              :left_height="188"
              :textarea="true"
              v-model="parameters.use"
            ></MyForm>
            <MyForm
              class="my_form"
              title="总体满意程度评价"
              :choice="true"
              :choice_list="['非常满意', '满意', '比较满意']"
              v-model="parameters.isuse"
            ></MyForm>

            <div class="form_title">
              <p>设计单位意见</p>
            </div>
            <MyForm
              class="my_form2"
              title="意见综述"
              :left_height="188"
              :textarea="true"
              v-model="parameters.Design"
            ></MyForm>
            <div class="flex">
              <MyForm
                class="my_form"
                title="总体满意程度评价"
                :choice="true"
                :choice_list="['非常满意', '满意', '比较满意']"
                v-model="parameters.isDesign"
              ></MyForm>
              <MyForm
                class="my_form"
                title="建设单位主要负责人"
                :text="true"
                :small="true"
                v-model="parameters.ResponsiblePerson2"
              ></MyForm>
            </div>
            <div class="form_title">
              <p>监理单位意见</p>
            </div>
            <MyForm
              class="my_form2"
              title="意见综述"
              :left_height="188"
              :textarea="true"
              v-model="parameters.supervisor"
            ></MyForm>
            <div class="flex">
              <MyForm
                class="my_form"
                title="总体满意程度评价"
                :choice="true"
                :choice_list="['非常满意', '满意', '比较满意']"
                v-model="parameters.issupervisor"
              ></MyForm>
              <MyForm
                class="my_form"
                title="监理单位总监工程师"
                :text="true"
                :small="true"
                v-model="parameters.Chiefengineer"
              ></MyForm>
            </div>
            <div class="form_title">
              <p>推荐单位意见</p>
            </div>
            <MyForm
              class="my_form2"
              title="推荐理由"
              :left_height="188"
              :textarea="true"
              v-model="parameters.Reasons"
            ></MyForm>
            <MyForm
              class="my_form"
              title="申报资料情况"
              :left_height="188"
              :textarea="true"
              v-model="parameters.Information"
            ></MyForm>
            <MyForm
              class="my_form2"
              title="申报工程获奖情况"
              :left_height="188"
              :textarea="true"
              v-model="parameters.Engineering_Award"
            ></MyForm>
            <MyForm
              class="my_form"
              :left_height="100"
              title="优质工程推荐表（按类型选择表格下载填写后上传）"
              :isDowninpu="true"
              v-model="parameters.Recommendationform"
            ></MyForm>
          </div>
        </div> -->
      </div>
      <div class="form_right" v-if="$route.query.title == '贵州省建筑业优秀项目经理'" id="exportPdf" ref="exportPdf">
        <div class="form_1" id="essinfo">
          <!-- title提示标题文字,background提示盒子背景色,border提示盒子左边边框颜色 -->
          <Tips title="申报单位" :background="essinfo ? '#EDF8F5' : '#FEF8EF'" :border="essinfo ? '#1ABF98' : '#FFB700'"
            :states="essinfo"></Tips>
          <div class="form_box_content">
            <div class="my_form2">
              <div class="form_title" style="height: 62px">
                推荐协会（单位）
              </div>
              <div class="form_long">
                <input placeholder="请输入" type="text" v-model="parameters2.essinfo.msg1" />
              </div>
            </div>
            <div class="my_form2">
              <div class="form_title" style="height: 62px">
                申报人所在企业名称
              </div>
              <div class="form_long">
                <input placeholder="请输入" type="text" v-model="parameters2.essinfo.msg2" />
              </div>
            </div>
            <div class="flex">
              <div class="my_form">
                <div class="form_title" style="height: 62px">联系电话</div>
                <div class="form_content">
                  <div class="input">
                    <input type="text" v-model="parameters2.essinfo.msg3" placeholder="请输入" />
                  </div>
                </div>
              </div>
              <div class="my_form">
                <div class="form_title" style="height: 62px">填报日期</div>
                <div class="form_content">
                  <el-date-picker type="date" value-format="yyyy-MM-dd" format="yyyy-MM-dd" placeholder="选择日期"
                    class="inpyabeb" v-model="parameters2.essinfo.msg4"></el-date-picker>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="form_1" id="candidate">
          <Tips title="申报人信息" :background="condition ? '#EDF8F5' : '#FEF8EF'"
            :border="condition ? '#1ABF98' : '#FFB700'" :states="condition"></Tips>
          <div class="form_box_content">
            <div class="flex">
              <div class="my_form">
                <div class="form_title" style="height: 62px">姓名</div>
                <div class="form_content">
                  <div class="input">
                    <input type="text" placeholder="请输入" v-model="parameters2.candidate.msg1" />
                  </div>
                </div>
              </div>
              <div class="my_form">
                <div class="form_title" style="height: 62px">性别</div>
                <div class="form_content">
                  <el-radio-group size="small" class="inpyabeb" v-model="parameters2.candidate.msg2">
                    <el-radio label="1">男</el-radio>
                    <el-radio label="0">女</el-radio>
                  </el-radio-group>
                </div>
              </div>
            </div>
            <div class="flex">
              <div class="my_form">
                <div class="form_title" style="height: 62px">身份证号</div>
                <div class="form_content">
                  <div class="input">
                    <input type="text" placeholder="请输入身份证号" v-model="parameters2.candidate.id_card" />
                  </div>
                </div>
              </div>
            </div>

            <div class="flex">
              <div class="my_form">
                <div class="form_title" style="height: 62px">出生年月</div>
                <div class="form_content">
                  <el-date-picker type="date" value-format="yyyy-MM-dd" format="yyyy-MM-dd" placeholder="选择日期"
                    class="inpyabeb" v-model="parameters2.candidate.msg3"></el-date-picker>
                </div>
              </div>
              <div class="my_form">
                <div class="form_title" style="height: 62px">民族</div>
                <div class="form_content">
                  <div class="input">
                    <input type="text" placeholder="请输入" v-model="parameters2.candidate.msg4" />
                  </div>
                </div>
              </div>
            </div>
            <div class="flex">
              <div class="my_form">
                <div class="form_title" style="height: 62px">文化程度</div>
                <div class="form_content">
                  <div class="input">
                    <input type="text" placeholder="请输入" v-model="parameters2.candidate.msg5" />
                  </div>
                </div>
              </div>
              <div class="my_form">
                <div class="form_title" style="height: 62px">政治面貌</div>
                <div class="form_content">
                  <div class="input">
                    <input type="text" placeholder="请输入" v-model="parameters2.candidate.msg6" />
                  </div>
                </div>
              </div>
            </div>
            <div class="flex">
              <div class="my_form">
                <div class="form_title" style="height: 62px">参加工作时间</div>
                <div class="form_content">
                  <div class="input">
                    <input type="text" placeholder="请输入" v-model="parameters2.candidate.msg7" />
                  </div>
                </div>
              </div>
              <div class="my_form">
                <div class="form_title" style="height: 62px">专业技术职称</div>
                <div class="form_content">
                  <div class="input">
                    <input type="text" placeholder="请输入" v-model="parameters2.candidate.msg8" />
                  </div>
                </div>
              </div>
            </div>
            <div class="flex">
              <div class="my_form">
                <div class="form_title" style="height: 62px">
                  注册建造师等级及专业
                </div>
                <div class="form_content">
                  <div class="input">
                    <input type="text" placeholder="请输入" v-model="parameters2.candidate.msg9" />
                  </div>
                </div>
              </div>
              <div class="my_form">
                <div class="form_title" style="height: 62px">职务</div>
                <div class="form_content">
                  <div class="input">
                    <input type="text" placeholder="请输入" v-model="parameters2.candidate.msg10" />
                  </div>
                </div>
              </div>
            </div>
            <div class="my_form2">
              <div class="form_title" style="height: 62px">工作单位</div>
              <div class="form_long">
                <input placeholder="请输入" v-model="parameters2.candidate.msg11" type="text" />
              </div>
            </div>
            <div class="my_form2">
              <div class="form_title" style="height: 62px">单位地址</div>
              <div class="form_long">
                <input placeholder="请输入" v-model="parameters2.candidate.msg12" type="text" />
              </div>
            </div>
            <div class="flex">
              <div class="my_form">
                <div class="form_title" style="height: 62px">单位电话</div>
                <div class="form_content">
                  <div class="input">
                    <input type="text" placeholder="请输入" v-model="parameters2.candidate.msg13" />
                  </div>
                </div>
              </div>
              <div class="my_form">
                <div class="form_title" style="height: 62px">邮政编码</div>
                <div class="form_content">
                  <div class="input">
                    <input type="text" placeholder="请输入" v-model="parameters2.candidate.msg14" />
                  </div>
                </div>
              </div>
            </div>
            <div class="flex">
              <div class="my_form">
                <div class="form_title" style="height: 110px">上传照片</div>
                <el-upload style="height: 110px" class="upload-demo" :action="'/api/home/upload/file/user'"
                  :limit="limit" accept=".jpg, .png" :on-success="handleSuccessUpload" :on-remove="handleRemove"
                  :file-list="parameters2.candidate.msg15" list-type="picture">
                  <el-button size="small" icon="el-icon-plus" style="margin-right: 10px">选择文件</el-button>
                  <div slot="tip" class="el-upload__tip" v-if="!parameters2.candidate.msg15">
                    只能上传jpg/png文件，且不超过500kb
                  </div>
                </el-upload>
              </div>
            </div>
            <div class="my_form">
              <div class="form_title" style="height: 188px; text-align: center">
                近三年内负责的工程名称及所任项目经理职务：
              </div>
              <div class="form_textarea">
                <textarea name id cols="30" rows="10" placeholder="请输入"
                  v-model="parameters2.candidate.msg16"></textarea>
              </div>
            </div>
            <div class="my_form">
              <div class="form_title" style="height: 188px; text-align: center">
                从事项目管理工作简历、业绩及奖惩情况：
              </div>
              <div class="form_textarea">
                <textarea name id cols="30" rows="10" placeholder="请输入"
                  v-model="parameters2.candidate.msg17"></textarea>
              </div>
            </div>
          </div>
        </div>
        <div class="form_1" id="Typicaldeeds">
          <Tips title="担任项目经理负责施工管理的典型事迹" :background="Selection ? '#EDF8F5' : '#FEF8EF'"
            :border="Selection ? '#1ABF98' : '#FFB700'" :states="Selection"></Tips>
          <div class="form_box_content">
            <div class="my_form2">
              <div class="form_title" style="height: 62px">工程项目名称</div>
              <div class="form_long">
                <input placeholder="请输入" type="text" v-model="parameters2.Typicaldeeds.msg1" />
              </div>
            </div>
            <div class="my_form2">
              <div class="form_title" style="height: 62px">工程项目地点</div>
              <div class="form_long">
                <input placeholder="请输入" type="text" v-model="parameters2.Typicaldeeds.msg2" />
              </div>
            </div>
            <div class="my_form2">
              <div class="form_title" style="height: 62px">建设单位</div>
              <div class="form_long">
                <input placeholder="请输入" type="text" v-model="parameters2.Typicaldeeds.msg3" />
              </div>
            </div>
            <div class="flex">
              <div class="my_form">
                <div class="form_title" style="height: 62px">合同工期</div>
                <div class="form_content">
                  <div class="input">
                    <input type="text" v-model="parameters2.Typicaldeeds.msg4" placeholder="请输入" />
                  </div>
                </div>
              </div>
              <div class="my_form">
                <div class="form_title" style="height: 62px">实际工期</div>
                <div class="form_content">
                  <div class="input">
                    <input type="text" v-model="parameters2.Typicaldeeds.msg5" placeholder="请输入" />
                  </div>
                </div>
              </div>
            </div>
            <div class="flex">
              <div class="my_form">
                <div class="form_title" style="height: 62px">工程概算</div>
                <div class="form_content">
                  <div class="input">
                    <input type="text" v-model="parameters2.Typicaldeeds.msg6" placeholder="请输入" />
                  </div>
                </div>
              </div>
              <div class="my_form">
                <div class="form_title" style="height: 62px">竣工决算</div>
                <div class="form_content">
                  <div class="input">
                    <input type="text" v-model="parameters2.Typicaldeeds.msg7" placeholder="请输入" />
                  </div>
                </div>
              </div>
            </div>
            <div class="my_form">
              <div class="form_title" style="height: 188px; text-align: center">
                实施项目管理的具体办法：
              </div>
              <div class="form_textarea">
                <textarea name id cols="30" rows="10" placeholder="请输入"
                  v-model="parameters2.Typicaldeeds.msg8"></textarea>
              </div>
            </div>
            <div class="my_form">
              <div class="form_title" style="height: 188px; text-align: center">
                获市（州）级及以上工程质量奖获绿色施工、新技术应用示范工程奖名称及时间
              </div>
              <div class="form_textarea">
                <textarea name id cols="30" rows="10" placeholder="请输入"
                  v-model="parameters2.Typicaldeeds.msg9"></textarea>
              </div>
            </div>
            <div class="my_form">
              <div class="form_title" style="height: 188px; text-align: center">
                获文明施工现场时间及授予部门
              </div>
              <div class="form_textarea">
                <textarea name id cols="30" rows="10" placeholder="请输入"
                  v-model="parameters2.Typicaldeeds.msg10"></textarea>
              </div>
            </div>
            <div class="my_form">
              <div class="form_title" style="height: 188px; text-align: center">
                安全生产情况
              </div>
              <div class="form_textarea">
                <textarea name id cols="30" rows="10" placeholder="请输入"
                  v-model="parameters2.Typicaldeeds.msg11"></textarea>
              </div>
            </div>
          </div>
        </div>
        <div class="form_1" id="Upload">
          <Tips title="上传附件" :background="enclosure ? '#EDF8F5' : '#FEF8EF'" :border="enclosure ? '#1ABF98' : '#FFB700'"
            :states="enclosure"></Tips>
          <div class="form_box_content">
            <div class="my_form2">
              <div class="form_title" style="min-height: 100px">
                1、注册建造师证扫描件
              </div>
              <div class="uploadinput">
                <div class="uploadlist" style="margin-left:20px">
                  <el-upload style="
                      display: flex;
                      align-items: center;
                      margin-left: 10px;
                    " :action="'/api/home/upload/file/user'"
                    :on-success="(value) => handenclosure('parameters2', 1, value)"
                    :on-remove="(value) => removeenclosure('parameters2', 1, value)" :before-upload="beforePdfUpload"
                    :file-list="parameters2.enclosure.msg1" :limit="1" accept=".pdf">
                    <el-button size="small" type="primary">点击上传</el-button>
                    <div slot="tip" style="margin-left: 10px" class="el-upload__tip" v-if="!parameters2.enclosure.msg1">
                      只能上传pdf文件，且不超过100MB
                    </div>
                  </el-upload>
                </div>
              </div>
            </div>
            <div class="my_form">
              <div class="form_title" style="min-height: 100px">
                2、安全生产考核合格证扫描件
              </div>
              <div class="uploadinput">
                <div class="uploadlist" style="margin-left:20px">
                  <el-upload style="
                      display: flex;
                      align-items: center;
                      margin-left: 10px;
                    " :action="'/api/home/upload/file/user'"
                    :on-success="(value) => handenclosure('parameters2', 2, value)"
                    :on-remove="(value) => removeenclosure('parameters2', 2, value)" :before-upload="beforePdfUpload"
                    :file-list="parameters2.enclosure.msg2" :limit="1" accept=".pdf">
                    <el-button size="small" type="primary">点击上传</el-button>
                    <div slot="tip" style="margin-left: 10px" class="el-upload__tip" v-if="!parameters2.enclosure.msg2">
                      只能上传pdf文件，且不超过100MB
                    </div>
                  </el-upload>
                </div>
              </div>
            </div>
            <div class="my_form2">
              <div class="form_title" style="min-height: 100px">
                3、获得市（州）级及以上工程质量奖或绿色施工、新技术应用示范工程奖证书扫描件
              </div>
              <div class="uploadinput">
                <div class="uploadlist" style="margin-left:20px">
                  <el-upload style="
                      display: flex;
                      align-items: center;
                      margin-left: 10px;
                    " :action="'/api/home/upload/file/user'"
                    :on-success="(value) => handenclosure('parameters2', 3, value)"
                    :on-remove="(value) => removeenclosure('parameters2', 3, value)" :before-upload="beforePdfUpload"
                    :file-list="parameters2.enclosure.msg3" :limit="1" accept=".pdf">
                    <el-button size="small" type="primary">点击上传</el-button>
                    <div slot="tip" style="margin-left: 10px" class="el-upload__tip" v-if="!parameters2.enclosure.msg3">
                      只能上传pdf文件，且不超过100MB
                    </div>
                  </el-upload>
                </div>
              </div>
            </div>
            <div class="my_form">
              <div class="form_title" style="min-height: 100px">
                4、该获奖工程项目经理的任职文件扫描件
              </div>
              <div class="uploadinput">
                <div class="uploadlist" style="margin-left:20px">
                  <!-- <el-radio-group
                    v-model="parameters2.enclosure.msg7"
                    size="small"
                    class="inpyabeb"
                  >
                    <el-radio :label="true">有</el-radio>
                    <el-radio :label="false">无</el-radio>
                  </el-radio-group> -->
                  <el-upload style="
                      display: flex;
                      align-items: center;
                      margin-left: 10px;
                    " :action="'/api/home/upload/file/user'"
                    :on-success="(value) => handenclosure('parameters2', 4, value)"
                    :on-remove="(value) => removeenclosure('parameters2', 4, value)" :before-upload="beforePdfUpload"
                    :file-list="parameters2.enclosure.msg4" :limit="1" accept=".pdf">
                    <el-button size="small" type="primary">点击上传</el-button>
                    <div slot="tip" style="margin-left: 10px" class="el-upload__tip" v-if="!parameters2.enclosure.msg4">
                      只能上传pdf文件，且不超过100MB
                    </div>
                  </el-upload>
                </div>
              </div>
            </div>
            <div class="my_form2">
              <div class="form_title" style="min-height: 100px">
                5、获得文明施工现场证明材料扫描件
              </div>
              <div class="uploadinput">
                <div class="uploadlist" style="margin-left:20px">
                  <el-upload style="
                      display: flex;
                      align-items: center;
                      margin-left: 10px;
                    " :action="'/api/home/upload/file/user'"
                    :on-success="(value) => handenclosure('parameters2', 5, value)"
                    :on-remove="(value) => removeenclosure('parameters2', 5, value)" :before-upload="beforePdfUpload"
                    :file-list="parameters2.enclosure.msg5" :limit="1" accept=".pdf">
                    <el-button size="small" type="primary">点击上传</el-button>
                    <div slot="tip" style="margin-left: 10px" class="el-upload__tip" v-if="!parameters2.enclosure.msg5">
                      只能上传pdf文件，且不超过100MB
                    </div>
                  </el-upload>
                </div>
              </div>
            </div>
            <div class="my_form">
              <div class="form_title" style="min-height: 100px">
                6、企业法人承诺书(原件) 内容应包括: 1、申报资料真实有效有效。2、近三年所完成工程建设项目合格率达到100%， 没有发生过一般及以上工程建设质量安全事故，无拖欠农民工资的行为
              </div>
              <div class="uploadinput">
                <div class="uploadlist" style="margin-left:20px">
                  <!-- <el-radio-group
                    v-model="parameters2.enclosure.msg7"
                    size="small"
                    class="inpyabeb"
                  >
                    <el-radio :label="true">有</el-radio>
                    <el-radio :label="false">无</el-radio>
                  </el-radio-group> -->
                  <el-upload style="
                      display: flex;
                      align-items: center;
                      margin-left: 10px;
                    " :action="'/api/home/upload/file/user'"
                    :on-success="(value) => handenclosure('parameters2', 6, value)"
                    :on-remove="(value) => removeenclosure('parameters2', 6, value)" :before-upload="beforePdfUpload"
                    :file-list="parameters2.enclosure.msg6" :limit="1" accept=".pdf">
                    <el-button size="small" type="primary">点击上传</el-button>
                    <div slot="tip" style="margin-left: 10px" class="el-upload__tip" v-if="!parameters2.enclosure.msg6">
                      只能上传pdf文件，且不超过100MB
                    </div>
                  </el-upload>
                </div>
              </div>
            </div>
            <div class="my_form">
              <div class="form_title" style="min-height: 100px">
                7、贵州省优秀项目经理申报表
              </div>
              <div class="uploadinput">
                <div class="uploadlist" style="margin-left:20px">
                  <!-- <el-radio-group
                    v-model="parameters2.enclosure.msg7"
                    size="small"
                    class="inpyabeb"
                  >
                    <el-radio :label="true">有</el-radio>
                    <el-radio :label="false">无</el-radio>
                  </el-radio-group> -->
                  <el-upload style="
                      display: flex;
                      align-items: center;
                      margin-left: 10px;
                    " :action="'/api/home/upload/file/user'"
                    :on-success="(value) => handenclosure('parameters2', 7, value)"
                    :on-remove="(value) => removeenclosure('parameters2', 7, value)" :before-upload="beforePdfUpload"
                    :file-list="parameters2.enclosure.msg7" :limit="1" accept=".pdf">
                    <el-button size="small" type="primary">点击上传</el-button>
                    <div slot="tip" style="margin-left: 10px" class="el-upload__tip" v-if="!parameters2.enclosure.msg7">
                      只能上传pdf文件，且不超过100MB
                    </div>
                  </el-upload>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="form_right" v-if="$route.query.title == '新技术示范工程'" id="exportPdf" ref="exportPdf">
        <div class="form_1">
          <!-- title提示标题文字,background提示盒子背景色,border提示盒子左边边框颜色 -->
          <Tips title="基本信息" background="#FEF8EF" border="#FEF8EF" :states="true"></Tips>
        </div>
        <div class="form_1" v-for="item in count" :key="item">
          <Tips title="详细信息" background="#FEF8EF" border="#FFB700" :states="false"></Tips>
        </div>
      </div>
      <div class="form_right" v-if="$route.query.title == '省级施工工法'" id="exportPdf" ref="exportPdf">
        <div class="form_1" id="type_of_work">
          <!-- title提示标题文字,background提示盒子背景色,border提示盒子左边边框颜色 -->
          <div style="background-color:#FEF8EF;text-align:left;margin-bottom: 20px;padding: 10px;color:#f56c6c;">温馨提示：该表格所有内容都为必填、必传项目，故信息缺失的情况下将无法进行提交，请务必认真填写完整所有信息后再进行提交！</div>

          <Tips title="工程类别" :background="lefttitlelist[0].isok ? '#EDF8F5' : '#FEF8EF'"
            :border="lefttitlelist[0].isok ? '#1ABF98' : '#FFB700'" :states="lefttitlelist[0].isok"></Tips>
          <!-- 基本信息 s -->
          <el-form :model="ruleForm" :rules="rules" ref="ruleForm">
            <el-tabs style="margin-top: 16px" v-model="activeName" @tab-click="handleClick">
              <div class="my_form">
                <div class="form_title" style="height: 62px">工程类别</div>
                <div class="form_long form_long-1">
                  <el-radio-group v-model="parameters4.info.type_of_work" size="small" class="inpyabeb"
                    @change="changeType(parameters4.info.type_of_work)">
                    <!-- <el-radio label="0">房屋建筑工程</el-radio>
			              <el-radio label="1">土木工程</el-radio>
			              <el-radio label="2">工业安装工程</el-radio> -->
                    <el-radio v-for="(item, index) in type_work_arr" :label="item">{{ item }}</el-radio>
                  </el-radio-group>
                </div>
              </div>
            </el-tabs>
          </el-form>
          <!-- 基本信息 e -->
        </div>
        <div class="form_1" id="type_of_major">
          <Tips title="专业分类" :background="lefttitlelist[1].isok ? '#EDF8F5' : '#FEF8EF'"
            :border="lefttitlelist[1].isok ? '#1ABF98' : '#FFB700'" :states="lefttitlelist[1].isok"></Tips>
          <el-form :model="ruleForm" :rules="rules" ref="ruleForm">
            <el-tabs style="margin-top: 16px" v-model="activeName" @tab-click="handleClick">
              <div class="my_form">
                <div class="form_title" style="height: 62px">专业分类</div>
                <div class="form_long form_long-1">
                  <el-radio-group v-model="parameters4.info.type_of_major" size="small" class="inpyabeb"
                    @change="changeMajorType(parameters4.info.type_of_major)">
                    <el-radio v-for="(item1, index1) in type_major_arr" :label="item1">{{ item1 }}</el-radio>
                  </el-radio-group>
                </div>
              </div>
            </el-tabs>
          </el-form>
        </div>
        <div class="form_1" id="sj_info">
          <Tips title="基本信息" :background="lefttitlelist[2].isok ? '#EDF8F5' : '#FEF8EF'"
            :border="lefttitlelist[2].isok ? '#1ABF98' : '#FFB700'" :states="lefttitlelist[2].isok"></Tips>
          <!-- <div class="border"></div>
          <div class="newlybuild" @click="addunit(2)">
            <img src="../assets/6622@2x.png" alt />
            <p>新增参建单位信息表</p>
          </div> -->
          <!-- 基本信息 s -->
          <el-form :model="ruleForm" :rules="rules" ref="ruleForm">
            <el-tabs style="margin-top: 16px" v-model="activeName" @tab-click="handleClick">
              <div class="my_form">
                <div class="form_title" style="height: 62px">工法名称</div>
                <div class="form_long">
                  <input placeholder="点击输入" type="text" v-model="parameters4.info.name" />
                </div>
              </div>
              <div class="my_form2">
                <div class="form_title" style="height: 62px">编写单位</div>
                <div class="form_long">
                  <input placeholder="点击输入" type="text" v-model="parameters4.info.unit" />
                </div>
              </div>

              <div class="my_form">
                <div class="form_title" style="height: 62px">主要完成人姓名</div>
                <div class="form_long flex" style="padding-left: 21px;justify-content: space-between;padding-right: 21px;">
                  <div  v-for="(author,index) in parameters4.info.author_names" :key="'author-' + index">
                    <input style="width:120px" v-model="author['name']" @input="filterAuthorName(author)" @blur="author_sock_check()" :placeholder="'输入姓名'+(index+1)" type="text" />
                  </div>
                </div>
              </div>


              <div class="flex">
                <div class="my_form2">
                  <div class="form_title" style="height: 62px">申报联系人</div>
                  <div class="form_content">
                    <div class="input">
                      <input type="text" placeholder="点击输入" v-model="parameters4.info.username" />
                    </div>
                  </div>
                </div>
                <div class="my_form2">
                  <div class="form_title" style="height: 62px">联系电话</div>
                  <div class="form_content">
                    <div class="input">
                      <input type="text" placeholder="点击输入" v-model="parameters4.info.phone" />
                    </div>
                  </div>
                </div>
              </div>

               <div class="my_form">
                <div class="form_title" style="height: 62px">电话</div>
                <div class="form_long">
                  <input placeholder="点击输入" type="text" v-model="parameters4.info.tel" maxlength="20" @input="formatTelField('tel')" />
                </div>
              </div>



            </el-tabs>
          </el-form>
          <!-- 基本信息 e -->
        </div>

        <div class="form_1" id="sj_upload">
          <Tips title="申报材料上传" :background="lefttitlelist[4].isok ? '#EDF8F5' : '#FEF8EF'"
            :border="lefttitlelist[4].isok ? '#1ABF98' : '#FFB700'" :states="lefttitlelist[4].isok"></Tips>
          <div class="form_dec">下列第1到第11项申报材料应为盖章后扫描件，为PDF格式，申报材料内容包括：</div>
          <!-- 基本信息 s -->
          <el-form :model="ruleForm" :rules="rules" ref="ruleForm">
            <el-tabs v-model="activeName" @tab-click="handleClick">
              <div class="my_form form_long">
                <div class="form_title">贵州省级工法申报汇总表（附件2）</div>
                <div class="form_upload form_long">
                  <div class="uploadcertificate">
                    <el-upload class="upload-demo" :on-remove="handleOnRemove1" :on-success="uploadSuccess1"
                      :action="'/api/home/upload/file/user'" :file-list="parameters4.info.filelist1"
                      accept=".pdf">
                      <div class="form-upload-div">
                        <el-button size="small" class="el-icon-upload el-icon--left action_upload"> 点击上传PDF</el-button>
                        <div slot="tip" class="el-upload__tip">
                          仅支持pdf格式，大小不超过100mb
                        </div>
                      </div>
                    </el-upload>
                  </div>
                  <div class="uploadcertificate">
                    <el-upload class="upload-demo" :on-remove="handleOnRemove2" :on-success="uploadSuccess2"
                      :action="'/api/home/upload/file/user'" :file-list="parameters4.info.filelist2"
                      accept=".excel,.xls,.xlt,.xlsx">
                      <div class="form-upload-div">
                        <el-button size="small" class="el-icon-upload el-icon--left action_upload"> 点击上传Excel
                        </el-button>
                        <div slot="tip" class="el-upload__tip">
                          仅支持Excel格式，大小不超过100mb
                        </div>
                      </div>
                    </el-upload>
                  </div>
                  <div class="form_tip">
                    <el-tooltip content="除盖章后的PDF格式外另附EXCEL格式电子文档" style="color: indianred;" placement="top">
                      <li class="el-icon-info" style="margin-right:100px"></li>
                    </el-tooltip>
                  </div>
                </div>
              </div>

              <div class="my_form2">
                <div class="form_title" style="background: #f5f8fb;">贵州省级工法申报表（附件1）</div>
                <div class="uploadcertificate">
                  <el-upload class="upload-demo" :on-remove="handleOnRemove3" :on-success="uploadSuccess3"
                    :action="'/api/home/upload/file/user'" :file-list="parameters4.info.filelist3"
                    accept=".pdf" :before-upload="beforePdfUpload">
                    <div class="form-upload-div">
                      <el-button size="small" class="el-icon-upload el-icon--left action_upload"> 点击上传PDF</el-button>
                      <div slot="tip" class="el-upload__tip">
                        仅支持pdf格式，大小不超过100mb
                      </div>
                    </div>
                  </el-upload>
                </div>
              </div>

              <div class="my_form">
                <div class="form_title">工法文本</div>
                <div class="uploadcertificate form_long">
                  <el-upload class="upload-demo" :on-remove="handleOnRemove4" :on-success="uploadSuccess4"
                    :action="'/api/home/upload/file/user'" :file-list="parameters4.info.filelist4"
                    accept=".pdf" :before-upload="beforePdfUpload">
                    <div class="form-upload-div">
                      <el-button size="small" class="el-icon-upload el-icon--left action_upload"> 点击上传PDF</el-button>
                      <div slot="tip" class="el-upload__tip">
                        仅支持pdf格式，大小不超过100mb
                      </div>
                    </div>
                  </el-upload>
                  <div class="form_tip">
                    <el-tooltip content="工法编写内容应当包括:前言、工法特点、适用范围、工艺原理、施工工艺流程及操作要点、材料与设备、质量控制、安全措施、环保措施、效益分析和应用实例；"
                      style="color: indianred;" placement="top">
                      <li class="el-icon-info" style="margin-right:100px"></li>
                    </el-tooltip>
                  </div>
                </div>
              </div>

              <div class="my_form2">
                <div class="form_title">企业工法证明材料</div>
                <div class="uploadcertificate">
                  <el-upload class="upload-demo" :on-remove="handleOnRemove5" :on-success="uploadSuccess5"
                    :action="'/api/home/upload/file/user'" :file-list="parameters4.info.filelist5"
                    accept=".pdf" :before-upload="beforePdfUpload">
                    <div class="form-upload-div">
                      <el-button size="small" class="el-icon-upload el-icon--left action_upload"> 点击上传PDF</el-button>
                      <div slot="tip" class="el-upload__tip">
                        仅支持pdf格式，大小不超过100mb
                      </div>
                    </div>
                  </el-upload>
                </div>
              </div>

              <div class="my_form">
                <div class="form_title">工法关键技术鉴定的有关资料</div>
                <div class="uploadcertificate form_long">
                  <el-upload class="upload-demo" :on-remove="handleOnRemove6" :on-success="uploadSuccess6"
                    :action="'/api/home/upload/file/user'" :file-list="parameters4.info.filelist6"
                    accept=".pdf" :before-upload="beforePdfUpload">
                    <div class="form-upload-div">
                      <el-button size="small" class="el-icon-upload el-icon--left action_upload"> 点击上传PDF</el-button>
                      <div slot="tip" class="el-upload__tip">
                        仅支持pdf格式，大小不超过100mb
                      </div>
                    </div>
                  </el-upload>
                </div>
              </div>

              <div class="my_form2">
                <div class="form_title">工程应用证明</div>
                <div class="uploadcertificate" style="display: contents;">
                  <el-upload class="upload-demo" :on-remove="handleOnRemove7" :on-success="uploadSuccess7"
                    :action="'/api/home/upload/file/user'" :file-list="parameters4.info.filelist7"
                    accept=".pdf" :before-upload="beforePdfUpload">
                    <div class="form-upload-div">
                      <el-button size="small" class="el-icon-upload el-icon--left action_upload"> 点击上传PDF</el-button>
                      <div slot="tip" class="el-upload__tip">
                        仅支持pdf格式，大小不超过100mb
                      </div>
                    </div>
                  </el-upload>
                  <div class="form_tip" style="width: 600px;margin-top: 17px;">
                    <el-tooltip popper-class="tooltip-width"
                      content="包括应用工程的监理单位或建设单位提供的证明，施工许可证或开工报告复印件，施工合同复印件(只提供封面，含发包单位、承包单位及承包范围内容页及盖章页),工法要经过2项及以上工程应用实例，注册地非本省的建筑施工企业申报省级工法的，申报工法的工程应用实例至少有一项在贵州省区域内；"
                      style="color: indianred;max-width:200px" placement="top">
                      <li class="el-icon-info"></li>
                    </el-tooltip>
                  </div>
                </div>
              </div>

              <div class="my_form">
                <div class="form_title">经济效益证明</div>
                <div class="uploadcertificate form_long">
                  <el-upload class="upload-demo" :on-remove="handleOnRemove8" :on-success="uploadSuccess8"
                    :action="'/api/home/upload/file/user'" :file-list="parameters4.info.filelist8"
                    accept=".pdf" :before-upload="beforePdfUpload">
                    <div class="form-upload-div">
                      <el-button size="small" class="el-icon-upload el-icon--left action_upload"> 点击上传PDF</el-button>
                      <div slot="tip" class="el-upload__tip">
                        仅支持pdf格式，大小不超过100mb
                      </div>
                    </div>
                  </el-upload>
                </div>
              </div>

              <div class="my_form2">
                <div class="form_title">科技查新报告</div>
                <div class="uploadcertificate" style="display: contents;">
                  <el-upload class="upload-demo" :on-remove="handleOnRemove9" :on-success="uploadSuccess9"
                    :action="'/api/home/upload/file/user'" :file-list="parameters4.info.filelist9"
                    accept=".pdf" :before-upload="beforePdfUpload">
                    <div class="form-upload-div">
                      <el-button size="small" class="el-icon-upload el-icon--left action_upload"> 点击上传PDF</el-button>
                      <div slot="tip" class="el-upload__tip">
                        仅支持pdf格式，大小不超过100mb
                      </div>
                    </div>
                  </el-upload>
                  <div class="form_tip" style="width: 600px;margin-top: 17px;">
                    <el-tooltip content="科技查新报告由技术情报部门提供;" style="color: indianred;" placement="top">
                      <li class="el-icon-info"></li>
                    </el-tooltip>
                  </div>
                </div>
              </div>

              <div class="my_form">
                <div class="form_title">涉及他方专利的无争议声明书</div>
                <div class="uploadcertificate form_long">
                  <el-upload class="upload-demo" :on-remove="handleOnRemove10" :on-success="uploadSuccess10"
                    :action="'/api/home/upload/file/user'" :file-list="parameters4.info.filelist10"
                    accept=".pdf" :before-upload="beforePdfUpload">
                    <div class="form-upload-div">
                      <el-button size="small" class="el-icon-upload el-icon--left action_upload"> 点击上传PDF</el-button>
                      <div slot="tip" class="el-upload__tip">
                        仅支持pdf格式，大小不超过100mb
                      </div>
                    </div>
                  </el-upload>
                </div>
              </div>

              <div class="my_form2">
                <div class="form_title">关键技术标准、专利证书、科技成果获奖证明等其他有关材料</div>
                <div class="uploadcertificate">
                  <el-upload class="upload-demo" :action="'/api/home/upload/file/user'"
                    :file-list="parameters4.info.filelist11" :on-remove="handleOnRemove11" :on-success="uploadSuccess11"
                    accept=".pdf" :before-upload="beforePdfUpload">
                    <div class="form-upload-div">
                      <el-button size="small" class="el-icon-upload el-icon--left action_upload"> 点击上传PDF</el-button>
                      <div slot="tip" class="el-upload__tip">
                        仅支持pdf格式，大小不超过100mb
                      </div>
                    </div>
                  </el-upload>
                </div>
              </div>

              <div class="my_form">
                <div class="form_title">工法应用的有关照片</div>
                <div class="uploadcertificate form_long" style="padding-bottom: 10px;">
                  <el-upload style="display: grid;
					       padding-top: 20px;
					       padding-bottom: 180px;
					       overflow: scroll;
					       flex-wrap: wrap;" class="upload-demo" :action="'/api/home/upload/file/user'"
                    :on-remove="handleOnRemove12" :on-success="uploadSuccess12" :file-list="parameters4.info.filelist12"
                    accept=".jpg, .png,.mp4,.avi,.flv" >
                    <div class="form-upload-div" style="margin-bottom: 30px">
                      <el-button size="small" class="el-icon-upload el-icon--left action_upload"> 选择文件</el-button>
                      <div slot="tip" class="el-upload__tip">
                        仅支持jpg,png,.mp4,.avi,.flv格式，大小不超过300mb
                      </div>
                    </div>
                  </el-upload>
                </div>
              </div>


            </el-tabs>
          </el-form>
          <!-- 基本信息 e -->
        </div>
      </div>
      
      <div class="form_right" v-if="$route.query.title == '贵州省工程建设工法评定'" id="exportPdf" ref="exportPdf">
        <div class="form_1" id="type_of_work">
          <!-- title提示标题文字,background提示盒子背景色,border提示盒子左边边框颜色 -->
          <div style="background-color:#FEF8EF;text-align:left;margin-bottom: 20px;padding: 10px;color:#f56c6c;">温馨提示：该表格所有内容都为必填、必传项目，故信息缺失的情况下将无法进行提交，请务必认真填写完整所有信息后再进行提交！</div>
        
        
          <Tips title="工程类别" :background="lefttitlelist[0].isok ? '#EDF8F5' : '#FEF8EF'"
            :border="lefttitlelist[0].isok ? '#1ABF98' : '#FFB700'" :states="lefttitlelist[0].isok"></Tips>
          <!-- 基本信息 s -->
          <el-form :model="ruleForm" :rules="rules" ref="ruleForm">
            <el-tabs style="margin-top: 16px" v-model="activeName" @tab-click="handleClick">
              <div :class="gfneed_fields.indexOf('type_of_work') != -1 ? 'my_form form_error_k' : 'my_form'">
                <div class="form_title" style="height: 62px">工程类别</div>
                <div class="form_long form_long-1" >
                  <el-radio-group v-model="parameters4.info.type_of_work" :disabled="isGongfaReturnModify && gfneed_fields.indexOf('type_of_work') == -1  ? 'disabled' : false"  size="small" class="inpyabeb"
                    @change="changeType(parameters4.info.type_of_work)">
                    <!-- <el-radio label="0">房屋建筑工程</el-radio>
			              <el-radio label="1">土木工程</el-radio>
			              <el-radio label="2">工业安装工程</el-radio> -->
                    <el-radio v-for="(item, index) in type_work_arr" :label="item">{{ item }}</el-radio>
                  </el-radio-group>
                </div>
                <div v-if="gfneed_opinions['type_of_work']" class="gf-modify-opinion">修改意见：{{ gfneed_opinions['type_of_work'] }}</div>
              </div>
            </el-tabs>
          </el-form>
          <!-- 基本信息 e -->
        </div>
        <div class="form_1" id="type_of_major">
          <Tips title="专业分类" :background="lefttitlelist[1].isok ? '#EDF8F5' : '#FEF8EF'"
            :border="lefttitlelist[1].isok ? '#1ABF98' : '#FFB700'" :states="lefttitlelist[1].isok"></Tips>
          <el-form :model="ruleForm" :rules="rules" ref="ruleForm">
            <el-tabs style="margin-top: 16px" v-model="activeName" @tab-click="handleClick">
              <div :class="gfneed_fields.indexOf('type_of_major') != -1 ? 'my_form form_error_k' : 'my_form'">
                <div class="form_title" style="height: 62px">专业分类</div>
                <div class="form_long form_long-1" >
                  <el-radio-group v-model="parameters4.info.type_of_major" size="small" class="inpyabeb" :disabled="isGongfaReturnModify && gfneed_fields.indexOf('type_of_major') == -1 && gfneed_fields.indexOf('type_of_work') == -1 ? 'disabled' : false"
                    @change="changeMajorType(parameters4.info.type_of_major)">
                    <el-radio v-for="(item1, index1) in type_major_arr" :label="item1">{{ item1 }}</el-radio>
                  </el-radio-group>
                </div>
                <div v-if="gfneed_opinions['type_of_major']" class="gf-modify-opinion">修改意见：{{ gfneed_opinions['type_of_major'] }}</div>
              </div>
            </el-tabs>
          </el-form>
        </div>
        <div class="form_1" id="sj_info">
          <Tips title="基本信息" :background="lefttitlelist[2].isok ? '#EDF8F5' : '#FEF8EF'"
            :border="lefttitlelist[2].isok ? '#1ABF98' : '#FFB700'" :states="lefttitlelist[2].isok"></Tips>
          <!-- <div class="border"></div>
          <div class="newlybuild" @click="addunit(2)">
            <img src="../assets/6622@2x.png" alt />
            <p>新增参建单位信息表</p>
          </div> -->
          <!-- 基本信息 s -->
          <el-form :model="ruleForm" :rules="rules" ref="ruleForm">
            <el-tabs style="margin-top: 16px" v-model="activeName" @tab-click="handleClick">
              <div class="my_form">
                <div class="form_title" style="height: 62px">工法名称</div>
                <div :class="gfneed_fields.indexOf('name') != -1 ? 'form_long form_error' : 'form_long'" >
                  <input placeholder="点击输入" type="text" v-model="parameters4.info.name" :disabled="isGongfaReturnModify && gfneed_fields.indexOf('name') == -1 ? 'disabled' : false"/>
                </div>
                <div v-if="gfneed_opinions['name']" class="gf-modify-opinion">修改意见：{{ gfneed_opinions['name'] }}</div>
              </div>
              <div class="my_form2">
                <div class="form_title" style="height: 62px">编写单位</div>
                <div :class="gfneed_fields.indexOf('unit') != -1 ? 'form_long form_error' : 'form_long'" >
                  <input placeholder="点击输入" type="text" v-model="parameters4.info.unit" disabled="disabled"/>
                </div>
                <div v-if="gfneed_opinions['unit']" class="gf-modify-opinion">修改意见：{{ gfneed_opinions['unit'] }}</div>
              </div>

              <div class="my_form">
                <div class="form_title" style="height: 62px">主要完成人姓名</div>
                <div :class="gfneed_fields.indexOf('author_names') != -1 ? 'form_long form_error flex' : 'form_long flex'" style="padding-left: 21px;justify-content: space-between;padding-right: 21px;">
                  <div  v-for="(author,index) in parameters4.info.author_names" :key="'author-' + index">
                    <input style="width:120px" v-model="author['name']" @input="filterAuthorName(author)" @blur="author_sock_check()" :disabled="isGongfaReturnModify && gfneed_fields.indexOf('author_names') == -1  ? 'disabled' : false" :placeholder="'输入姓名'+(index+1)" type="text" />
                  </div>
                </div>
                <div v-if="gfneed_opinions['author_names']" class="gf-modify-opinion">修改意见：{{ gfneed_opinions['author_names'] }}</div>
              </div>


              <div class="flex">
                <div class="my_form2">
                  <div class="form_title" style="height: 62px">申报联系人</div>
                  <div  :class="gfneed_fields.indexOf('contact') != -1 ? 'form_content form_error' : 'form_content'" >
                    <div class="input">
                      <input type="text" placeholder="点击输入" v-model="parameters4.info.username" :disabled="isGongfaReturnModify && gfneed_fields.indexOf('contact') == -1  ? 'disabled' : false "/>
                    </div>
                  </div>
                </div>
                <div class="my_form2">
                  <div class="form_title" style="height: 62px">手机号码</div>
                  <div   :class="gfneed_fields.indexOf('contact') != -1 ? 'form_content form_error' : 'form_content'" >
                    <div class="input input--with-tip">
                      <input
                        type="text"
                        placeholder="点击输入"
                        maxlength="11"
                        v-model="parameters4.info.phone"
                        :disabled="isGongfaReturnModify && gfneed_fields.indexOf('contact') == -1  ? 'disabled' : false"
                        @input="formatGongfaPhone"
                        @blur="validateGongfaPhone"
                      />
                      <div class="field-tip field-tip--error">
                        {{ gongfaPhoneError || '该电话将用于接收申报审核结果及有关通知' }}
                      </div>
                    </div>
                  </div>
                  <div v-if="gfneed_opinions['contact']" class="gf-modify-opinion">修改意见：{{ gfneed_opinions['contact'] }}</div>
                </div>
              </div>

            <div class="my_form2">
                <div class="form_title" style="height: 62px">企业注册地</div>
                <div   :class="gfneed_fields.indexOf('gf_province') != -1 ? 'form_long form_long-1 form_error gongfa-province' : 'form_long-1 form_long gongfa-province'" >
                    <el-radio-group size="small" class="inpyabeb" v-model="parameters4.info.gf_province" :disabled="isGongfaReturnModify && gfneed_fields.indexOf('gf_province') == -1  ? 'disabled' : false">
                        <el-radio label="1">贵州省</el-radio>
                        <el-radio label="2">其他省</el-radio>
                      </el-radio-group>
                      <el-select
                        v-if="parameters4.info.gf_province == '2'"
                        v-model="parameters4.info.gf_province_detail"
                        placeholder="请选择省份"
                        size="small"
                        class="gongfa-province__select"
                        :disabled="isGongfaReturnModify && gfneed_fields.indexOf('gf_province') == -1  ? 'disabled' : false"
                      >
                        <el-option
                          v-for="province in gongfaProvinceOptions"
                          :key="province"
                          :label="province"
                          :value="province"
                        />
                      </el-select>
                      
                  <!--<el-radio-group  :disabled="isGongfaReturnModify && gfneed_fields.indexOf('gf_province') == -1  ? 'disabled' : false"  size="small" class="inpyabeb" >-->
                  <!--      <el-radio label="1"></el-radio>-->
                  <!--      <el-radio label="2"></el-radio>-->
                  <!--</el-radio-group>-->
                </div>
                <div v-if="gfneed_opinions['gf_province']" class="gf-modify-opinion">修改意见：{{ gfneed_opinions['gf_province'] }}</div>
              </div>

            </el-tabs>
          </el-form>
          <!-- 基本信息 e -->
        </div>

       <div class="form_1 gfupload" id="sj_upload">
              <Tips
                title="申报材料上传"
                :background="lefttitlelist[4].isok ? '#EDF8F5' : '#FEF8EF'"
                :border="lefttitlelist[4].isok ? '#1ABF98' : '#FFB700'"
                :states="lefttitlelist[4].isok"
              />
              <div class="form_dec">
                下列第1至12项申报材料应为加盖所属单位公章后的扫描件，为PDF格式。
              </div>
            
              <el-form :model="ruleForm" :rules="rules" ref="ruleForm">
                <el-tabs v-model="activeName" @tab-click="handleClick">
                  <!-- 1. 《贵州省工程建设施工工法申报表》 -->
                  <div :class="gfneed_fields.indexOf('filelist3') != -1 ? 'my_form form_error_k' : 'my_form'">
                    <div class="dftitle form_title  form_title--soft" style="padding-top:10px !important;padding-bottom:10px !important;">
                      《贵州省工程建设工法申报表》（官方制式表格，完整填报、加盖申报单位公章）
                    </div>
                    <div class="uploadcertificate">
                      <el-upload
                        class="upload-demo"
                        :on-remove="handleOnRemove3"
                        :on-success="uploadSuccess3"
                        :action="'/api/home/upload/file/user'"
                        :file-list="parameters4.info.filelist3"
                        ref="gf_upload_filelist3"
                        :limit="1"
                        :on-exceed="(f,fl) => handleGfFileExceed(f,fl,'gf_upload_filelist3')"
                        :disabled="isGfFieldDisabled('filelist3')"
                        accept=".pdf"
                        :before-upload="beforePdfUpload"
                      >
                        <div class="form-upload-div">
                          <el-button size="small" class="el-icon-upload el-icon--left action_upload">点击上传PDF</el-button>
                          <div slot="tip" class="el-upload__tip">仅支持 pdf 格式，大小不超过 100MB</div>
                        </div>
                      </el-upload>
                      <div>
                         <a class="upload-file--file" target="_blank" href="/user/附件：申请表.doc">
                                附件：申请表.doc
                          </a> 
                      </div>
                      
                    </div>
                    <div v-if="gfneed_opinions['filelist3']" class="gf-modify-opinion">修改意见：{{ gfneed_opinions['filelist3'] }}</div>
                  </div>
            
                  <!-- 2. 贵州省工程建设工法申报承诺书 -->
                  <div :class="gfneed_fields.indexOf('filelist_commitment') != -1 ? 'my_form form_error_k' : 'my_form'">
                    <div class="dftitle form_title  form_title--soft" style="padding-top:10px !important;padding-bottom:10px !important;">
                      工法申报承诺书
                    </div>
                    <div class="uploadcertificate">
                      <el-upload
                        class="upload-demo"
                        :on-remove="handleOnRemoveCommitment"
                        :on-success="uploadSuccessCommitment"
                        :action="'/api/home/upload/file/user'"
                        :file-list="parameters4.info.filelist_commitment"
                        ref="gf_upload_filelist_commitment"
                        :limit="1"
                        :on-exceed="(f,fl) => handleGfFileExceed(f,fl,'gf_upload_filelist_commitment')"
                        :disabled="isGfFieldDisabled('filelist_commitment')"
                        accept=".pdf"
                        :before-upload="beforePdfUpload"
                      >
                        <div class="form-upload-div">
                          <el-button size="small" class="el-icon-upload el-icon--left action_upload">点击上传PDF</el-button>
                          <div slot="tip" class="el-upload__tip">仅支持 pdf 格式，大小不超过 100MB</div>
                        </div>
                      </el-upload>
                      <div>
                        <a class="upload-file--file" target="_blank" href="/user/附件：贵州省工程建设工法申报承诺书.docx">
                          附件：贵州省工程建设工法申报承诺书.docx
                        </a>
                      </div>
                    </div>
                    <div v-if="gfneed_opinions['filelist_commitment']" class="gf-modify-opinion">修改意见：{{ gfneed_opinions['filelist_commitment'] }}</div>
                  </div>

                  <!-- 3. 工法文本（含编写要点说明） -->
                  <div :class="gfneed_fields.indexOf('filelist4') != -1 ? 'my_form form_error_k' : 'my_form'">
                    <div class="dform_title">
                         <div class="form_title">
                          工法文本
                        </div>
                        <div class="title-desc">
                          完整工法文本。内容包含：前言、工法特点、适用范围、工艺原理、工艺流程及操作要点、材料与设备、质量控制、安全措施、环保措施、效益分析、应用实例
                        </div>
                    </div>
                   
                    <div class="uploadcertificate">
                      <el-upload
                        class="upload-demo"
                        :on-remove="handleOnRemove4"
                        :on-success="uploadSuccess4"
                        :action="'/api/home/upload/file/user'"
                        :file-list="parameters4.info.filelist4"
                        ref="gf_upload_filelist4"
                        :disabled="isGfFieldDisabled('filelist4')"
                        :on-exceed="(f,fl) => handleGfFileExceed(f,fl,'gf_upload_filelist4')"
                        accept=".pdf"
                        :before-upload="beforePdfUpload"
                        :limit="1"
                      >
                        <div class="form-upload-div">
                          <el-button size="small" class="el-icon-upload el-icon--left action_upload">点击上传PDF</el-button>
                          <div slot="tip" class="el-upload__tip">仅支持 pdf 格式，大小不超过 100MB</div>
                        </div>
                      </el-upload>
                    </div>
                    <div class="gongfa-authorization">
                      <div class="field-tip field-tip--block">
                        若您的申报材料通过终审，您所申报的工法文本将在工法库进行展示。如同意展示请选择“同意”，不同意则选择“不同意”。
                      </div>
                      <el-radio-group
                        v-model="parameters4.info.text_public_authorized"
                        :disabled="isGongfaReturnModify && gfneed_fields.indexOf('text_public_authorized') == -1 && gfneed_fields.indexOf('filelist4') == -1 ? 'disabled' : false"
                      >
                        <el-radio label="1">同意</el-radio>
                        <el-radio label="0">不同意</el-radio>
                      </el-radio-group>
                    </div>
                    <div v-if="gfneed_opinions['filelist4']" class="gf-modify-opinion">修改意见：{{ gfneed_opinions['filelist4'] }}</div>
                  </div>
            
                  <!-- 4. 企业工法证明材料 -->
                  <div :class="gfneed_fields.indexOf('filelist5') != -1 ? 'my_form form_error_k' : 'my_form'">
                    <div class="dftitle form_title " style="padding-top:10px !important;padding-bottom:10px !important;">企业级工法批准发布文件</div>
                    <div class="uploadcertificate">
                      <el-upload
                        class="upload-demo"
                        :on-remove="handleOnRemove5"
                        :on-success="uploadSuccess5"
                        :action="'/api/home/upload/file/user'"
                        :file-list="parameters4.info.filelist5"
                        ref="gf_upload_filelist5"
                        :disabled="isGfFieldDisabled('filelist5')"
                        :on-exceed="(f,fl) => handleGfFileExceed(f,fl,'gf_upload_filelist5')"
                        accept=".pdf"
                        :before-upload="beforePdfUpload"
                        :limit="1"
                      >
                        <div class="form-upload-div">
                          <el-button size="small" class="el-icon-upload el-icon--left action_upload">点击上传PDF</el-button>
                          <div slot="tip" class="el-upload__tip">仅支持 pdf 格式，大小不超过 100MB</div>
                        </div>
                      </el-upload>
                    </div>
                    <div v-if="gfneed_opinions['filelist5']" class="gf-modify-opinion">修改意见：{{ gfneed_opinions['filelist5'] }}</div>
                  </div>
            
                  <!-- 5. 工法关键技术专家论证的有关资料（文字更新） -->
                  <div :class="gfneed_fields.indexOf('filelist6') != -1 ? 'my_form form_error_k' : 'my_form'">
                    <div class="dftitle form_title " style="padding-top:10px !important;padding-bottom:10px !important;">关键技术专家论证材料（关键技术应由申报单位委托具备相应资质的机构或组织专家论证，且申报时论证时间不超过1年）</div>
                    <div class="uploadcertificate">
                      <el-upload
                        class="upload-demo"
                        :on-remove="handleOnRemove6"
                        :on-success="uploadSuccess6"
                        :action="'/api/home/upload/file/user'"
                        :file-list="parameters4.info.filelist6"
                        ref="gf_upload_filelist6"
                        :disabled="isGfFieldDisabled('filelist6')"
                        :on-exceed="(f,fl) => handleGfFileExceed(f,fl,'gf_upload_filelist6')"
                        accept=".pdf"
                        :before-upload="beforePdfUpload"
                        :limit="1"
                      >
                        <div class="form-upload-div">
                          <el-button size="small" class="el-icon-upload el-icon--left action_upload">点击上传PDF</el-button>
                          <div slot="tip" class="el-upload__tip">仅支持 pdf 格式，大小不超过 100MB</div>
                        </div>
                      </el-upload>
                    </div>
                    <div v-if="gfneed_opinions['filelist6']" class="gf-modify-opinion">修改意见：{{ gfneed_opinions['filelist6'] }}</div>
                  </div>
            
                  <!-- 6. 工程应用证明（长说明文字更新） -->
                  <div :class="gfneed_fields.indexOf('filelist7') != -1 ? 'my_form form_error_k' : 'my_form'">
                      <div class="dform_title">
                        <div class="form_title" style="padding-top:10px !important;padding-bottom:10px !important;">工程应用证明</div>
                        <div class="title-desc">
                          工程应用证明材料：建设或监理单位出具的应用证明，对应项目施工合同关键页、施工许可或开工证明；完整提供不少于2项工程实例佐证；省外企业至少1项实例位于贵州境内
                        </div>
                    </div>
                    <div class="uploadcertificate">
                      <el-upload
                        class="upload-demo"
                        :on-remove="handleOnRemove7"
                        :on-success="uploadSuccess7"
                        :action="'/api/home/upload/file/user'"
                        :file-list="parameters4.info.filelist7"
                        ref="gf_upload_filelist7"
                        :disabled="isGfFieldDisabled('filelist7')"
                        :on-exceed="(f,fl) => handleGfFileExceed(f,fl,'gf_upload_filelist7')"
                        accept=".pdf"
                        :limit="1"
                        :before-upload="beforePdfUpload"
                      >
                        <div class="form-upload-div">
                          <el-button size="small" class="el-icon-upload el-icon--left action_upload">点击上传PDF</el-button>
                          <div slot="tip" class="el-upload__tip">仅支持 pdf 格式，大小不超过 100MB</div>
                        </div>
                      </el-upload>
                    </div>
                    <div v-if="gfneed_opinions['filelist7']" class="gf-modify-opinion">修改意见：{{ gfneed_opinions['filelist7'] }}</div>
                  </div>
            
                  <!-- 7. 经济效益证明 -->
                  <div :class="gfneed_fields.indexOf('filelist8') != -1 ? 'my_form form_error_k' : 'my_form'">
                    <div class="dftitle form_title " style="padding-top:10px !important;padding-bottom:10px !important;">经济效益证明（由申报单位出具，每个应用工程出具一份）</div>
                    <div class="uploadcertificate">
                      <el-upload
                        class="upload-demo"
                        :on-remove="handleOnRemove8"
                        :on-success="uploadSuccess8"
                        :action="'/api/home/upload/file/user'"
                        :file-list="parameters4.info.filelist8"
                        ref="gf_upload_filelist8"
                        :disabled="isGfFieldDisabled('filelist8')"
                        :on-exceed="(f,fl) => handleGfFileExceed(f,fl,'gf_upload_filelist8')"
                        accept=".pdf"
                        :before-upload="beforePdfUpload"
                        :limit="1"
                      >
                        <div class="form-upload-div">
                          <el-button size="small" class="el-icon-upload el-icon--left action_upload">点击上传PDF</el-button>
                          <div slot="tip" class="el-upload__tip">仅支持 pdf 格式，大小不超过 100MB</div>
                        </div>
                      </el-upload>
                      <div>
                         <a class="upload-file--file" target="_blank" href="/user/附件：工法经济效益证明.docx">
                                附件：工法经济效益证明.docx
                          </a> 
                      </div>
                      
                    </div>
                    <div v-if="gfneed_opinions['filelist8']" class="gf-modify-opinion">修改意见：{{ gfneed_opinions['filelist8'] }}</div>
                  </div>
            
                  <!-- 8. 照片/视频（文案更新 + 宫格展示） -->
                  <div :class="gfneed_fields.indexOf('filelist12') != -1 ? 'my_form form_error_k' : 'my_form'">
                    <div class="dftitle form_title " style="padding-top:10px !important;padding-bottom:10px !important;">
                      工法现场应用照片不少于 10张，可附短视频资料
                    </div>
                    <div class="uploadcertificate media">
                      <el-upload
                        ref="gf_upload_filelist12"
                        class="upload-demo"
                        list-type="picture-card"
                        :action="'/api/home/upload/file/user'"
                        :on-remove="handleOnRemove12"
                        :on-success="uploadSuccess12"
                        :disabled="isGfFieldDisabled('filelist12') || mediaUploading"
                        :file-list="parameters4.info.filelist12"
                        :before-upload="beforeMediaUpload"
                        :on-error="handleMediaUploadError"
                        accept=".jpg,.jpeg,.png,.mp4,.avi,.flv"
                      >
                        <template slot="file" slot-scope="{ file }">
                          <div
                            v-if="file.status !== 'uploading' && isVideoFile(file)"
                            class="el-upload-list__item-thumbnail media-thumb media-thumb--video"
                            @click.stop="handleMediaPreview(file)"
                          >
                            <i class="el-icon-caret-right"></i>
                            <span>视频</span>
                          </div>
                          <img
                            v-else-if="file.status !== 'uploading'"
                            class="el-upload-list__item-thumbnail"
                            :src="file.url"
                            alt=""
                            @click.stop="handleMediaPreview(file)"
                          >
                          <el-progress
                            v-if="file.status === 'uploading'"
                            type="circle"
                            :stroke-width="6"
                            :percentage="parseInt(file.percentage, 10)"
                          />
                          <span class="el-upload-list__item-actions">
                            <span
                              class="el-upload-list__item-preview"
                              v-if="file.status !== 'uploading'"
                              @click.stop="handleMediaPreview(file)"
                            >
                              <i class="el-icon-zoom-in"></i>
                            </span>
                            <span
                              v-if="file.status !== 'uploading' && !isGfFieldDisabled('filelist12')"
                              class="el-upload-list__item-delete"
                              @click.stop="handleRemoveMedia(file)"
                            >
                              <i class="el-icon-delete"></i>
                            </span>
                          </span>
                        </template>
                        <i v-if="!mediaUploading" class="el-icon-plus"></i>
                        <div slot="tip" class="el-upload__tip">仅支持 jpg、png、mp4、avi、flv，大小不超过 300MB</div>
                      </el-upload>
                    </div>
                    <div v-if="gfneed_opinions['filelist12']" class="gf-modify-opinion">修改意见：{{ gfneed_opinions['filelist12'] }}</div>
                  </div>
            
                  <!-- 9. 科技查新报告 -->
                  <div :class="gfneed_fields.indexOf('filelist9') != -1 ? 'my_form form_error_k' : 'my_form'">
                    <div class="dftitle form_title " style="padding-top:10px !important;padding-bottom:10px !important;">科技查新报告（申报时查新报告出具时间原则上不超过1年）</div>
                    <div class="uploadcertificate">
                      <el-upload
                        class="upload-demo"
                        :on-remove="handleOnRemove9"
                        :on-success="uploadSuccess9"
                        :action="'/api/home/upload/file/user'"
                        :file-list="parameters4.info.filelist9"
                        ref="gf_upload_filelist9"
                        :disabled="isGfFieldDisabled('filelist9')"
                        :on-exceed="(f,fl) => handleGfFileExceed(f,fl,'gf_upload_filelist9')"
                        accept=".pdf"
                        :before-upload="beforePdfUpload"
                        :limit="1"
                      >
                        <div class="form-upload-div">
                          <el-button size="small" class="el-icon-upload el-icon--left action_upload">点击上传PDF</el-button>
                          <div slot="tip" class="el-upload__tip">仅支持 pdf 格式，大小不超过 100MB</div>
                        </div>
                      </el-upload>
                    </div>
                    <div v-if="gfneed_opinions['filelist9']" class="gf-modify-opinion">修改意见：{{ gfneed_opinions['filelist9'] }}</div>
                  </div>
            
                  <!-- 10. 无争议声明书 -->
                  <div :class="gfneed_fields.indexOf('filelist10') != -1 ? 'my_form form_error_k' : 'my_form'">
                    <div class="dftitle form_title " style="padding-top:10px !important;padding-bottom:10px !important;">涉及第三方专利的提交无争议声明</div>
                    <div class="uploadcertificate">
                      <el-upload
                        class="upload-demo"
                        :on-remove="handleOnRemove10"
                        :on-success="uploadSuccess10"
                        :action="'/api/home/upload/file/user'"
                        :file-list="parameters4.info.filelist10"
                        ref="gf_upload_filelist10"
                        :disabled="isGfFieldDisabled('filelist10')"
                        :on-exceed="(f,fl) => handleGfFileExceed(f,fl,'gf_upload_filelist10')"
                        accept=".pdf"
                        :before-upload="beforePdfUpload"
                        :limit="1"
                      >
                        <div class="form-upload-div">
                          <el-button size="small" class="el-icon-upload el-icon--left action_upload">点击上传PDF</el-button>
                          <div slot="tip" class="el-upload__tip">仅支持 pdf 格式，大小不超过 100MB</div>
                        </div>
                      </el-upload>
                    </div>
                    <div v-if="gfneed_opinions['filelist10']" class="gf-modify-opinion">修改意见：{{ gfneed_opinions['filelist10'] }}</div>
                  </div>
            
                  <!-- 11. 其他材料 -->
                  <div :class="gfneed_fields.indexOf('filelist11') != -1 ? 'my_form form_error_k' : 'my_form'">
                    <div class="dftitle form_title " style="padding-top:10px !important;padding-bottom:10px !important;">专利证书、成果获奖等其他佐证材料</div>
                    <div class="uploadcertificate">
                      <el-upload
                        class="upload-demo"
                        :action="'/api/home/upload/file/user'"
                        ref="gf_upload_filelist11"
                        :disabled="isGfFieldDisabled('filelist11')"
                        :on-exceed="(f,fl) => handleGfFileExceed(f,fl,'gf_upload_filelist11')"
                        :file-list="parameters4.info.filelist11"
                        :on-remove="handleOnRemove11"
                        :on-success="uploadSuccess11"
                        accept=".pdf"
                        :before-upload="beforePdfUpload"
                        :limit="1"
                      >
                        <div class="form-upload-div">
                          <el-button size="small" class="el-icon-upload el-icon--left action_upload">点击上传PDF</el-button>
                          <div slot="tip" class="el-upload__tip">仅支持 pdf 格式，大小不超过 100MB</div>
                        </div>
                      </el-upload>
                    </div>
                    <div v-if="gfneed_opinions['filelist11']" class="gf-modify-opinion">修改意见：{{ gfneed_opinions['filelist11'] }}</div>
                  </div>
            
                  <!-- 12. 汇总表（附件3） -->
                  <div :class="(gfneed_fields.indexOf('filelist1') != -1 || gfneed_fields.indexOf('filelist2') != -1) ? 'my_form form_error_k' : 'my_form'">
                    <div class="dftitle form_title " style="padding-top:10px !important;padding-bottom:10px !important;">
                      贵州省工程建设工法申报汇总表
                    </div>
                    <div class="uploadcertificate">
                      <el-upload
                        class="upload-demo"
                        :on-remove="handleOnRemove1"
                        :on-success="uploadSuccess1"
                        :action="'/api/home/upload/file/user'"
                        :file-list="parameters4.info.filelist1"
                        ref="gf_upload_filelist1"
                        :disabled="isGfFieldDisabled('filelist1')"
                        :on-exceed="(f,fl) => handleGfFileExceed(f,fl,'gf_upload_filelist1')"
                        accept=".pdf"
                        :before-upload="beforePdfUpload"
                        :limit="1"
                      >
                        <div class="form-upload-div">
                          <el-button size="small" class="el-icon-upload el-icon--left action_upload">点击上传PDF</el-button>
                          <div slot="tip" class="el-upload__tip">仅支持 pdf 格式，大小不超过 100MB</div>
                        </div>
                      </el-upload>
                      <div>
                         <a class="upload-file--file" target="_blank" href="/user/附件：工法申报汇总表.xlsx">
                                附件：工法申报汇总表.xlsx
                          </a> 
                      </div>
                    </div>
                    <div v-if="gfneed_opinions['filelist1']" class="gf-modify-opinion">修改意见：{{ gfneed_opinions['filelist1'] }}</div>
                    <div :class="gfneed_fields.indexOf('filelist2') != -1 ? 'uploadcertificate form_error_k' : 'uploadcertificate'">
                        <el-upload class="upload-demo" :on-remove="handleOnRemove2" :on-success="uploadSuccess2"
                          :action="'/api/home/upload/file/user'" :file-list="parameters4.info.filelist2" ref="gf_upload_filelist2" :disabled="isGfFieldDisabled('filelist2')" :on-exceed="(f,fl) => handleGfFileExceed(f,fl,'gf_upload_filelist2')" :limit="1"
                          accept=".excel,.xls,.xlt,.xlsx">
                          <div class="form-upload-div">
                            <el-button size="small" class="el-icon-upload el-icon--left action_upload"> 点击上传Excel
                            </el-button>
                            <div slot="tip" class="el-upload__tip">
                              仅支持Excel格式，大小不超过100mb
                            </div>
                          </div>
                        </el-upload>
                      </div>
                      <!--<div class="form_tip">-->
                      <!--  <el-tooltip content="除盖章后的PDF格式外另附EXCEL格式电子文档" style="color: indianred;" placement="top">-->
                      <!--    <li class="el-icon-info" style="margin-right:100px"></li>-->
                      <!--  </el-tooltip>-->
                      <!--</div>-->
                    </div>

                </el-tabs>
              </el-form>
            </div>


      </div>
      
      <div class="form_right" v-if="$route.query.title == '贵州省优秀施工企业'" id="exportPdf" ref="exportPdf">
        <div class="form_1" id="essinfo">
          <!-- title提示标题文字,background提示盒子背景色,border提示盒子左边边框颜色 -->
          <Tips title="基本信息" :background="essinfo ? '#EDF8F5' : '#FEF8EF'" :border="essinfo ? '#1ABF98' : '#FFB700'"
            :states="essinfo"></Tips>

            <el-form :model="ruleForm" :rules="rules" ref="ruleForm">
            <el-tabs style="margin-top: 16px" v-model="activeName" @tab-click="handleClick">
              <div class="my_form">
                <div class="form_title" style="height: 62px">企业名称</div>
                <div class="form_long form_long-1">
                      <input type="text" placeholder="点击输入" v-model="parameters1.essinfo.msg1" />
                </div>
              </div>
              <div class="my_form2">
                <div class="form_title" style="height: 62px">工商注册地址</div>
                <div class="form_long">
                  <input type="text"  placeholder="请输入" v-model="parameters1.essinfo.msg2" />
                </div>
              </div>
              <div class="flex">
                <div class="my_form">
                  <div class="form_title" style="height: 62px">法定代表人</div>
                  <div class="form_content">
                    <div class="input">
                      <input type="text" placeholder="点击输入" v-model="parameters1.essinfo.msg3" />
                    </div>
                  </div>
                </div>
                <div class="my_form2">
                  <div class="form_title" style="height: 62px">电话</div>
                  <div class="form_content">
                    <div class="input">
                      <input type="text" placeholder="点击输入" v-model="parameters1.essinfo.msg4" />
                    </div>
                  </div>
                </div>
              </div>
              <div class="flex">
                <div class="my_form">
                  <div class="form_title" style="height: 62px">联系人</div>
                  <div class="form_content">
                    <div class="input">
                      <input type="text" placeholder="点击输入" v-model="parameters1.essinfo.linker" />
                    </div>
                  </div>
                </div>
                <div class="my_form2">
                  <div class="form_title" style="height: 62px">联系电话</div>
                  <div class="form_content">
                    <div class="input">
                      <input type="text" placeholder="点击输入" v-model="parameters1.essinfo.tel" />
                    </div>
                  </div>
                </div>
              </div>
              <div class="flex">
                <div class="my_form2">
                  <div class="form_title" style="height: 62px">申报企业类别</div>
                  <div class="form_content">
                    <el-radio-group size="small" class="inpyabeb" v-model="parameters1.essinfo.msg5">
                    <el-radio label="1">施工总承包企业</el-radio>
                    <el-radio label="2">专业承包企业</el-radio>
                  </el-radio-group>
                  </div>
                </div>
                <div class="my_form">
                  <div class="form_title" style="height: 62px">申报时间</div>
                  <div class="form_content">
                    <div class="input">
                      <el-date-picker type="date" value-format="yyyy-MM-dd" format="yyyy-MM-dd" placeholder="选择日期"
                    class="inpyabeb" v-model="parameters1.essinfo.msg6"></el-date-picker>
                    </div>
                  </div>
                </div>
              </div>
              <div class="my_form">
                <div class="form_title" style="height: 188px; text-align: center">
                  企业申报意见
                </div>
                <div class="form_textarea">
                  <textarea name id cols="30" rows="10" placeholder="请输入"
                    v-model="parameters1.essinfo.msg7"></textarea>
                </div>
              </div>
              <div class="my_form2">
                <div class="form_title" style="height: 188px; text-align: center">
                  推荐意见（各市、州建筑业协会或企业主管部门）
                </div>
                <div class="form_textarea">
                  <textarea name id cols="30" rows="10" placeholder="请输入"
                    v-model="parameters1.essinfo.msg8"></textarea>
                </div>
              </div>
            </el-tabs>
          </el-form>
        </div>
        <div class="form_1" id="condition">
          <Tips title="基本条件" :background="condition ? '#EDF8F5' : '#FEF8EF'" :border="condition ? '#1ABF98' : '#FFB700'"
            :states="condition"></Tips>

            <el-form :model="ruleForm" :rules="rules" ref="ruleForm">
            <el-tabs style="margin-top: 16px" v-model="activeName" @tab-click="handleClick">

              <div class="flex">
                <div class="my_form">
                  <div class="form_title" style="height: 62px">主项资质及等级</div>
                  <div class="form_content">
                    <div class="input">
                      <input type="text" placeholder="点击输入" v-model="parameters1.condition.msg1" />
                    </div>
                  </div>
                </div>
                <div class="my_form2">
                  <div class="form_title" style="height: 62px">取得时间</div>
                  <div class="form_content">
                    <div class="input">
                      <el-date-picker type="date" value-format="yyyy-MM-dd" format="yyyy-MM-dd" placeholder="选择日期"
                    class="inpyabeb" v-model="parameters1.condition.msg2"></el-date-picker>
                    </div>
                  </div>
                </div>
              </div>
              <div class="flex">
                <div class="my_form2">
                  <div class="form_title" style="height: 128px">本年度和上一年度发生一般及以上工程质量安全事故及有关投诉</div>
                  <div class="form_content">
                    <el-radio-group size="small" class="inpyabeb" v-model="parameters1.condition.msg3">
                    <el-radio label="1">有</el-radio>
                    <el-radio label="0">无</el-radio>
                  </el-radio-group>
                  </div>
                </div>
                <div class="my_form">
                  <div class="form_title" style="height: 128px">本年度和上一年度存在拖欠农民工工资行为</div>
                  <div class="form_content">
                    <div class="input">
                      <el-radio-group size="small" class="inpyabeb" v-model="parameters1.condition.msg4">
                    <el-radio label="1">有</el-radio>
                    <el-radio label="0">无</el-radio>
                  </el-radio-group>
                    </div>
                  </div>
                </div>
              </div>

              <div class="flex">
                <div class="my_form">
                  <div class="form_title" style="height: 128px">本年度和上一年度存在失信、违法违规事件</div>
                  <div class="form_content">
                    <el-radio-group size="small" class="inpyabeb" v-model="parameters1.condition.msg5">
                    <el-radio label="1">有</el-radio>
                    <el-radio label="0">无</el-radio>
                  </el-radio-group>
                  </div>
                </div>
                <div class="my_form2">
                  <div class="form_title" style="height: 128px">本年度和上一年度存在恶意拖欠建筑业税收行为</div>
                  <div class="form_content">
                    <div class="input">
                      <el-radio-group size="small" class="inpyabeb" v-model="parameters1.condition.msg6">
                    <el-radio label="1">有</el-radio>
                    <el-radio label="0">无</el-radio>
                  </el-radio-group>
                    </div>
                  </div>
                </div>
              </div>

              <div class="flex">
                <div class="my_form2">
                  <div class="form_title" style="height: 128px">通过ISO9000系列三项管理体系认证</div>
                  <div class="form_content">
                    <el-radio-group size="small" class="inpyabeb" v-model="parameters1.condition.msg7">
                    <el-radio label="1">有</el-radio>
                    <el-radio label="0">无</el-radio>
                  </el-radio-group>
                  </div>
                </div>
                <div class="my_form">

                </div>
              </div>


            </el-tabs>
          </el-form>

        </div>
        <div class="form_1" id="Selection">
          <Tips title="评选指标" :background="Selection ? '#EDF8F5' : '#FEF8EF'" :border="Selection ? '#1ABF98' : '#FFB700'"
            :states="Selection"></Tips>


            <el-form :model="ruleForm" :rules="rules" ref="ruleForm">
            <el-tabs style="margin-top: 16px" v-model="activeName" @tab-click="handleClick">

              <div class="flex">
                <div class="my_form">
                  <div class="form_title" style="height: 62px">上一年度建筑业总产值</div>
                  <div class="form_content">
                    <div class="input">
                      <el-input placeholder="点击输入" v-model="parameters1.Selection.msg1">
                        <template slot="append">亿元</template>
                      </el-input>
                    </div>
                  </div>
                </div>
                <div class="my_form2">
                  <div class="form_title" style="height: 62px">上一年度省外（境外）完成的产值</div>
                  <div class="form_content">
                    <div class="input">
                      <el-input placeholder="点击输入" v-model="parameters1.Selection.msg2">
                        <template slot="append">亿元</template>
                      </el-input>
                    </div>
                  </div>
                </div>
              </div>

              <div class="flex">
                <div class="my_form2">
                  <div class="form_title" style="height: 62px">上一年度现金净流</div>
                  <div class="form_content">
                    <div class="input">
                      <el-input placeholder="点击输入" v-model="parameters1.Selection.msg3">
                        <template slot="append">亿元</template>
                      </el-input>
                    </div>
                  </div>
                </div>
                <div class="my_form">
                  <div class="form_title" style="height: 62px">上一年度净利润总额</div>
                  <div class="form_content">
                    <div class="input">
                      <el-input placeholder="点击输入" v-model="parameters1.Selection.msg4">
                        <template slot="append">亿元</template>
                      </el-input>
                    </div>
                  </div>
                </div>
              </div>

              <div class="flex">
                <div class="my_form">
                  <div class="form_title" style="height: 62px">近三年获得企业管理类奖项</div>
                  <div class="form_content">
                    <div class="input">
                      <el-input placeholder="点击输入" v-model="parameters1.Selection.msg5">
                        <template slot="append">项</template>
                      </el-input>
                    </div>
                  </div>
                </div>
                <div class="my_form2">
                  <div class="form_title" style="height: 62px">近三年获得省级及以上工程质量安全类奖项</div>
                  <div class="form_content">
                    <div class="input">
                      <el-input placeholder="点击输入" v-model="parameters1.Selection.msg6">
                        <template slot="append">项</template>
                      </el-input>
                    </div>
                  </div>
                </div>
              </div>

              <div class="flex">
                <div class="my_form2">
                  <div class="form_title" style="height: 62px">近三年获得新技术、绿色施工类奖项</div>
                  <div class="form_content">
                    <div class="input">
                      <el-input placeholder="点击输入" v-model="parameters1.Selection.msg7">
                        <template slot="append">项</template>
                      </el-input>
                    </div>
                  </div>
                </div>
                <div class="my_form">
                  <div class="form_title" style="height: 62px">近三年获得技术、专利类奖项</div>
                  <div class="form_content">
                    <div class="input">
                      <el-input placeholder="点击输入" v-model="parameters1.Selection.msg8">
                        <template slot="append">项</template>
                      </el-input>
                    </div>
                  </div>
                </div>
              </div>

            </el-tabs>
          </el-form>



        </div>
        <div class="form_1" id="Material">
          <Tips title="企业业绩材料" :background="parameters1.Material != '' && parameters1.Material != undefined ? '#EDF8F5'
              : '#FEF8EF'
          " :border="parameters1.Material != '' && parameters1.Material != undefined ? '#1ABF98' : '#FFB700'
" :states="
  parameters1.Material != '' && parameters1.Material != undefined
"></Tips>

                <div class="form_box_content">
              <div class="my_form">
                <div class="form_title" style="height: 188px; text-align: center">
                  企业业绩材料（文字部分）
                </div>
                <div class="form_textarea">


                  <div>
                    <el-popover
                    placement="top-start"
                    title=""
                    width="660"
                    trigger="hover"
                    content="内容应包括企业的基本情况、党的建设、精神文明建设、职工生活水平、企业建立现代企业制度、获奖情况、工程质量和安全生产情况、重视新技术开发和应用情况、无拖欠农民工工资情况等几个方面的业绩。">
                    <div  slot="reference" >
                      <i class="el-icon-caret-bottom" style="color:#FF989F;"></i>
                    </div>
                  </el-popover>
                  </div>

                  <textarea name id cols="30" rows="10" placeholder="请输入"
                    v-model="parameters1.Material"></textarea>
                </div>
              </div>
            </div>


        </div>
        <div class="form_1" id="Upload">
          <Tips title="上传附件" :background="enclosure ? '#EDF8F5' : '#FEF8EF'" :border="enclosure ? '#1ABF98' : '#FFB700'"
            :states="enclosure"></Tips>


            <div class="form_box_content">
              <div class="my_form">
                <div class="form_title" style="min-height: 100px">
                  企业营业执照扫描件
                </div>
                <div class="uploadinput">
                  <div class="uploadlist" style="margin-left:20px">
                    <el-upload style="display: flex;
                        align-items: center;
                        margin-left: 10px;
                      " :action="'/api/home/upload/file/user'"
                      :on-success="(value) => handenclosure('parameters1', 1, value)"
                      :on-remove="(value) => removeenclosure('parameters1', 1, value)" :before-upload="beforePdfUpload"
                      :file-list="parameters1.enclosure.msg1" :limit="1" accept=".pdf">
                      <el-button size="small" type="primary">点击上传</el-button>
                      <div slot="tip" style="margin-left: 10px" class="el-upload__tip" v-if="!parameters1.enclosure.msg1">
                        只能上传pdf文件，且不超过2MB
                      </div>
                    </el-upload>
                  </div>
                </div>
              </div>

              <div class="my_form">
                <div class="form_title" style="min-height: 100px">
                  企业资质证书扫描件
                </div>
                <div class="uploadinput">
                  <div class="uploadlist" style="margin-left:20px">
                    <el-upload style="
                        display: flex;
                        align-items: center;
                        margin-left: 10px;
                      " :action="'/api/home/upload/file/user'"
                      :on-success="(value) => handenclosure('parameters1', 2, value)"
                      :on-remove="(value) => removeenclosure('parameters1', 2, value)" :before-upload="beforePdfUpload"
                      :file-list="parameters1.enclosure.msg2" :limit="1" accept=".pdf">
                      <el-button size="small" type="primary">点击上传</el-button>
                      <div slot="tip" style="margin-left: 10px" class="el-upload__tip" v-if="!parameters1.enclosure.msg2">
                        只能上传pdf文件，且不超过2MB
                      </div>
                    </el-upload>
                  </div>
                </div>
              </div>

              <div class="my_form">
                <div class="form_title" style="min-height: 100px">
                  ISO9000系列三项管理体系认证证书扫描件
                </div>
                <div class="uploadinput">
                  <div class="uploadlist" style="margin-left:20px">
                    <el-upload style="
                        display: flex;
                        align-items: center;
                        margin-left: 10px;
                      " :action="'/api/home/upload/file/user'"
                      :on-success="(value) => handenclosure('parameters1', 3, value)"
                      :on-remove="(value) => removeenclosure('parameters1', 3, value)" :before-upload="beforePdfUpload"
                      :file-list="parameters1.enclosure.msg3" :limit="1" accept=".pdf">
                      <el-button size="small" type="primary">点击上传</el-button>
                      <div slot="tip" style="margin-left: 10px" class="el-upload__tip" v-if="!parameters1.enclosure.msg3">
                        只能上传pdf文件，且不超过2MB
                      </div>
                    </el-upload>
                  </div>
                </div>
              </div>

              <div class="my_form">
                <div class="form_title" style="min-height: 100px">
                  ISO9000系列三项管理体系认证证书扫描件
                </div>
                <div class="uploadinput">
                  <div class="uploadlist" style="margin-left:20px">
                    <el-upload style="
                        display: flex;
                        align-items: center;
                        margin-left: 10px;
                      " :action="'/api/home/upload/file/user'"
                      :on-success="(value) => handenclosure('parameters1', 4, value)"
                      :on-remove="(value) => removeenclosure('parameters1', 4, value)" :before-upload="beforePdfUpload"
                      :file-list="parameters1.enclosure.msg4" :limit="1" accept=".pdf">
                      <el-button size="small" type="primary">点击上传</el-button>
                      <div slot="tip" style="margin-left: 10px" class="el-upload__tip" v-if="!parameters1.enclosure.msg4">
                        只能上传pdf文件，且不超过2MB
                      </div>
                    </el-upload>
                  </div>
                </div>
              </div>

              <div class="my_form">
                <div class="form_title" style="min-height: 100px">
                  ISO9000系列三项管理体系认证证书扫描件
                </div>
                <div class="uploadinput">
                  <div class="uploadlist" style="margin-left:20px">
                    <el-upload style="
                        display: flex;
                        align-items: center;
                        margin-left: 10px;
                      " :action="'/api/home/upload/file/user'"
                      :on-success="(value) => handenclosure('parameters1', 5, value)"
                      :on-remove="(value) => removeenclosure('parameters1', 5, value)" :before-upload="beforePdfUpload"
                      :file-list="parameters1.enclosure.msg5" :limit="1" accept=".pdf">
                      <el-button size="small" type="primary">点击上传</el-button>
                      <div slot="tip" style="margin-left: 10px" class="el-upload__tip" v-if="!parameters1.enclosure.msg5">
                        只能上传pdf文件，且不超过2MB
                      </div>
                    </el-upload>
                  </div>
                </div>
              </div>

              <div class="my_form">
                <div class="form_title" style="min-height: 100px">
                  企业法人承诺书（原件） 内容应包括：1、申报资料真实有效。2、本年度和上一年度没有发生一般及以上工程质量安全事故及有关投诉，无拖欠农民工工资、建筑业税收行为、无失信、违法违规事件(复印件)
                </div>
                <div class="uploadinput">
                  <div class="uploadlist" style="margin-left:20px">
                    <el-upload style="
                        display: flex;
                        align-items: center;
                        margin-left: 10px;
                      " :action="'/api/home/upload/file/user'"
                      :on-success="(value) => handenclosure('parameters1', 6, value)"
                      :on-remove="(value) => removeenclosure('parameters1', 6, value)" :before-upload="beforePdfUpload"
                      :file-list="parameters1.enclosure.msg6" :limit="1" accept=".pdf">
                      <el-button size="small" type="primary">点击上传</el-button>
                      <div slot="tip" style="margin-left: 10px" class="el-upload__tip" v-if="!parameters1.enclosure.msg6">
                        只能上传pdf文件，且不超过2MB
                      </div>
                    </el-upload>
                  </div>
                </div>
              </div>

              <div class="my_form">
                <div class="form_title" style="min-height: 100px">
                  近三年获得企业管理类奖项
                </div>
                <div class="uploadinput">
                  <div class="uploadlist" style="margin-left:20px">
                    <el-upload style="
                        display: flex;
                        align-items: center;
                        margin-left: 10px;
                      " :action="'/api/home/upload/file/user'"
                      :on-success="(value) => handenclosure('parameters1', 7, value)"
                      :on-remove="(value) => removeenclosure('parameters1', 7, value)" :before-upload="beforePdfUpload"
                      :file-list="parameters1.enclosure.msg7" :limit="1" accept=".pdf">
                      <el-button size="small" type="primary">点击上传</el-button>
                      <div slot="tip" style="margin-left: 10px" class="el-upload__tip" v-if="!parameters1.enclosure.msg7">
                        只能上传pdf文件，且不超过15MB
                      </div>
                    </el-upload>
                  </div>
                </div>
              </div>

              <div class="my_form">
                <div class="form_title" style="min-height: 100px">
                  近三年获得省级及以上工程质量安全类奖项
                </div>
                <div class="uploadinput">
                  <div class="uploadlist" style="margin-left:20px">
                    <el-upload style="
                        display: flex;
                        align-items: center;
                        margin-left: 10px;
                      " :action="'/api/home/upload/file/user'"
                      :on-success="(value) => handenclosure('parameters1', 8, value)"
                      :on-remove="(value) => removeenclosure('parameters1', 8, value)" :before-upload="beforePdfUpload"
                      :file-list="parameters1.enclosure.msg8" :limit="1" accept=".pdf">
                      <el-button size="small" type="primary">点击上传</el-button>
                      <div slot="tip" style="margin-left: 10px" class="el-upload__tip" v-if="!parameters1.enclosure.msg8">
                        只能上传pdf文件，且不超过50MB
                      </div>
                    </el-upload>
                  </div>
                </div>
              </div>

              <div class="my_form">
                <div class="form_title" style="min-height: 100px">
                  近三年获得新技术、绿色施工类奖项
                </div>
                <div class="uploadinput">
                  <div class="uploadlist" style="margin-left:20px">
                    <el-upload style="
                        display: flex;
                        align-items: center;
                        margin-left: 10px;
                      " :action="'/api/home/upload/file/user'"
                      :on-success="(value) => handenclosure('parameters1', 9, value)"
                      :on-remove="(value) => removeenclosure('parameters1', 9, value)" :before-upload="beforePdfUpload"
                      :file-list="parameters1.enclosure.msg9" :limit="1" accept=".pdf">
                      <el-button size="small" type="primary">点击上传</el-button>
                      <div slot="tip" style="margin-left: 10px" class="el-upload__tip" v-if="!parameters1.enclosure.msg9">
                        只能上传pdf文件，且不超过15MB
                      </div>
                    </el-upload>
                  </div>
                </div>
              </div>

              <div class="my_form">
                <div class="form_title" style="min-height: 100px">
                  近三年获得技术、专利类奖项
                </div>
                <div class="uploadinput">
                  <div class="uploadlist" style="margin-left:20px">
                    <el-upload style="
                        display: flex;
                        align-items: center;
                        margin-left: 10px;
                      " :action="'/api/home/upload/file/user'"
                      :on-success="handenclosure2"
                      :on-remove="removeenclosure2" :before-upload="beforePdfUpload"
                      :file-list="parameters1.enclosure.msg10"
                      :limit="2"
                      :multiple="true"
                      accept=".pdf">
                      <el-button size="small" type="primary">点击上传</el-button>
                      <div slot="tip" style="margin-left: 10px" class="el-upload__tip" v-if="!parameters1.enclosure.msg10.length">
                        <div style="text-align: left;">只能上传pdf文件，且不超过80MB

                        <br/>
                         为减轻后台存储压力，请将文档压缩后上传；如需上传两个文件，请再次点击上传按钮即可
                        </div>
                      </div>
                    </el-upload>
                  </div>
                </div>
              </div>

              <div class="my_form">
                <div class="form_title" style="min-height: 100px">
                  上一年度企业财务审计报表扫描件
                </div>
                <div class="uploadinput">
                  <div class="uploadlist" style="margin-left:20px">
                    <el-upload style="
                        display: flex;
                        align-items: center;
                        margin-left: 10px;
                      " :action="'/api/home/upload/file/user'"
                      :on-success="(value) => handenclosure('parameters1', 11, value)"
                      :on-remove="(value) => removeenclosure('parameters1', 11, value)" :before-upload="beforePdfUpload"
                      :file-list="parameters1.enclosure.msg11" :limit="1" accept=".pdf">
                      <el-button size="small" type="primary">点击上传</el-button>
                      <div slot="tip" style="margin-left: 10px" class="el-upload__tip" v-if="!parameters1.enclosure.msg11">
                        只能上传pdf文件，且不超过15MB
                      </div>
                    </el-upload>
                  </div>
                </div>
              </div>

              <div class="my_form">
                <div class="form_title" style="min-height: 100px">
                  贵州省优秀施工企业申报表
                </div>
                <div class="uploadinput">
                  <div class="uploadlist" style="margin-left:20px">
                    <el-upload style="display: flex;
                        align-items: center;
                        margin-left: 10px;
                      " :action="'/api/home/upload/file/user'"
                      :on-success="(value) => handenclosure('parameters1', 12, value)"
                      :on-remove="(value) => removeenclosure('parameters1', 12, value)" :before-upload="beforePdfUpload"
                      :file-list="parameters1.enclosure.msg12" :limit="1" accept=".pdf">
                      <el-button size="small" type="primary">点击上传</el-button>
                      <div slot="tip" style="margin-left: 10px" class="el-upload__tip" v-if="!parameters1.enclosure.msg12">
                        只能上传pdf文件，且不超过15MB
                      </div>
                    </el-upload>
                  </div>
                </div>
              </div>

          </div>
        </div>
      </div>
      <div class="form_right" v-if="$route.query.title == '2021年半年报' || $route.query.title == '2021年度年报'" id="exportPdf"
        ref="exportPdf">
        <div class="form_1">
          <Tips title="填表须知" background="#FEF8EF" border="#FEF8EF" :states="false"></Tips>
          <div class="form_box_content" style="text-align: start; font-size: 14px; color: #0c0d0f">
            <p>
              1、本企业郑重承诺所填数据皆为真实数据，无不实、捏造、造假情况，对上传所有内容负责；<br />
              2、注册类人员包括一、二级注册建造师、注册造价师、注册监理工程师、注册安全工程师、注册会计师。（若一人有多种执业资格，只计算一次）<br />
              3、中、高级技工指企业内从事相关工种，包括瓦工、钢筋工、混凝土工、抹灰工、防水工、管道工、水暖工、测量放线工、木工、电焊工、油漆工、安装起重工、电气设备安装调试工、工程机械维修工、中小型机械操作工等，经市级以上建筑职业技能岗位主管部门培训考核，取得中级技工及以上级别的人员。<br />
              4、所有内容只限于调研分析所用，将会严格保密。在填写过程中有任何疑问请致电：0851-85360455；<br />
            </p>
          </div>
        </div>
        <div class="form_1">
          <Tips title="企业概况" background="#FEF8EF" border="#FEF8EF" :states="false"></Tips>
          <div class="my_form" style="margin-top: 20px">
            <div class="form_title" style="height: 62px">企业全称</div>
            <div class="form_long">
              <input placeholder="请输入" type="text" />
            </div>
          </div>
          <div class="my_form2">
            <div class="form_title" style="height: 62px">注册地址</div>
            <div class="form_long">
              <input placeholder="请输入" type="text" />
            </div>
          </div>
          <div class="flex">
            <div class="my_form">
              <div class="form_title" style="height: 62px">填表人</div>
              <div class="form_content">
                <div class="input">
                  <input type="text" placeholder="请输入" />
                </div>
              </div>
            </div>
            <div class="my_form">
              <div class="form_title" style="height: 62px">联系电话</div>
              <div class="form_content">
                <div class="input">
                  <input type="text" placeholder="请输入" />
                </div>
              </div>
            </div>
          </div>
          <div class="flex">
            <div class="my_form2">
              <div class="form_title" style="height: 62px">企业性质</div>
              <div class="form_content">
                <div class="input">
                  <input type="text" placeholder="请输入" />
                </div>
              </div>
            </div>
            <div class="my_form2">
              <div class="form_title" style="height: 62px">
                企业资质类型及等级
              </div>
              <div class="form_content">
                <div class="input">
                  <input type="text" placeholder="请输入" />
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="form_1">
          <Tips title="企业生产经营情况" background="#FEF8EF" border="#FEF8EF" :states="false"></Tips>
          <div class="flex" style="margin-top: 20px">
            <div class="my_form2 my_form2min">
              <div class="form_title">完成总产值</div>
              <div class="form_content">
                <div class="input">
                  <input placeholder="请输入" type="text" />
                  <span>亿元</span>
                </div>
              </div>
            </div>
            <div class="my_form2 my_form2min">
              <div class="form_title">应收账款</div>
              <div class="form_content">
                <div class="input">
                  <input placeholder="请输入" type="text" />
                  <span>亿元</span>
                </div>
              </div>
            </div>
            <div class="my_form2 my_form2min">
              <div class="form_title">现金流</div>
              <div class="form_content">
                <div class="input">
                  <input type="text" placeholder="请输入" />
                  <span>亿元</span>
                </div>
              </div>
            </div>
          </div>
          <div class="flex">
            <div class="my_form my_formmin">
              <div class="form_title">实现利润</div>
              <div class="form_content">
                <div class="input">
                  <input type="text" placeholder="请输入" />
                  <span>亿元</span>
                </div>
              </div>
            </div>
            <div class="my_form my_formmin">
              <div class="form_title">总资产</div>
              <div class="form_content">
                <div class="input">
                  <input type="text" placeholder="请输入" />
                  <span>亿元</span>
                </div>
              </div>
            </div>
            <div class="my_form my_formmin">
              <div class="form_title">资产负债率</div>
              <div class="form_content">
                <div class="input">
                  <input type="text" placeholder="请输入" />
                  <span>%</span>
                </div>
              </div>
            </div>
          </div>
          <div class="form_title">
            <p style="text-align: start; margin: 20px 0">业务结构</p>
          </div>
          <div class="flex">
            <div class="my_form2 my_form2min">
              <div class="form_title">建筑施工</div>
              <div class="form_content">
                <div class="input">
                  <input type="text" placeholder="请输入" />
                  <span>亿元</span>
                </div>
              </div>
            </div>
          </div>
          <div class="bord">
            <img src="@/assets/51@2x.png" alt="" />
          </div>
          <div class="flex">
            <div class="my_form my_formmin">
              <div class="form_title">住宅类项目</div>
              <div class="form_content">
                <div class="input">
                  <input type="text" placeholder="请输入" />
                  <span>亿元</span>
                </div>
              </div>
            </div>
            <div class="my_form my_formmin">
              <div class="form_title">公共类项目</div>
              <div class="form_content">
                <div class="input">
                  <input type="text" placeholder="请输入" />
                  <span>亿元</span>
                </div>
              </div>
            </div>
            <div class="my_form my_formmin">
              <div class="form_title">工业类项目</div>
              <div class="form_content">
                <div class="input">
                  <input type="text" placeholder="请输入" />
                  <span>亿元</span>
                </div>
              </div>
            </div>
          </div>
          <div class="flex">
            <div class="my_form2 my_form2min">
              <div class="form_title">装配式混凝土项目</div>
              <div class="form_content">
                <div class="input">
                  <input type="text" placeholder="请输入" />
                  <span>万平方米</span>
                </div>
                <div class="input">
                  <input type="text" placeholder="请输入" />
                  <span>亿元</span>
                </div>
              </div>
            </div>
            <div class="my_form2 my_form2min">
              <div class="form_title">装配式钢结构项目</div>
              <div class="form_content">
                <div class="input">
                  <input type="text" placeholder="请输入" />
                  <span>万平方米</span>
                </div>
                <div class="input">
                  <input type="text" placeholder="请输入" />
                  <span>亿元</span>
                </div>
              </div>
            </div>
          </div>
          <div class="flex" style="margin-top: 20px">
            <div class="my_form my_formmin">
              <div class="form_title">市政施工</div>
              <div class="form_content">
                <div class="input">
                  <input type="text" placeholder="请输入" />
                  <span>亿元</span>
                </div>
              </div>
            </div>
          </div>
          <div class="bord">
            <img src="@/assets/51@2x.png" alt="" />
          </div>
          <div class="flex">
            <div class="my_form2 my_form2min">
              <div class="form_title">城市道路项目</div>
              <div class="form_content">
                <div class="input">
                  <input type="text" placeholder="请输入" />
                  <span>亿元</span>
                </div>
              </div>
            </div>
            <div class="my_form2 my_form2min">
              <div class="form_title">轨道交通项目</div>
              <div class="form_content">
                <div class="input">
                  <input type="text" placeholder="请输入" />
                  <span>亿元</span>
                </div>
              </div>
            </div>
            <div class="my_form2 my_form2min">
              <div class="form_title">地下管廊（线）项目</div>
              <div class="form_content">
                <div class="input">
                  <input type="text" placeholder="请输入" />
                  <span>亿元</span>
                </div>
              </div>
            </div>
          </div>
          <div class="flex" style="height: 62px">
            <div class="my_form my_formmin">
              <div class="form_title">绿化景观项目</div>
              <div class="form_content">
                <div class="input">
                  <input type="text" placeholder="请输入" />
                  <span>亿元</span>
                </div>
              </div>
            </div>
            <div class="my_form my_formmin">
              <div class="form_title">污水（垃圾）处理项目</div>
              <div class="form_content">
                <div class="input">
                  <input type="text" placeholder="请输入" />
                  <span>亿元</span>
                </div>
              </div>
            </div>
            <div class="my_form my_formmin">
              <div class="form_title">其他项目</div>
              <div class="form_content">
                <div class="input">
                  <input type="text" placeholder="请输入" />
                  <span>亿元</span>
                </div>
              </div>
            </div>
          </div>
          <div class="flex" style="height: 111px; margin-top: 20px">
            <div class="my_form2 my_formmin">
              <div class="form_title">房地产开发</div>
              <div class="form_content">
                <div class="input">
                  <input type="text" placeholder="请输入" />
                  <span>亿元</span>
                </div>
                <div class="input">
                  <input type="text" placeholder="请输入" />
                  <span>亿元</span>
                </div>
              </div>
            </div>
            <div class="my_form2 my_formmin">
              <div class="form_title">铁路施工</div>
              <div class="form_content">
                <div class="input">
                  <input type="text" placeholder="请输入" />
                  <span>亿元</span>
                </div>
              </div>
            </div>
            <div class="my_form2 my_formmin">
              <div class="form_title">公路施工</div>
              <div class="form_content">
                <div class="input">
                  <input type="text" placeholder="请输入" />
                  <span>亿元</span>
                </div>
              </div>
            </div>
          </div>
          <div class="flex" style="height: 62px">
            <div class="my_form my_formmin">
              <div class="form_title">电力施工</div>
              <div class="form_content">
                <div class="input">
                  <input type="text" placeholder="请输入" />
                  <span>亿元</span>
                </div>
              </div>
            </div>
            <div class="my_form my_formmin">
              <div class="form_title">煤炭施工</div>
              <div class="form_content">
                <div class="input">
                  <input type="text" placeholder="请输入" />
                  <span>亿元</span>
                </div>
              </div>
            </div>
            <div class="my_form my_formmin">
              <div class="form_title">冶金施工</div>
              <div class="form_content">
                <div class="input">
                  <input type="text" placeholder="请输入" />
                  <span>亿元</span>
                </div>
              </div>
            </div>
          </div>
          <div class="flex" style="height: 62px">
            <div class="my_form2 my_formmin">
              <div class="form_title">石油化工施工</div>
              <div class="form_content">
                <div class="input">
                  <input type="text" placeholder="请输入" />
                  <span>亿元</span>
                </div>
              </div>
            </div>
            <div class="my_form2 my_formmin">
              <div class="form_title">建材装饰施工</div>
              <div class="form_content">
                <div class="input">
                  <input type="text" placeholder="请输入" />
                  <span>亿元</span>
                </div>
              </div>
            </div>
            <div class="my_form2 my_formmin">
              <div class="form_title">水利施工</div>
              <div class="form_content">
                <div class="input">
                  <input type="text" placeholder="请输入" />
                  <span>亿元</span>
                </div>
              </div>
            </div>
          </div>
          <div class="flex" style="height: 111px; margin-top: 20px">
            <div class="my_form my_formmin">
              <div class="form_title">海外项目</div>
              <div class="form_content">
                <div class="input">
                  <input type="text" placeholder="请输入" />
                  <span>亿元</span>
                </div>
              </div>
            </div>
            <div class="my_form my_formmin">
              <div class="form_title">PPP项目数量及投资额</div>
              <div class="form_content">
                <div class="input">
                  <input type="text" placeholder="请输入" />
                  <span>亿元</span>
                </div>
                <div class="input">
                  <input type="text" placeholder="请输入" />
                  <span>亿元</span>
                </div>
              </div>
            </div>
            <div class="my_form my_formmin">
              <div class="form_title">其他</div>
              <div class="form_content">
                <div class="input">
                  <input type="text" placeholder="请输入" />
                  <span>亿元</span>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="form_1">
          <Tips title="企业生产经营情况" background="#FEF8EF" border="#FEF8EF" :states="false"></Tips>
          <div class="flex" style="margin-top: 20px">
            <div class="my_form2 my_form2min">
              <div class="form_title">获得国家级奖项数量</div>
              <div class="form_content">
                <div class="input">
                  <input placeholder="请输入" type="text" />
                  <span>个</span>
                </div>
              </div>
            </div>
          </div>
          <div class="my_form">
            <div class="form_title" style="height: 188px; text-align: center">
              获得国家级奖项名称
            </div>
            <div class="form_textarea">
              <textarea name id cols="30" rows="10" placeholder="请输入"></textarea>
            </div>
          </div>
          <div class="flex" style="margin-top: 20px">
            <div class="my_form2 my_form2min">
              <div class="form_title">获得省、市级奖项数量</div>
              <div class="form_content">
                <div class="input">
                  <input placeholder="请输入" type="text" />
                  <span>个</span>
                </div>
              </div>
            </div>
          </div>
          <div class="my_form">
            <div class="form_title" style="height: 188px; text-align: center">
              获得省、市级奖项名称
            </div>
            <div class="form_textarea">
              <textarea name id cols="30" rows="10" placeholder="请输入"></textarea>
            </div>
          </div>
          <div class="flex" style="margin-top: 20px">
            <div class="my_form2 my_form2min">
              <div class="form_title">获得专利数量</div>
              <div class="form_content">
                <div class="input">
                  <input placeholder="请输入" type="text" />
                  <span>个</span>
                </div>
              </div>
            </div>
          </div>
          <div class="my_form">
            <div class="form_title" style="height: 188px; text-align: center">
              发明专利名称
            </div>
            <div class="form_textarea">
              <textarea name id cols="30" rows="10" placeholder="请输入"></textarea>
            </div>
          </div>
          <div class="my_form2">
            <div class="form_title" style="height: 188px; text-align: center">
              实用新型名称
            </div>
            <div class="form_textarea">
              <textarea name id cols="30" rows="10" placeholder="请输入"></textarea>
            </div>
          </div>
          <div class="flex" style="height: 111px; margin-top: 20px">
            <div class="my_form my_formmin">
              <div class="form_title">高新技术及科技研发投入</div>
              <div class="form_content">
                <div class="input">
                  <input type="text" placeholder="请输入" />
                  <span>万元</span>
                </div>
              </div>
            </div>
            <div class="my_form my_formmin">
              <div class="form_title">技术中心级别和数量</div>
              <div class="form_content">
                <div class="input">
                  <input type="text" placeholder="请输入" />
                  <span></span>
                </div>
                <div class="input">
                  <input type="text" placeholder="请输入" />
                  <span>个</span>
                </div>
              </div>
            </div>
            <div class="my_form my_formmin">
              <div class="form_title">行政管理人员数量</div>
              <div class="form_content">
                <div class="input">
                  <input type="text" placeholder="请输入" />
                  <span>人</span>
                </div>
              </div>
            </div>
          </div>
          <div class="flex" style="height: 62px">
            <div class="my_form2 my_formmin">
              <div class="form_title">接收应届毕业生数量</div>
              <div class="form_content">
                <div class="input">
                  <input type="text" placeholder="请输入" />
                  <span>人</span>
                </div>
              </div>
            </div>
            <div class="my_form2 my_formmin">
              <div class="form_title">专职科技研发人员数量</div>
              <div class="form_content">
                <div class="input">
                  <input type="text" placeholder="请输入" />
                  <span>人</span>
                </div>
              </div>
            </div>
            <div class="my_form2 my_formmin">
              <div class="form_title">院士数量</div>
              <div class="form_content">
                <div class="input">
                  <input type="text" placeholder="请输入" />
                  <span>人</span>
                </div>
              </div>
            </div>
          </div>
          <div class="flex" style="height: 62px">
            <div class="my_form my_formmin">
              <div class="form_title">技能大师数量</div>
              <div class="form_content">
                <div class="input">
                  <input type="text" placeholder="请输入" />
                  <span>人</span>
                </div>
              </div>
            </div>
            <div class="my_form my_formmin">
              <div class="form_title">博士学历人员数量</div>
              <div class="form_content">
                <div class="input">
                  <input type="text" placeholder="请输入" />
                  <span>人</span>
                </div>
              </div>
            </div>
            <div class="my_form my_formmin">
              <div class="form_title">硕士学历人员数量</div>
              <div class="form_content">
                <div class="input">
                  <input type="text" placeholder="请输入" />
                  <span>人</span>
                </div>
              </div>
            </div>
          </div>
          <div class="flex" style="height: 62px">
            <div class="my_form2 my_formmin">
              <div class="form_title">注册类人员数量</div>
              <div class="form_content">
                <div class="input">
                  <input type="text" placeholder="请输入" />
                  <span>人</span>
                </div>
              </div>
            </div>
            <div class="my_form2 my_formmin">
              <div class="form_title">中、高级职称人员数量</div>
              <div class="form_content">
                <div class="input">
                  <input type="text" placeholder="请输入" />
                  <span>人</span>
                </div>
              </div>
            </div>
            <div class="my_form2 my_formmin">
              <div class="form_title">中、高级技工数量</div>
              <div class="form_content">
                <div class="input">
                  <input type="text" placeholder="请输入" />
                  <span>人</span>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="form_1">
          <Tips title="上传附件" background="#FEF8EF" border="#FEF8EF" :states="false"></Tips>
          <div class="my_form2">
            <div class="form_title" style="height: 100px">上传附件</div>
            <div class="uploadcertificate">
              <el-upload class="upload-demo" :action="'/api/home/upload/file/user'" :file-list="[filelist]"
                accept=".pdf" :before-upload="beforePdfUpload">
                <el-button size="small" type="primary">点击上传</el-button>
                <div slot="tip" class="el-upload__tip">
                  仅支持pdf格式，大小不超过100mb
                </div>
              </el-upload>
            </div>
          </div>
        </div>
      </div>
      
    </div>
    <Footer />
  </div>
</template>

<script>
import { SaveDraft, SaveBDraft, Draftrecord,Draftrecord2, Declare, DeclareDetails, Declare_modify } from "../utils/api";
import Footer from "../components/Footer";
import MyForm from "../components/Modal/my_form";
import Tips from "../components/Modal/tips"; //提示组件
import GreenProjcet from '../components/fromProjcet/greenProject.vue'
import GroupAward from './applyAward/groupAward.vue'
import {
  PROVINCE_OPTIONS,
  REQUIRED_UPLOAD_FIELDS,
  ensureGongfaEnterpriseInfo,
  getGongfaSubmitSuccessOptions,
  isValidMobile,
  normalizeGongfaAuthorNames,
  validateGongfaEnterpriseInfo,
} from '../utils/gongfaEnterprise'
export default {
  components: {
    Tips,
    MyForm,
    Footer,
    GreenProjcet,
    GroupAward
  },
  data() {
    return {
      btnSaveStatus: false,
      currentSubmit: false,
      enclosure: false,//贵州省优秀施工企业 上传附件是否传完
      candidatefileimg: [],//贵州省优秀施工企业 照片
      essinfo: false,//贵州省优秀施工企业 基本信息是否填完
      condition: false,//贵州省优秀施工企业 基本条件是否填完
      Selection: false,//贵州省优秀施工企业 评选指标是否填完
      tipserror: 0,
      form: {
        type: [],
      },
      gongfaProvinceOptions: PROVINCE_OPTIONS,
      islist: "0",
      ruleForm: {
        name: "",
        contact_number: "",
        unified_social_credit_code: "",
        enterprise_nature: "",
        economic_type: "",
        is_list: 0,
        token: "",
        established_time: "",
        registered_capital: "",
        legal_representative: "",
        legal_representative_id: "", //法定身份证号
        // Social_name:'',//社会组织名称
        other_phone: "", //法人电话
        job: "", //本组织现任职务
        is_secretary_general: "", //是否秘书长
        is_representative: "", //是否法定代表人
        political_outlook: "", //政治面貌
        education_degree: "", //文化程度
        is_social_worker: "", //是否社工师
        is_employees: "", //是否本组织从业人员
        professional_qualification_level: "", //职业资格水平
        business_license: "",
        is_show: "",
        party_posts: "", //本组织党内职务
        company: "", //党组织关系所在单位
        introduce: "", //基本介绍
        head_portrait: "", //企业标识图
        certifications: "",//上传资质证书
        address: "", //企业地址
      },
      rules: {
        name: [
          {
            required: true,
            message: "请输入企业名称",
            trigger: "blur",
          },
          {
            min: 2,
            max: 16,
            message: "长度在 2 到 16 个字符",
            trigger: "blur",
          },
        ],
        introduce: [
          {
            required: true,
            message: "请输入单位的基本介绍文字...",
            trigger: "change",
          },
        ],
        party_posts: [
          {
            required: true,
            message: "请选择本组织党内职务",
            trigger: "change",
          },
        ],
        company: [
          {
            required: true,
            message: "请输入党组织关系所在单位",
            trigger: "change",
          },
        ],
        professional_qualification_level: [
          {
            required: true,
            message: "请选择职业资格水平",
            trigger: "change",
          },
        ],
        is_employees: [
          {
            required: true,
            message: "是否本组织从业人员",
            trigger: "change",
          },
        ],
        is_social_worker: [
          {
            required: true,
            message: "是否社工师",
            trigger: "change",
          },
        ],
        political_outlook: [
          {
            required: true,
            message: "请选择政治面貌",
            trigger: "change",
          },
        ],
        education_degree: [
          {
            required: true,
            message: "请选择文化程度",
            trigger: "change",
          },
        ],
        contact_number: [
          {
            required: true,
            message: "请输入联系电话",
            trigger: "change",
          },
        ],
        unified_social_credit_code: [
          {
            required: true,
            message: "请输入统一社会信用代码",
            trigger: "change",
          },
        ],
        enterprise_nature: [
          {
            required: true,
            message: "请选择企业性质",
            trigger: "change",
          },
        ],
        economic_type: [
          {
            required: true,
            message: "请选择经济类型",
            trigger: "change",
          },
        ],
        is_list: [
          {
            required: true,
            message: "请选择是否上市",
            trigger: "change",
          },
        ],
        established_time: [
          {
            type: "string",
            required: true,
            message: "请选择成立日期",
            trigger: "change",
          },
        ],
        registered_capital: [
          {
            required: true,
            message: "请输入注册资本/万",
            trigger: "change",
          },
        ],
        legal_representative: [
          {
            // type: 'array',
            required: true,
            message: "请输入发定代表人",
            trigger: "change",
          },
        ],
        legal_representative_id: [
          {
            required: true,
            message: "请输入法人身份证",
            trigger: "change",
          },
        ],
        // Social_name:[{
        // 	required: true,
        // 	message: '请输入社会组织名称',
        // 	trigger: 'change'
        // }],
        other_phone: [
          {
            required: true,
            message: "请输入法定代表人或指定代表手机号码",
            trigger: "change",
          },
        ],
        job: [
          {
            required: true,
            message: "请选择本组织现任职务（按最高职务）",
            trigger: "change",
          },
        ],
        is_secretary_general: [
          {
            required: true,
            message: "是否任本组织秘书长",
            trigger: "change",
          },
        ],
        is_representative: [
          {
            required: true,
            message: "是否任本组织法定代表人",
            trigger: "change",
          },
        ],
        business_license: [
          {
            required: true,
            message: "请上传营业执照",
            trigger: "change",
          },
        ],
        is_show: [
          {
            required: true,
            message: "请选择是否展示",
            trigger: "change",
          },
        ],
      },
      rId: 0,//记录id
      SupplementaryContent: {},
      dialogVisible: false,
      dialogImageUrl: "",
      Businesslicense: [],
      filechangelist2: {},
      filechangelist: {},
      Contractorinfo: {},
      ProjectOverview: {},
      DeclarationSummary: {},
      Recommendationform: false,
      Informationparticipatingunits: {},
      lefttitlelist: [],
      fileList: [],
      Tipstates: false,
      Tipsbackground: "#FEF8EF",
      Tipsborder: "#FFB700",
      is_list: "",
      count: 1,
      oldcount: 1,
      states: 6,
      limit: 1,
      issumbit: true,
      parameters: {},
      parameters1: {
        essinfo: {},
        Material: {},
        condition: {},
        Selection: {},
        enclosure: {
          msg10:[],
        }
      },
      parameters2: {
        essinfo: {},
        candidate: {},
        Typicaldeeds: {},
        enclosure: {}
      },
      parameters3: {
        info: {},
        Indicators: {},
        ProjectOverview: {},
        Upload: {
          GreenConstruction: [],
          GreenDeclarationForm: []
        }
      },
      parameters4: {
        info: {
          type_of_work: 0,
          type_of_major: 0,
          gf_province:"1",
          name: "",
          unit: "",
          phone: "",
          username:"",
          tel: "",
          gf_province_detail: "",
          text_public_authorized: "",
          author_names: [
            {
              name: "",
              starttime: "",
            },
          ],
          filelist1: [],
          filelist2: [],
          filelist3: [],
          filelist4: [],
          filelist5: [],
          filelist6: [],
          filelist7: [],
          filelist8: [],
          filelist9: [],
          filelist10: [],
          filelist11: [],
          filelist12: [],
          filelist_commitment: [],
        }
      },
      // 工法照片/视频一次只允许上传一个文件，避免并发上传造成列表状态错乱。
      mediaUploading: false,
      type_work_arr: [
        "房屋建筑工程",
        "土木工程",
        "工业安装工程",
      ],
      type_major_arr: [
        "地基与基础",
        "主体结构",
        "钢结构",
        "装饰与屋面",
        "水电与智能",
        "其它",
      ],
      type_major_arr1: [
        "地基与基础",
        "主体结构",
        "钢结构",
        "装饰与屋面",
        "水电与智能",
        "其它",
      ],
      type_major_arr2: [
        "公路",
        "铁路",
        "隧道",
        "桥梁",
        "堤坝与电站",
        "矿山",
        "其他",

      ],
      type_major_arr3: [
        "工业设备",
        "工业管道",
        "电气装置与自动化",
        "其它",
      ],
      activeName: '',
      gfneed_fields:[],
      gfneed_opinions: {},
      isGongfaReturnModify: false, // 是否是退回修改状态（撤回时为false，允许编辑所有字段）
      reject_reason:'',
      return_type:'',
      modify_deadline:'',
      gongfaPhoneError:''
    };
  },
  async created() {
    var _this = this;
    let res; 
    switch (_this.$route.query.title) {
      case "贵州省建筑业优秀项目经理":
        _this.lefttitlelist = [
          { name: "申报单位", isok: false, id: "#essinfo" },
          { name: "申报人信息", isok: false, id: "#candidate" },
          { name: "担任项目经理负责施工管理的典型事迹", isok: false, id: "#Typicaldeeds" },
          { name: "上传附件", isok: false, id: "#Upload" },
        ];
        console.log('this.$route.query.r',this.$route.query.r)
        if (this.$route.query.r) {
          this.rId = this.$route.query.r;
          //判断是否存在记录id，如果是则表示是申请记录审核失败的
          if (this.rId) {
            res = await DeclareDetails(this.rId);
             console.log('this.$route.query res',res)
            if(res) {
               if (JSON.stringify(res) == "{}") {
                  _this.parameters2 = {
                    essinfo: {},
                    candidate: {},
                    Typicaldeeds: {},
                    enclosure: {}
                  };
                } else {
                  _this.parameters2 = res.content;
                  for (const key in _this.parameters2) {
                    if (Array.isArray(_this.parameters2[key])) {
                      _this.parameters2[key] = {}
                    }
                  }
                }
                console.log('parameters2',_this.parameters2);
            }
          }
        }
        if (!res) {
          Draftrecord(_this.$route.query.id, _this.$route.query.award_batch_id).then(res => {
            console.log('----------------------1111res1111----------------------');
            console.log(res);
            if (JSON.stringify(res) == "{}") {
              _this.parameters2 = {
                essinfo: {},
                candidate: {},
                Typicaldeeds: {},
                enclosure: {}
              };
            } else {
              _this.parameters2 = res.content;
              for (const key in _this.parameters2) {
                if (Array.isArray(_this.parameters2[key])) {
                  _this.parameters2[key] = {}
                }
              }
            }
            console.log(_this.parameters2);
          })
        }

        break;
      case "贵州省优质工程评价":
        if (this.$route.query.r) {
          this.rId = this.$route.query.r;
          //判断是否存在记录id，如果是则表示是申请记录审核失败的
          if (this.rId) {
            res = await DeclareDetails(this.rId);
          }
        }
        if (!res) {
          res = await Draftrecord(this.$route.query.id,this.$route.query.award_batch_id);
        }
        this.lefttitlelist = [
          {
            name: "承建单位（申报单位）简况",
            isok: false,
            id: "#Contractorinfo",
          },
          { name: "参建单位信息", isok: false, id: "#index0" },
          { name: "申报工程概况", isok: false, id: "#ProjectOverview" },
          { name: "申报理由", isok: false, id: "#Explain_the_reason" },
          { name: "有关单位意见", isok: true, id: "#Explain_the_opinion" },
          {
            name: "申报登记表需补充内容",
            isok: false,
            id: "#SupplementaryContent",
          },
          {
            name: "申报汇总表需补充内容",
            isok: false,
            id: "#DeclarationSummary",
          },
          // { name: "推荐表", isok: false, id: "#Recommendationform" },
        ];
        if (JSON.stringify(res) == "{}") {
          this.parameters = {
            Explain_the_reason: "",
            Recommendationform: [],
            DeclarationSummary: {},
            Contractorinfo: {'projectNname':''},
            ProjectOverview: {},
            SupplementaryContent: {
              certificate: [{ uploadinput: "", uploadlist: [] }],
              Contactemail: "",
              Unitcontact: "",
              contactnumber: "",
              Architecture_msg2_file: [],
              Architecture_msg3_file: [],
              is1arr: [],
              is2arr: [],
              is3arr: [],
              is4arr: [],
              is5arr: [],
              is6arr: [],
              is7arr: [],
              is8arr: [],
              is9arr: [],
              is10arr: [],
              is11arr: [],
              is12arr: [],
              is13arr: [],
              is14arr: [],
              is15arr: [],
              is16arr: [],
              is17arr: [],
              is18arr: [],
              is19arr: [],
              is20arr: [],
              is21arr: [],
              is22arr: [],
              is23arr: [],
              is24arr: [],
              is25arr: [],
              is26arr: [],
              is27arr: [],
              is28arr: [],
              is29arr: [],
              is30arr: [],
              is31arr: [],
              is32arr: [],
              is33arr: [],
              is34arr: [],
              is35arr: [],
              is36arr: [],
              //is37arr:[],
              is1: "0",
              is2: "0",
              is3: "0",
              is4: "0",
              is5: "0",
              is6: "0",
              is7: "0",
              is8: "0",
              is9: "0",
              is10: "0",
              is11: "0",
              is12: "0",
              is13: "0",
              is14: "0",
              is15: "0",
              is16: "0",
              is17: "0",
              is18: "0",
              is19: "0",
              is20: "0",
              is21: "0",
              is22: "0",
              is23: "0",
              is24: "0",
              is25: "0",
              is26: "0",
              is27: "0",
              is28: "0",
              is29: "0",
              is30: "0",
              is31: "0",
              is32: "0",
              is33: "0",
              is34: "0",
              is35: "0",
              is36: "0",
              //is37:"0"
            },
            Architecture_msg3_file: [],
            Architecture_msg2_file: [],
            Approval_comments: "",
            Architecture_msg1: "",
            Architecture_msg2: "",
            Architecture_msg3: "",
            Awarding_unit: "",
            unitinfo: [
              {
                Construction_content: "",
                Construction_proportion: "",
                Construction_workload: "",
                Qualification_level: "",
                Telephone: "",
                brief_introduction: "",
                codeyouzheng: "",
                guding_phone: "",
                leave: "",
                movephone1: "",
                name2: "",
                name3: "",
                name4: "",
                phone2: "",
                phone3: "",
                phoneaddress: "",
                postion: "",
                unitname: "",
                work_department: "",
              },
            ],
          };
        } else {
          for (const key in res.content) {
            if (res.content[key] == null) {
              res.content[key] = "";
            }
            this.parameters = res.content;
          }
          if (res.content.unitinfo.length == 0) {
            this.lefttitlelist.splice(1, 1);
          }
          for (let i = 1; i < res.content.unitinfo.length; i++) {
            this.lefttitlelist.splice(i + 1, 0, {
              name: "参建单位信息" + (i == 0 ? "" : i),
              isok: false,
              id: "#index" + i,
            });
          }
          this.parameters = res.content;
          this.Recommendationform = true

          this.parameters.SupplementaryContent.is17 = '0';
          this.parameters.SupplementaryContent.is19 = '0';
          //this.lefttitlelist[this.parameters.unitinfo.length + 6].isok = true;
        }

        break;
      case "新技术示范工程":
        res = await Draftrecord(this.$route.query.id, this.$route.query.award_batch_id);//this.parameters3);
        if (JSON.stringify(res) == "{}") {
          this.parameters3 = {};
          return false;
        }
        this.parameters3 = res.content;
        break;
      case "贵州省优秀施工企业":
        this.lefttitlelist = [
          { name: "基本信息", isok: false, id: "#essinfo" },
          { name: "基本条件", isok: false, id: "#condition" },
          { name: "评选指标", isok: false, id: "#Selection" },
          { name: "企业业绩材料", isok: false, id: "#Material" },
          { name: "上传附件", isok: false, id: "#Upload" }
        ];
        if (this.$route.query.r) {
          this.rId = this.$route.query.r;
          //判断是否存在记录id，如果是则表示是申请记录审核失败的
          if (this.rId) {
            res = await DeclareDetails(this.rId);
          }
        } else {
          res = await Draftrecord(this.$route.query.id,this.$route.query.award_batch_id);
        }
        if (JSON.stringify(res) == "{}") {
          this.parameters1 = {
            essinfo: {},
            condition: {},
            Selection: {},
            enclosure: {
              msg10:[]
            }
          };
        } else {
          this.parameters1 = res.content;
          for (const key in this.parameters1) {
            if (Array.isArray(this.parameters1[key])) {
              this.parameters1[key] = {}
            }
          }
          if (!this.parameters1.enclosure.msg10) {
            this.parameters1.enclosure.msg10 = [];
          }
          console.log(66, this.parameters1);
        }
        break;

      case "建筑与市政工程绿色施工评价":
        this.lefttitlelist = [
          { name: "基本信息", isok: false, id: "#info" },
          { name: "工程概况", isok: false, id: "#ProjectOverview" },
          { name: "拟完成绿色施工主要指标情况", isok: false, id: "#Indicators" },
          { name: "上传附件", isok: false, id: "#Upload" }
        ];
        if (this.$route.query.r) {
          this.rId = this.$route.query.r;
          //判断是否存在记录id，如果是则表示是申请记录审核失败的
          if (this.rId) {
            res = await DeclareDetails(this.rId);
             console.log('this.$route.query res',res)
            if (JSON.stringify(res) == "{}") {
                this.parameters3 = {
                  info: {},
                  Indicators: {},
                  Upload: {
                    GreenConstruction: [],
                    GreenDeclarationForm: []
                  },
                  ProjectOverview: {}
                };
              } else {
                this.parameters3 = res.content;
                for (const key in this.parameters3) {
                  if (Array.isArray(this.parameters3[key])) {
                    this.parameters3[key] = {}
                  }
                }
                console.log(66, this.parameters3);
              }
          }
        } else {
            res = await Draftrecord(this.$route.query.id,this.$route.query.award_batch_id);
            if (JSON.stringify(res) == "{}") {
              this.parameters3 = {
                info: {},
                Indicators: {},
                Upload: {
                  GreenConstruction: [],
                  GreenDeclarationForm: []
                },
                ProjectOverview: {}
              };
            } else {
              this.parameters3 = res.content;
              for (const key in this.parameters3) {
                if (Array.isArray(this.parameters3[key])) {
                  this.parameters3[key] = {}
                }
              }
              console.log(66, this.parameters3);
            }
        }


        break;

      case "省级施工工法":
        this.lefttitlelist = [
          { name: "工程类别", isok: false, id: "#type_of_work" },
          { name: "专业分类", isok: false, id: "#type_of_major" },
          { name: "基本信息", isok: false, id: "#sj_info" },
          { name: "主要完成人", isok: false, id: "#sj_info" },
          { name: "申报材料上传", isok: false, id: "#sj_upload" }
        ];
        var a_id = this.$route.query.a_id;
        if(a_id == undefined || a_id == 0){
          a_id = this.$route.query.r;
        }
        if(a_id){
          this.rId = a_id;
          res = await DeclareDetails(this.rId);
          //res = await Draftrecord2(this.$route.query.a_id);
        }else{
          res = await Draftrecord(this.$route.query.id,this.$route.query.award_batch_id);
        }

        console.log('----------------------res----------------------');
        console.log(res);
        if (JSON.stringify(res) == "{}" ) {
          this.parameters4 = {
            Indicators: {},
            ProjectOverview: {},
            Upload: {},
            info: {
              gf_province:"1",
              unit: localStorage.getItem("member_name"),
              author_names: [
                {
                  name: "",
                  starttime: "",
                },
              ],
            }
          };
          this.parameters4.info = ensureGongfaEnterpriseInfo(this.parameters4.info)
          this.upAuthor()
        } else {

          if (res.content.Indicators != undefined) {
                this.parameters4.Indicators = res.content.Indicators;
          }
          if ( res.content.info != undefined) {
             this.parameters4.info = res.content.info;
          }
          this.parameters4.info = ensureGongfaEnterpriseInfo(this.parameters4.info)

          if ( res.content.ProjectOverview != undefined) {
             this.parameters4.ProjectOverview = res.content.ProjectOverview;
          }

          if ( res.content.Upload != undefined) {
             this.parameters4.Upload = res.content.Upload;
          }
          
          
          for (const key in this.parameters4) {
            if (Array.isArray(this.parameters4[key])) {
              this.parameters4[key] = {}
            }
          }

          console.log("this.parameters4.info.type_of_work");
          console.log(this.parameters4.info.type_of_work);
          if (this.parameters4.info != undefined && this.parameters4.info.type_of_work == null) {
            this.parameters4.info.type_of_work = '房屋建筑工程';
            this.changeType(this.parameters4.info.type_of_work);
          }
          var type_of_major_bak = res.content.info.type_of_major;

          this.parameters4.info.type_of_major = type_of_major_bak;
          // info.author_names
          this.upAuthor()
        }
        break;
      case "贵州省工程建设工法评定":
        this.lefttitlelist = [
          { name: "工程类别", isok: false, id: "#type_of_work" },
          { name: "专业分类", isok: false, id: "#type_of_major" },
          { name: "基本信息", isok: false, id: "#sj_info" },
          { name: "主要完成人", isok: false, id: "#sj_info" },
          { name: "申报材料上传", isok: false, id: "#sj_upload" }
        ];
        var a_id = this.$route.query.a_id;
        if(a_id == undefined || a_id == 0){
          a_id = this.$route.query.r;
        }
        console.log('a_id',a_id);
        if(a_id){
          this.rId = a_id;
          res = await DeclareDetails(this.rId);
          var gfneed_modify_remark = res.need_modify_remark || null;
          var gfneed_fields = [];
          // 格式一：review管理员退回（info/files key）
          if(gfneed_modify_remark && gfneed_modify_remark['info']){
              for(let key in gfneed_modify_remark['info']){
                  gfneed_fields.push(gfneed_modify_remark['info'][key]['id'])
              }
          }
          if(gfneed_modify_remark && gfneed_modify_remark['files']){
              for(let key in gfneed_modify_remark['files']){
                  gfneed_fields.push(gfneed_modify_remark['files'][key]['id'])
              }
          }
          // 格式二：专家在线退回（reject_items: [{item_id:'info:contact'},{item_id:'file:filelist4'}]）
          if(gfneed_modify_remark && Array.isArray(gfneed_modify_remark['reject_items'])){
              gfneed_modify_remark['reject_items'].forEach(function(item){
                  if(item && item.item_id){
                      var parts = item.item_id.split(':');
                      if(parts.length === 2 && parts[1]) gfneed_fields.push(parts[1]);
                  }
              });
          }
          this.gfneed_fields = gfneed_fields;
          var gfneed_opinions = {}
          if (gfneed_modify_remark && Array.isArray(gfneed_modify_remark['reject_items'])) {
              gfneed_modify_remark['reject_items'].forEach(function(item) {
                  if (item && item.item_id) {
                      // 同时用完整key和纯字段名key存储，模板用纯字段名查询
                      gfneed_opinions[item.item_id] = item.opinion || '';
                      var parts = item.item_id.split(':');
                      if(parts.length === 2 && parts[1]) gfneed_opinions[parts[1]] = item.opinion || '';
                  }
              })
          }
          // 格式一的 opinion（review管理员退回）
          if(gfneed_modify_remark && gfneed_modify_remark['info']){
              for(let key in gfneed_modify_remark['info']){
                  var infoItem = gfneed_modify_remark['info'][key];
                  if(infoItem.id && infoItem.opinion) gfneed_opinions[infoItem.id] = infoItem.opinion;
              }
          }
          if(gfneed_modify_remark && gfneed_modify_remark['files']){
              for(let key in gfneed_modify_remark['files']){
                  var fileItem = gfneed_modify_remark['files'][key];
                  if(fileItem.id && fileItem.opinion) gfneed_opinions[fileItem.id] = fileItem.opinion;
              }
          }
          this.gfneed_opinions = gfneed_opinions
          // 只有退回修改状态才限制编辑，撤回状态允许编辑所有字段
          this.isGongfaReturnModify = gfneed_modify_remark !== null;
          this.reject_reason = res.reject_reason || '';
          this.return_type = res.return_type || '';
          this.modify_deadline = res.modify_deadline || '';
          console.log('this.gfneed_fields',this.gfneed_fields)
          //res = await Draftrecord2(this.$route.query.a_id);
        }else{
          res = await Draftrecord(this.$route.query.id,this.$route.query.award_batch_id);
        }

        console.log('----------------------res----------------------');
        console.log(res);
        if (JSON.stringify(res) == "{}" ) {
          this.parameters4 = {
            Indicators: {},
            ProjectOverview: {},
            Upload: {},
            info: {
              gf_province:"1",
              author_names: [
                {
                  name: "",
                  starttime: "",
                },
              ],
            }
          };
          this.upAuthor()
        } else {

          if (res.content.Indicators != undefined) {
                this.parameters4.Indicators = res.content.Indicators;
          }
          if ( res.content.info != undefined) {
             this.parameters4.info = res.content.info;
          }

          if ( res.content.ProjectOverview != undefined) {
             this.parameters4.ProjectOverview = res.content.ProjectOverview;
          }

          if ( res.content.Upload != undefined) {
             this.parameters4.Upload = res.content.Upload;
          }
          for (const key in this.parameters4) {
            if (Array.isArray(this.parameters4[key])) {
              this.parameters4[key] = {}
            }
          }
          console.log('res.content.info.gf_province',res.content.info.gf_province)
        //   if ( res.content.info.gf_province == undefined) {
        //      this.parameters4.info.gf_province = "1";
        //   }
          
          console.log("this.parameters4.info.type_of_work");
          console.log(this.parameters4.info.type_of_work);
          if (this.parameters4.info != undefined && this.parameters4.info.type_of_work == null) {
            this.parameters4.info.type_of_work = '房屋建筑工程';
            this.changeType(this.parameters4.info.type_of_work);
          }
          var type_of_major_bak = res.content.info.type_of_major;

          this.parameters4.info.type_of_major = type_of_major_bak;
          console.log("this.parameters4.info.gfneed_modify_remark",this.gfneed_fields);

          // info.author_names
          this.upAuthor()
        }
        break;
      case "工程建设质量管理小组竞赛活动":
        this.lefttitlelist = [
          { name: "基本信息", isok: false, id: "#sj_info" },
          { name: "申报材料上传", isok: false, id: "#sj_upload" }
        ];
        if (this.$route.query.r) {
          this.rId = this.$route.query.r;
          //判断是否存在记录id，如果是则表示是申请记录审核失败的
          if (this.rId) {
            res = await DeclareDetails(this.rId);
             console.log('this.$route.query res',res)
              this.$refs.groupAward.setInfo(this.rId,this.$route.query.id,this.$route.query.award_batch_id)
             this.$refs.groupAward.setData(res.content)
          }
        } else {
          res = await Draftrecord(this.$route.query.id, this.$route.query.award_batch_id);
          if(this.$route.query.r != undefined){
            this.rId = this.$route.query.r;
          }
          this.$refs.groupAward.setInfo(0,this.$route.query.id,this.$route.query.award_batch_id)
          this.$refs.groupAward.setData(res.content)
        }


    }
  },
  computed: {
    issumbitshow: function () {
      let issumbit = true;
      for (let i = 0; i < this.lefttitlelist.length; i++) {
        if (!this.lefttitlelist[i].isok) {
          issumbit = false;
        }
      }
      return issumbit;
    },
    imageCount() {
          const list = (this.parameters4?.info?.filelist12 || []);
          return list.filter(f => this.isImageFile(f)).length;
        },
        videoCount() {
          const list = (this.parameters4?.info?.filelist12 || []);
          return list.filter(f => this.isVideoFile(f)).length;
        },
        mediaRequirementOk() {
          // 规则：现场应用照片必须不少于 10 张（视频仅作为附加资料，不能替代）
          return this.imageCount >= 10;
        },
  },
  watch: {
    "parameters.Contractorinfo": {
      handler: function (newV, oldV) {
        if (Array.isArray(this.parameters.Contractorinfo)) {
          this.parameters.Contractorinfo = {};
        }
        let count = 0;
        this.Contractorinfo.Tipsbackground = "#FEF8EF";
        this.Contractorinfo.Tipstates = false;
        this.Contractorinfo.Tipsborder = "#FFB700";
        this.lefttitlelist[0].isok = false;
        //console.log('this.parameters.Contractorinfo',this.parameters.Contractorinfo)
        for (const key in this.parameters.Contractorinfo) {
        //console.log('this.parameters.Contractorinfo key',key+'--'+this.parameters.Contractorinfo[key])
          if (!this.parameters.Contractorinfo[key]) return;
          count++;
          //console.log('this.parameters.Contractorinfo count',count)
          if (count >= 22) {
            this.Contractorinfo.Tipsbackground = "#EDF8F5";
            this.Contractorinfo.Tipstates = true;
            this.Contractorinfo.Tipsborder = "#1ABF98";
            this.lefttitlelist[0].isok = true;
          }
        }
      },
      deep: true,
    },
    "parameters.unitinfo": {
      handler: function (newV, oldV) {
        let count = 0;
        let num = 19;
        let isnull = true;
        for (let i = 0; i < this.parameters.unitinfo.length; i++) {
          for (const key in this.parameters.unitinfo[i]) {
            if (
              this.parameters.unitinfo[i][key] == "" ||
              this.parameters.unitinfo[i][key] == null
            ) {
              isnull = false;
            }
          }
          if (isnull == true) {
            this.Informationparticipatingunits.Tipsbackground = "#EDF8F5";
            this.Informationparticipatingunits.Tipstates = true;
            this.Informationparticipatingunits.Tipsborder = "#1ABF98";
            this.lefttitlelist[i + 1].isok = true;
          } else {
            this.Informationparticipatingunits.Tipsbackground = "#FEF8EF";
            this.Informationparticipatingunits.Tipstates = false;
            this.Informationparticipatingunits.Tipsborder = "#FFB700";
            this.lefttitlelist[i + 1].isok = false;
          }
        }
      },
      deep: true,
    },
    "parameters.ProjectOverview": {
      handler: function (newV, oldV) {
        if (Array.isArray(this.parameters.ProjectOverview)) {
          this.parameters.ProjectOverview = {};
        }
        let count = 0;
        this.ProjectOverview.Tipsbackground = "#FEF8EF";
        this.ProjectOverview.Tipstates = false;
        this.ProjectOverview.Tipsborder = "#FFB700";
        this.lefttitlelist[this.parameters.unitinfo.length + 1].isok = false;
        for (const key in this.parameters.ProjectOverview) {
          if (!this.parameters.ProjectOverview[key]) return;
          count++;
          if (count >= 16) {
            this.ProjectOverview.Tipsbackground = "#EDF8F5";
            this.ProjectOverview.Tipstates = true;
            this.ProjectOverview.Tipsborder = "#1ABF98";
            this.lefttitlelist[this.parameters.unitinfo.length + 1].isok = true;
          }
        }
      },
      deep: true,
    },
    "parameters.Explain_the_reason": {
      handler() {
        if (this.parameters.Explain_the_reason != "") {
          this.lefttitlelist[this.parameters.unitinfo.length + 2].isok = true;
        } else {
          this.lefttitlelist[this.parameters.unitinfo.length + 2].isok = false;
        }
      },
      deep: true,
    },
    parameters: {
      handler: function (newval, oldval) {
        console.log('handler',newval);
        let count = 0;
        let isshenbao = 0;
        let istrue = true;
        for (const key in this.parameters.SupplementaryContent) {
          if (this.parameters.SupplementaryContent[key] === "" || this.parameters.SupplementaryContent[key] === null || this.parameters.SupplementaryContent[key] === undefined) {
            // console.log(key,JSON.stringify(this.parameters.SupplementaryContent[key]));
            istrue = false;
          }
          for (let i = 20; i <= 36; i++) {
            if (this.parameters.SupplementaryContent["is" + i] == "1") {
              if(i == 20 && this.parameters.SupplementaryContent["is" + i + "arr"].length < 15){
                   istrue = false;
              } else  if (
                this.parameters.SupplementaryContent["is" + i + "arr"].length <
                1
              ) {
                console.log(i+'-'+this.parameters.SupplementaryContent["is" + i + "arr"], '图像i');
                istrue = false;
              }
            }
          }
        }

        if (istrue) {
          this.SupplementaryContent.Tipsbackground = "#EDF8F5";
          this.SupplementaryContent.Tipstates = true;
          this.SupplementaryContent.Tipsborder = "#1ABF98";
          this.lefttitlelist[this.parameters.unitinfo.length + 4].isok = true;
          console.log(11);
        } else {
          this.SupplementaryContent.Tipstates = false;
          this.SupplementaryContent.Tipsbackground = "#FEF8EF";
          this.SupplementaryContent.Tipsborder = "#FFB700";
          this.lefttitlelist[this.parameters.unitinfo.length + 4].isok = false;
          console.log(22);
        }

        console.log(996, this.Recommendationform);
      },
      deep: true,
    },
    "parameters.DeclarationSummary": {
      handler() {
        let count = 0;
        if (Array.isArray(this.parameters.DeclarationSummary)) {
          this.parameters.DeclarationSummary = {};
        }
        this.DeclarationSummary.Tipsbackground = "#FEF8EF";
        this.DeclarationSummary.Tipstates = false;
        this.DeclarationSummary.Tipsborder = "#FFB700";
        this.lefttitlelist[this.parameters.unitinfo.length + 5].isok = false;
        for (const key in this.parameters.DeclarationSummary) {
          if (!this.parameters.DeclarationSummary[key]) return;
          count++;
          if (count >= 7) {
            this.DeclarationSummary.Tipsbackground = "#EDF8F5";
            this.DeclarationSummary.Tipstates = true;
            this.DeclarationSummary.Tipsborder = "#1ABF98";
            this.lefttitlelist[this.parameters.unitinfo.length + 5].isok = true;
          }
        }
      },
      deep: true,
    },
    parameters1: {
      handler() {
        let copykey;
        console.log('OKOKOK');
        for (const key in this.parameters1.enclosure) {
          if (typeof this.parameters1.enclosure[key] == 'boolean') {
            if (this.parameters1.enclosure[key] == false) {
              copykey = key.slice(3, 5)
              delete this.parameters1.enclosure['msg' + (parseInt(copykey) + 1)]
            }
          }
        }
        this.essinfo = this.noempty(this.parameters1.essinfo, 6, "msg");
        this.condition = this.noempty(this.parameters1.condition, 7, "msg");
        this.Selection = this.noempty(this.parameters1.Selection, 8, "msg");
        if (this.parameters1.enclosure.msg12) {
          this.enclosure = this.parameters1.enclosure.msg12.length >= 1
        }
        console.log('this.enclosure',this.enclosure)
        this.parameters1.enclosure.msg12 == undefined ? this.enclosure = false : this.enclosure = true
        this.lefttitlelist[0].isok = this.essinfo;
        this.lefttitlelist[1].isok = this.condition;
        this.lefttitlelist[2].isok = this.Selection;
        this.lefttitlelist[3].isok =
          this.parameters1.Material != "" &&
          this.parameters1.Material != undefined;
        this.lefttitlelist[4].isok = this.enclosure;
        console.log(this.parameters1.enclosure.msg2);
      },
      deep: true
    },
    parameters2: {
      handler() {
        let copykey;
        for (const key in this.parameters2.enclosure) {
          if (typeof this.parameters2.enclosure[key] == 'boolean') {
            if (this.parameters2.enclosure[key] == false) {
              copykey = key.slice(3, 5)
              delete this.parameters2.enclosure['msg' + (parseInt(copykey) + 1)]
            }
          }
        }
        this.essinfo = this.noempty(this.parameters2.essinfo, 4, "msg");
        this.condition = this.noempty(this.parameters2.candidate, 17, "msg");
        this.Selection = this.noempty(this.parameters2.Typicaldeeds, 11, "msg");
        console.log('enclosure', this.parameters2.enclosure);
        if (this.parameters2.enclosure.msg7) {
          this.enclosure = this.parameters2.enclosure.msg7.length >= 1
        }
        this.parameters2.enclosure.msg7 == undefined ? this.enclosure = false : this.enclosure = true
        this.lefttitlelist[0].isok = this.essinfo;
        this.lefttitlelist[1].isok = this.condition;
        this.lefttitlelist[2].isok = this.Selection;
        this.lefttitlelist[3].isok = this.enclosure;
      },
      deep: true
    },
    parameters3: {
      handler() {
        this.parameters3.info.msg6='msg6';
        this.parameters3.info.linker = this.parameters3.info.msg17;
        this.parameters3.info.tel = this.parameters3.info.msg19;
        this.lefttitlelist[0].isok = this.noempty(this.parameters3.info, 19, "msg");
        this.lefttitlelist[1].isok = this.noempty(this.parameters3.ProjectOverview, 1, "msg");
        this.parameters3.Indicators.msg5='msg5';
        this.lefttitlelist[2].isok = this.noempty(this.parameters3.Indicators, 8, "msg");
      },
      deep: true
    },
    "parameters4": {
      handler: function (newV, oldV) {
        this.lefttitlelist[0].isok = false;
        if (this.parameters4.info.type_of_work) {
          this.lefttitlelist[0].isok = true;
        }
        this.lefttitlelist[1].isok = false;
        if (this.parameters4.info.type_of_major) {
          this.lefttitlelist[1].isok = true;
        }
        this.lefttitlelist[2].isok = false;
        if (this.isGongfaBasicInfoComplete()) {
          this.lefttitlelist[2].isok = true;
        }
        this.lefttitlelist[3].isok = false;
        if (this.parameters4.info.author_names && this.parameters4.info.author_names.some((author) => author && author.name)) {
          this.lefttitlelist[3].isok = true;
        }
        this.lefttitlelist[4].isok = false;

        if (this.isGongfaUploadComplete()) {
          this.lefttitlelist[4].isok = true;
        }
      },
      deep: true
    },
  },
  methods: {
        isGfFieldDisabled(field) {
          return Boolean(this.isGongfaReturnModify && this.gfneed_fields.indexOf(field) === -1);
        },
        // limit=1 超限时自动覆盖：清掉旧文件再上传新文件
        handleGfFileExceed(files, fileList, refName) {
          const uploadRef = this.$refs[refName];
          if (!uploadRef) return;
          uploadRef.clearFiles();
          const file = files[0];
          file.uid = Date.now();
          uploadRef.handleStart(file);
          uploadRef.submit();
        },

      // 上传前校验：类型+视频大小（≤300MB）
        beforeMediaUpload(file) {
          const isImg = /^image\//.test(file.type) || this.hasExt(file, ['jpg','jpeg','png']);
          const isVid = /^video\//.test(file.type) || this.hasExt(file, ['mp4','avi','flv']);
    
          if (!isImg && !isVid) {
            this.$message.error('仅支持 jpg、png、mp4、avi、flv 格式');
            return false;
          }
    
          if (isVid) {
            const sizeMB = file.size / 1024 / 1024;
            if (sizeMB > 300) {
              this.$message.error(`视频大小 ${sizeMB.toFixed(1)}MB，已超过 300MB`);
              return false;
            }
          }
          this.mediaUploading = true;
          return true;
        },

        handleMediaUploadError() {
          this.mediaUploading = false;
          this.$message.error('文件上传失败，请重试');
        },

        // 自定义删除：调用 el-upload 内部 handleRemove 删除内部列表，
        // 再由 :on-remove（handleOnRemove12）同步外部数据 filelist12
        handleRemoveMedia(file) {
          const upload = this.$refs.gf_upload_filelist12;
          if (upload && typeof upload.handleRemove === 'function') {
            upload.handleRemove(file);
          } else {
            this.handleOnRemove12(file);
          }
        },
    
        // 工具：判断扩展名
        hasExt(file, exts) {
          const name = (file.name || '').toLowerCase();
          const url  = (file.url || (file.response && file.response.url) || '').toLowerCase();
          return exts.some(ext => name.endsWith('.' + ext) || url.includes('.' + ext));
        },
    
        // 判断已在列表里的文件是图片/视频（file.type 可能缺失，降级用扩展名）
        isImageFile(file) {
          const t = (file.type || '').toLowerCase();
          if (t.startsWith('image/')) return true;
          return this.hasExt(file, ['jpg','jpeg','png']);
        },
        isVideoFile(file) {
          const t = (file.type || '').toLowerCase();
          if (t.startsWith('video/')) return true;
          return this.hasExt(file, ['mp4','avi','flv']);
        },
    hasGongfaUpload(field) {
      const value = this.parameters4 && this.parameters4.info ? this.parameters4.info[field] : null;
      return Array.isArray(value) ? value.length > 0 : !!value;
    },
    isGongfaUploadComplete() {
      const info = this.parameters4 && this.parameters4.info ? this.parameters4.info : {};
      // 现场应用照片必须不少于 10 张（视频仅作为附加资料，不能替代）
      const mediaList = info.filelist12 || [];
      const imageNum = mediaList.filter(f => this.isImageFile(f)).length;
      return REQUIRED_UPLOAD_FIELDS.every((field) => this.hasGongfaUpload(field)) &&
        imageNum >= 10 &&
        (info.text_public_authorized === '1' || info.text_public_authorized === '0');
    },
    isGongfaBasicInfoComplete() {
      const info = this.parameters4 && this.parameters4.info ? this.parameters4.info : {};
      return !!(
        info.name &&
        info.unit &&
        info.username &&
        isValidMobile(info.phone) &&
        info.gf_province &&
        (String(info.gf_province) !== '2' || info.gf_province_detail)
      );
    },
    formatGongfaPhone() {
      const info = this.parameters4 && this.parameters4.info ? this.parameters4.info : {};
      info.phone = String(info.phone || '').replace(/\D/g, '').slice(0, 11);
      if (this.gongfaPhoneError && isValidMobile(info.phone)) {
        this.gongfaPhoneError = '';
      }
    },
    validateGongfaPhone() {
      const info = this.parameters4 && this.parameters4.info ? this.parameters4.info : {};
      const phone = String(info.phone || '').trim();
      if (!phone) {
        this.gongfaPhoneError = '请输入手机号码';
      } else if (phone.length !== 11) {
        this.gongfaPhoneError = '手机号码需为11位';
      } else if (!isValidMobile(phone)) {
        this.gongfaPhoneError = '请输入正确的手机号码';
      } else {
        this.gongfaPhoneError = '';
      }
      return !this.gongfaPhoneError;
    },
    formatTelField(field) {
      const info = this.parameters4 && this.parameters4.info ? this.parameters4.info : {};
      if (field === 'tel') {
        info.tel = String(info.tel || '').replace(/[^\d\-]/g, '').slice(0, 20);
      }
    },
    showGongfaSubmitSuccess() {
      const options = getGongfaSubmitSuccessOptions();
      return this.$alert(options.message, options.title, {
        confirmButtonText: options.confirmButtonText,
        customClass: 'gongfa-submit-success-dialog',
      });
    },
    
    lefttitlelist4_check() {
      this.lefttitlelist[4].isok = false;
      if (this.isGongfaUploadComplete()) {
        this.lefttitlelist[4].isok = true;
      }

    },
    uploadSuccess1(response, file, fileList) {
      let data = [{
        url: response.data.host + response.data.url,
        name: response.data.originalName
      }]
      this.parameters4.info.filelist1 = data;
      this.lefttitlelist4_check();
    },
    uploadSuccess2(response, file, fileList) {
      let data = [{
        url: response.data.host + response.data.url,
        name: response.data.originalName
      }]
      this.parameters4.info.filelist2 = data;
      this.lefttitlelist4_check();
    },
    uploadSuccess3(response, file, fileList) {
      let data = {
        url: response.data.host + response.data.url,
        name: response.data.originalName
      }
      this.parameters4.info.filelist3 = [data];
      
      //this.parameters4.info.filelist3 = data;
      this.lefttitlelist4_check();
    },
    uploadSuccessCommitment(response, file, fileList) {
      let data = [{
        url: response.data.host + response.data.url,
        name: response.data.originalName
      }]
      this.parameters4.info.filelist_commitment = data;
      this.lefttitlelist4_check();
    },
    uploadSuccess4(response, file, fileList) {
      let data = {
        url: response.data.host + response.data.url,
        name: response.data.originalName
      }
      this.parameters4.info.filelist4 = [data];
      
      this.lefttitlelist4_check();
    },
    uploadSuccess5(response, file, fileList) {
      let data = {
        url: response.data.host + response.data.url,
        name: response.data.originalName
      }
      this.parameters4.info.filelist5 = [data];
      this.lefttitlelist4_check();
    },
    uploadSuccess6(response, file, fileList) {
      let data = {
        url: response.data.host + response.data.url,
        name: response.data.originalName
      }
      this.parameters4.info.filelist6 = [data];
      this.lefttitlelist4_check();
    },
    uploadSuccess7(response, file, fileList) {
      let data = {
        url: response.data.host + response.data.url,
        name: response.data.originalName
      }
      this.parameters4.info.filelist7 = [data];
      this.lefttitlelist4_check();
    },
    uploadSuccess8(response, file, fileList) {
      let data = {
        url: response.data.host + response.data.url,
        name: response.data.originalName
      }
      this.parameters4.info.filelist8 = [data];
      this.lefttitlelist4_check();
    },
    uploadSuccess9(response, file, fileList) {
      let data = {
        url: response.data.host + response.data.url,
        name: response.data.originalName
      }
      this.parameters4.info.filelist9 = [data];
      this.lefttitlelist4_check();
    },
    uploadSuccess10(response, file, fileList) {
      let data = {
        url: response.data.host + response.data.url,
        name: response.data.originalName
      }
      this.parameters4.info.filelist10 = [data];
      this.lefttitlelist4_check();
    },
    uploadSuccess11(response, file, fileList) {
      let data = {
        url: response.data.host + response.data.url,
        name: response.data.originalName
      }
      this.parameters4.info.filelist11 = [data];
      console.log('this.parameters4.info.filelist11',this.parameters4.info.filelist11)
     // this.parameters4.info.filelist11 = data;
      this.lefttitlelist4_check();
    },
    uploadSuccess12(response, file, fileList) {
      this.mediaUploading = false;
      let data = {
        url: response.data.host + response.data.url,
        name: response.data.originalName || file.name,
        // 关联 el-upload 内部文件对象的 uid，删除时可按 uid 精确匹配
        uid: file.uid
      }
      // 把真实地址写回内部文件对象，保证列表展示与刷新后地址一致
      file.url = data.url;
      if (typeof (this.parameters4.info.filelist12) == "undefined") {
        this.parameters4.info.filelist12 = [data];
      } else {
        this.parameters4.info.filelist12.push(data);
      }
      this.lefttitlelist4_check();
    },
    //绿色施工子传父上传附件
    greenPorject(v, is) {
      console.log(v, is);
      this.parameters3.Upload = v
      this.lefttitlelist[3].isok = is
    },
    handenclosure(name, index, value) {
      let obj = {
        url: value.data.host + value.data.url,
        name: value.data.originalName
      }
      this.$set(this[name].enclosure, 'msg' + index, [obj])
      console.log(999, this[name].enclosure['msg' + index]);
      // this[name].enclosure['msg'+index] = [obj]

    },
    handenclosure2(file,fileList) {
      let obj = {
        url: file.data.host + file.data.url,
        name: file.data.originalName
      }
      if(!this.parameters1.enclosure.msg10){
        this.parameters1.enclosure.msg10 = [];
      }
      this.parameters1.enclosure.msg10.push(obj);
      console.log("++++", this.parameters1.enclosure.msg10.length)
      console.log("===", this.parameters1.enclosure.msg10);
      this.$forceUpdate()
    },
    removeenclosure(name, index, value) {
      this.$set(this[name].enclosure, 'msg' + index)
    },
    removeenclosure2(file, fileList) {
      let msg10_list = this.parameters1.enclosure.msg10;
      let name = file.name;
      let i = 0;
      msg10_list.forEach(item => {
        if (name == item.name) {
          msg10_list.splice(i, 1);
          this.parameters1.enclosure.msg10 = msg10_list;
        }
        i++;
      });
      console.log("===", this.parameters1.enclosure.msg10);
      this.$forceUpdate()
    },
    //贵州省建筑业优秀项目经理 保存照片
    handleSuccessUpload(response, file, fileList) {
      console.log(response);
      console.log(file, fileList);
      let fileobj = {
        name: file.name,
        url: file.response.data.host + file.response.data.url
      }
      this.parameters2.candidate.msg15 = [fileobj];
    },
    //贵州省建筑业优秀项目经理 删除照片
    handleRemove(file) {
      delete this.parameters2.candidate.msg15
    },
    handleOnRemove1(file, fileList) {
      this.parameters4.info.filelist1 = null;
      this.lefttitlelist4_check();
    },
    handleOnRemove2(file, fileList) {
      this.parameters4.info.filelist2 = null;
      this.lefttitlelist4_check();
    },
    handleOnRemove3(file, fileList) {
      this.parameters4.info.filelist3 = null;
      this.lefttitlelist4_check();
    },
    handleOnRemoveCommitment(file, fileList) {
      this.parameters4.info.filelist_commitment = null;
      this.lefttitlelist4_check();
    },
    handleOnRemove4(file, fileList) {
      this.parameters4.info.filelist4 = null;
      this.lefttitlelist4_check();
    },
    handleOnRemove5(file, fileList) {
      this.parameters4.info.filelist5 = null;
      this.lefttitlelist4_check();
    },
    handleOnRemove6(file, fileList) {
      this.parameters4.info.filelist6 = null;
      this.lefttitlelist4_check();
    },
    handleOnRemove7(file, fileList) {
      this.parameters4.info.filelist7 = null;
      this.lefttitlelist4_check();
    },
    handleOnRemove8(file, fileList) {
      this.parameters4.info.filelist8 = null;
      this.lefttitlelist4_check();
    },
    handleOnRemove9(file, fileList) {
      this.parameters4.info.filelist9 = null;
      this.lefttitlelist4_check();
    },
    handleOnRemove10(file, fileList) {
      this.parameters4.info.filelist10 = null;
      this.lefttitlelist4_check();
    },
    handleOnRemove11(file, fileList) {
      this.parameters4.info.filelist11 = null;
      this.lefttitlelist4_check();
    },
    handleOnRemove12(file, fileList) {
      const list = this.parameters4.info.filelist12 || [];
      // 优先 uid 匹配（上传成功时已关联），兜底 name / url 匹配（历史数据）
      const index = list.findIndex(item =>
        (item.uid !== undefined && file.uid !== undefined && item.uid === file.uid) ||
        (item.name && file.name && item.name === file.name) ||
        (item.url && file.url && item.url === file.url)
      );
      if (index > -1) {
        list.splice(index, 1);
      } else if (Array.isArray(fileList)) {
        // 兜底：直接用 el-upload 删除后的内部列表重建外部数据
        this.parameters4.info.filelist12 = fileList.map(f => ({
          url: f.url,
          name: f.name,
          uid: f.uid
        }));
      }
      this.lefttitlelist4_check();
    },
    //非空验证 参数：根据对象名，对象内有多少条属性，属性名
    noempty(obj, num, name) {
      var empty = true;
      console.log(num)
      console.log(obj)
      for (let i = 1; i <= num; i++) {
        if (obj[name + i] == "" || obj[name + i] == undefined) {
          console.log(obj[name + i])
          console.log(name )
          console.log(i)
          empty = false;
        }
      }
      console.log(empty)
      return empty;
    },
    //限制文件上传大小
    beforeAvatarUpload(file) {
      let filesize = (Math.ceil(file.size / 1024) / 1024).toFixed(2);
      console.log(file);
      if (filesize > 100) {
        this.$message.error("上传文件不能大于100MB");
        return false;
      }
    },
    beforePdfUpload(file) {
      let filesize = (Math.ceil(file.size / 1024) / 1024).toFixed(2);
      console.log(file);
      if (filesize > 100) {
        this.$message.error("上传文件不能大于100MB");
        return false;
      }
      //检查文件类型
      const fileName = file.name;
      const fileType = fileName.substring(fileName.lastIndexOf('.'));
      console.log('fileType',fileType)
      if(fileType != '.pdf'){
          this.$message.error("只能上传pdf文件");
          return false;
      }

    },

    handlePreview(file) {
      this.dialogVisible = true;
      this.dialogImageUrl = file.url;
    },
    handleMediaPreview(file) {
      if (file && file.url) {
        window.open(file.url, '_blank');
      }
    },
    handlesuccess2(file, fileList) {
      this.Businesslicense = [fileList];
    },
    //竣工验收备案资料 有无上传文件
    isuploadshow2(v) {
      this.parameters.SupplementaryContent.is10 = v;
      if (v == "0") {
        this.parameters.SupplementaryContent.Acceptance_record = [];
      }
    },
    //有无上传文件
    isuploadshow(state, v) {
      console.log('state',state)
      v = v.toString();
      switch (state) {
        case "1":
          this.parameters.SupplementaryContent.is1 = v;
          if (v == "0") {
            this.parameters.SupplementaryContent.is1arr = [];
          }
          break;
        case "2":
          this.parameters.SupplementaryContent.is2 = v;
          if (v == "0") {
            this.parameters.SupplementaryContent.is2arr = [];
          }
          break;
        case "3":
          this.parameters.SupplementaryContent.is3 = v;
          if (v == "0") {
            this.parameters.SupplementaryContent.is3arr = [];
          }
          break;
        case "4":
          this.parameters.SupplementaryContent.is4 = v;
          if (v == "0") {
            this.parameters.SupplementaryContent.is4arr = [];
          }
          break;
        case "5":
          this.parameters.SupplementaryContent.is5 = v;
          if (v == "0") {
            this.parameters.SupplementaryContent.is5arr = [];
          }
          break;
        case "6":
          this.parameters.SupplementaryContent.is6 = v;
          if (v == "0") {
            this.parameters.SupplementaryContent.is6arr = [];
          }
          break;
        case "7":
          this.parameters.SupplementaryContent.is7 = v;
          if (v == "0") {
            this.parameters.SupplementaryContent.is7arr = [];
          }
          break;
        case "8":
          this.parameters.SupplementaryContent.is8 = v;
          if (v == "0") {
            this.parameters.SupplementaryContent.is8arr = [];
          }
          break;
        case "9":
          this.parameters.SupplementaryContent.is9 = v;
          if (v == "0") {
            this.parameters.SupplementaryContent.is9arr = [];
          }
          break;
        case "10":
          this.parameters.SupplementaryContent.is10 = v;
          if (v == "0") {
            this.parameters.SupplementaryContent.is10arr = [];
          }
          break;
        case "11":
          this.parameters.SupplementaryContent.is11 = v;
          if (v == "0") {
            this.parameters.SupplementaryContent.is11arr = [];
          }
          break;
        case "12":
          this.parameters.SupplementaryContent.is12 = v;
          if (v == "0") {
            this.parameters.SupplementaryContent.is12arr = [];
          }
          break;
        case "13":
          this.parameters.SupplementaryContent.is13 = v;
          if (v == "0") {
            this.parameters.SupplementaryContent.is13arr = [];
          }
          break;
        case "14":
          this.parameters.SupplementaryContent.is14 = v;
          if (v == "0") {
            this.parameters.SupplementaryContent.is14arr = [];
          }
          break;
        case "15":
          this.parameters.SupplementaryContent.is15 = v;
          if (v == "0") {
            this.parameters.SupplementaryContent.is15arr = [];
          }
          break;
        case "16":
          this.parameters.SupplementaryContent.is16 = v;
          if (v == "0") {
            this.parameters.SupplementaryContent.is16arr = [];
          }
          break;
        case "17":
          this.parameters.SupplementaryContent.is17 = v;
          if (v == "0") {
            this.parameters.SupplementaryContent.is17arr = [];
          }
          break;
        case "18":
          this.parameters.SupplementaryContent.is18 = v;
          if (v == "0") {
            this.parameters.SupplementaryContent.is18arr = [];
          }
          break;
        case "19":
          this.parameters.SupplementaryContent.is19 = v;
          if (v == "0") {
            this.parameters.SupplementaryContent.is19arr = [];
          }
          break;
        case "20":
          this.parameters.SupplementaryContent.is20 = v;
          if (v == "0") {
            this.parameters.SupplementaryContent.is20arr = [];
          }
          break;
        case "21":
          this.parameters.SupplementaryContent.is21 = v;
          if (v == "0") {
            this.parameters.SupplementaryContent.is21arr = [];
          }
          break;
        case "22":
          this.parameters.SupplementaryContent.is22 = v;
          if (v == "0") {
            this.parameters.SupplementaryContent.is22arr = [];
          }
          break;
         case "36":
          this.parameters.SupplementaryContent.is36 = v;
          if (v == "0") {
            this.parameters.SupplementaryContent.is36arr = [];
          }
          break;
        // case "37":
        //   this.parameters.SupplementaryContent.is37 = v;
        //   if (v == "0") {
        //     this.parameters.SupplementaryContent.is37arr = [];
        //   }
        //   break;
        case "23":
          this.parameters.SupplementaryContent.is23 = v;
          if (v == "0") {
            this.parameters.SupplementaryContent.is23arr = [];
          }
          break;
        case "24":
          this.parameters.SupplementaryContent.is24 = v;
          if (v == "0") {
            this.parameters.SupplementaryContent.is24arr = [];
          }
          break;
        case "25":
          this.parameters.SupplementaryContent.is25 = v;
          if (v == "0") {
            this.parameters.SupplementaryContent.is25arr = [];
          }
          break;
        case "26":
          this.parameters.SupplementaryContent.is26 = v;
          if (v == "0") {
            this.parameters.SupplementaryContent.is26arr = [];
          }
          break;
        case "27":
          this.parameters.SupplementaryContent.is27 = v;
          if (v == "0") {
            this.parameters.SupplementaryContent.is27arr = [];
          }
          break;
        case "28":
          this.parameters.SupplementaryContent.is28 = v;
          if (v == "0") {
            this.parameters.SupplementaryContent.is28arr = [];
          }
          break;
        case "29":
          this.parameters.SupplementaryContent.is29 = v;
          if (v == "0") {
            this.parameters.SupplementaryContent.is29arr = [];
          }
          break;
        case "30":
          this.parameters.SupplementaryContent.is30 = v;
          if (v == "0") {
            this.parameters.SupplementaryContent.is30arr = [];
          }
          break;
        case "31":
          this.parameters.SupplementaryContent.is31 = v;
          if (v == "0") {
            this.parameters.SupplementaryContent.is31arr = [];
          }
          break;
        case "32":
          this.parameters.SupplementaryContent.is32 = v;
          if (v == "0") {
            this.parameters.SupplementaryContent.is32arr = [];
          }
          break;
        case "33":
          this.parameters.SupplementaryContent.is33 = v;
          if (v == "0") {
            this.parameters.SupplementaryContent.is33arr = [];
          }
          break;
        case "34":
          this.parameters.SupplementaryContent.is34 = v;
          if (v == "0") {
            this.parameters.SupplementaryContent.is34arr = [];
          }
          break;
        case "35":
          this.parameters.SupplementaryContent.is35 = v;
          if (v == "0") {
            this.parameters.SupplementaryContent.is35arr = [];
          }
          break;
      }
      console.log(this.parameters.SupplementaryContent);
    },
    //竣工验收备案资料 上传文件
    filechange2(v) {
      this.parameters.SupplementaryContent.is10arr = v;
    },
    //有无 上传文件
    filechange(res) {
      console.log('filechange',res)
      switch (res[0].title) {
        case "工程立项复批":
          if (res[0].name) {
            this.parameters.SupplementaryContent.is1arr = res;
          } else {
            this.parameters.SupplementaryContent.is1arr = [];
          }
          break;
        case "土地使用证":
          if (res[0].name) {
            this.parameters.SupplementaryContent.is2arr = res;
          } else {
            this.parameters.SupplementaryContent.is2arr = [];
          }

          break;
        case "建设工程规划许可证":
          if (res[0].name) {
            this.parameters.SupplementaryContent.is3arr = res;
          } else {
            this.parameters.SupplementaryContent.is3arr = [];
          }
          break;
        case "工程创优策划书":
          if (res[0].name) {
            this.parameters.SupplementaryContent.is4arr = res;
          } else {
            this.parameters.SupplementaryContent.is4arr = [];
          }
          break;
        case "工程施工图设计文件审查合格书或审批文件(电力工程按行业规定)":
          if (res[0].name) {
            this.parameters.SupplementaryContent.is5arr = res;
          } else {
            this.parameters.SupplementaryContent.is5arr = [];
          }
          break;
        case "工程施工合同":
          if (res[0].name) {
            this.parameters.SupplementaryContent.is6arr = res;
          } else {
            this.parameters.SupplementaryContent.is6arr = [];
          }
          break;
        case "施工许可证或批准开工报告":
          if (res[0].name) {
            this.parameters.SupplementaryContent.is7arr = res;
          } else {
            this.parameters.SupplementaryContent.is7arr = [];
          }
          break;
        case "建设工程消防验收意见书(涉及消防工程)":
          if (res[0].name) {
            this.parameters.SupplementaryContent.is8arr = res;
          } else {
            this.parameters.SupplementaryContent.is8arr = [];
          }
          break;
        case "工程“竣工验收报告”(交通工程提交“交工验收证书”,电力工程提交“投运备案证明书”,水利工程提交“工程合同完工验收文件”)":
          if (res[0].name) {
            this.parameters.SupplementaryContent.is9arr = res;
          } else {
            this.parameters.SupplementaryContent.is9arr = [];
          }
          break;
        case "“投入使用时间和使用效果证明”(建设单位出具)":
          if (res[0].name) {
            this.parameters.SupplementaryContent.is10arr = res;
          } else {
            this.parameters.SupplementaryContent.is10arr = [];
          }
          break;
        case "“建筑业10项新技术应用证明”(监理单位出具)":
          if (res[0].name) {
            this.parameters.SupplementaryContent.is11arr = res;
          } else {
            this.parameters.SupplementaryContent.is11arr = [];
          }
          break;
        case "工业交通水利工程其“技术指标、经济效益及社会效益应达到本专业工程省内领先水平证明”(建设单位出具)":
          if (res[0].name) {
            this.parameters.SupplementaryContent.is12arr = res;
          } else {
            this.parameters.SupplementaryContent.is12arr = [];
          }
          break;
        case "建筑业新技术应用示范工程或绿色施工示范工程证书":
          if (res[0].name) {
            this.parameters.SupplementaryContent.is13arr = res;
          } else {
            this.parameters.SupplementaryContent.is13arr = [];
          }
          break;
        case "“贵州省建筑工程优质质量结构工程”评定文件(住宅工程、公共建筑工程、市政桥梁)":
          if (res[0].name) {
            this.parameters.SupplementaryContent.is14arr = res;
          } else {
            this.parameters.SupplementaryContent.is14arr = [];
          }
          break;
        case "“贵州省建筑安全文明施工样板工地”评定文件(住宅工程、公共建筑工程、市政园林工程)":
          if (res[0].name) {
            this.parameters.SupplementaryContent.is15arr = res;
          } else {
            this.parameters.SupplementaryContent.is15arr = [];
          }
          break;
        case "无质量安全事故承诺":
          if (res[0].name) {
            this.parameters.SupplementaryContent.is16arr = res;
          } else {
            this.parameters.SupplementaryContent.is16arr = [];
          }
          break;
        case "无质量安全事故承诺补充材料":
          if (res[0].name) {
            this.parameters.SupplementaryContent.is17arr = res;
          } else {
            this.parameters.SupplementaryContent.is17arr = [];
          }
          break;
        case "无拖欠农民工工资承诺":
          if (res[0].name) {
            this.parameters.SupplementaryContent.is18arr = res;
          } else {
            this.parameters.SupplementaryContent.is18arr = [];
          }
          break;
        case "无拖欠农民工工资承诺补充材料":
          if (res[0].name) {
            this.parameters.SupplementaryContent.is19arr = res;
          } else {
            this.parameters.SupplementaryContent.is19arr = [];
          }
          break;
        case "反映工程概况和质量状况的彩色照片15张":
          if (res[0].name) {
            if (!this.parameters.SupplementaryContent.is20arr) {
              this.parameters.SupplementaryContent.is20arr = [];
            }
            let bo = true;
            let i = 0;
            let j = this.parameters.SupplementaryContent.is20arr.length;

            console.log('this.parameters.SupplementaryContent.is20arr',this.parameters.SupplementaryContent.is20arr)
            if(res[0].response != undefined){
                for (i=0; i < j; i++) {
                    console.log('res',res[0].response.data.url)
                    console.log('this.parameters.SupplementaryContent.is20arr[i].uid',this.parameters.SupplementaryContent.is20arr[i].response.data.url)
                  if (res[0].response.data.url == this.parameters.SupplementaryContent.is20arr[i].response.data.url) {
                    bo = false;
                    break;
                  }
                }
                console.log('bo',bo)
                console.log('this.parameters.SupplementaryContent.is20arr',this.parameters.SupplementaryContent.is20arr)
                if (bo) {
                  this.parameters.SupplementaryContent.is20arr.push(res[0]);
                }
            }


          } else {
            this.parameters.SupplementaryContent.is20arr = [];
          }
          break;
        case "5分钟影像或PPT资料":
          if (res[0].name) {
            this.parameters.SupplementaryContent.is21arr = res;
          } else {
            this.parameters.SupplementaryContent.is21arr = [];
          }
          break;
        case "无质量安全事故承诺书":
          if (res[0].name) {
            this.parameters.SupplementaryContent.is36arr = res;
          } else {
            this.parameters.SupplementaryContent.is36arr = [];
          }
          break;
        // case "贵州省优质工程申报汇总表（PDF盖章版）":
        //   if (res[0].name) {
        //     this.parameters.SupplementaryContent.is37arr = res;
        //   } else {
        //     this.parameters.SupplementaryContent.is37arr = [];
        //   }
        //   break;
          
        case "贵州省优质工程申报表（盖章后扫描件）":
          if (res[0].name) {
            this.parameters.SupplementaryContent.is22arr = res;
          } else {
            this.parameters.SupplementaryContent.is22arr = [];
          }
          break;

        case "“施工许可证”或“施工许可文件”":
           if (res[0].name) {
             this.parameters.SupplementaryContent.is23arr = res;
           } else {
             this.parameters.SupplementaryContent.is23arr = [];
           }
           break;
        case "工程“创优”策划书":
            if (res[0].name) {
              this.parameters.SupplementaryContent.is24arr = res;
            } else {
              this.parameters.SupplementaryContent.is24arr = [];
            }
            break;
        case "<div style='text-align:left'>1.建筑市政工程提交“竣工验收报告”；<br/>2.工业、交通工程提交“交工验收证书”或“静态验收报告（铁路工程）”；<br/>3.电力工程提交“竣工验收报告”；<br/>4.水利工程提交“工程合同完工验收文件”；</div>":
            if (res[0].name) {
              this.parameters.SupplementaryContent.is25arr = res;
            } else {
              this.parameters.SupplementaryContent.is25arr = [];
            }
            break;
        case "建设工程“消防验收意见书”（涉及消防工程）":
            if (res[0].name) {
              this.parameters.SupplementaryContent.is26arr = res;
            } else {
              this.parameters.SupplementaryContent.is26arr = [];
            }
            break;
        case "“投入使用时间和使用效果证明”（建设单位出具）":
            if (res[0].name) {
              this.parameters.SupplementaryContent.is27arr = res;
            } else {
              this.parameters.SupplementaryContent.is27arr = [];
            }
            break;
        case "“建筑业10项新技术应用证明”（监理单位出具）":
            if (res[0].name) {
              this.parameters.SupplementaryContent.is28arr = res;
            } else {
              this.parameters.SupplementaryContent.is28arr = [];
            }
            break;
        case "工业交通水利工程其“技术指标、经济效益及社会效益应达到本专业工程省内领先水平”证明（监理单位出具）":
            if (res[0].name) {
              this.parameters.SupplementaryContent.is29arr = res;
            } else {
              this.parameters.SupplementaryContent.is29arr = [];
            }
            break;
        case "住宅工程需提供入住率达到50％的证明（建设单位出具）":
            if (res[0].name) {
              this.parameters.SupplementaryContent.is30arr = res;
            } else {
              this.parameters.SupplementaryContent.is30arr = [];
            }
            break;
        case "工程在施工过程中开展绿色施工并经评价合格":
            if (res[0].name) {
              this.parameters.SupplementaryContent.is31arr = res;
            } else {
              this.parameters.SupplementaryContent.is31arr = [];
            }
            break;
        case "建筑工程提供省（部）级结构优或满足《建筑工程施工质量评价标准》GB／T50375优良评价报告（监理单位或有资质的检测单位出具）":
            if (res[0].name) {
              this.parameters.SupplementaryContent.is32arr = res;
            } else {
              this.parameters.SupplementaryContent.is32arr = [];
            }
            break;
        case "反映工程概况和质量状况的彩色照片15张，５分钟工程影像或PPT资料":
            if (res[0].name) {
              this.parameters.SupplementaryContent.is33arr = res;
            } else {
              this.parameters.SupplementaryContent.is33arr = [];
            }
            break;
        case "无质量安全事故和无拖欠农民工工资承诺。（申报单位和参建单位都应提供）":
            if (res[0].name) {
              this.parameters.SupplementaryContent.is33arr = res;
            } else {
              this.parameters.SupplementaryContent.is33arr = [];
            }
            break;
        case "贵州省优质工程申报汇总表（XLSX格式）":
            if (res[0].name) {
              this.parameters.SupplementaryContent.is34arr = res;
            } else {
              this.parameters.SupplementaryContent.is34arr = [];
            }
            break;
        case "贵州省优质工程申报汇总表（PDF盖章版）":
            if (res[0].name) {
              this.parameters.SupplementaryContent.is35arr = res;
            } else {
              this.parameters.SupplementaryContent.is35arr = [];
            }
            break;
      }
    },
    fileSplice(index) {
      // console.log(this.parameters.SupplementaryContent.is20arr)
      //   this.parameters.SupplementaryContent.is20arr.splice(index,1);
      //   console.log(this.parameters.SupplementaryContent.is20arr)
    },
    //建筑业10项新技术应用证明或绿色施工证明 新增5个以内上传文件
    newadd() {
      if (this.parameters.SupplementaryContent.certificate.length > 4) {
        return false;
      }
      this.parameters.SupplementaryContent.certificate.push({
        uploadinput: "",
        uploadlist: [],
      });
    },
    //删除申报登记表需补充内容的上传文件
    remove(type, index, fileList) {
      console.log('ok', type, index);
      if (type == 1) {

        this.parameters.SupplementaryContent.certificate.splice(index, 1);
      }
      if (type == 2) {
        this.parameters.SupplementaryContent.Architecture_msg2_file.splice(
          index,
          1
        );
      }
      if (type == 3) {
        this.parameters.SupplementaryContent.Architecture_msg3_file.splice(
          index,
          1
        );
      }
      console.log(this.parameters.SupplementaryContent.Architecture_msg3_file);
    },
    //建筑业10项新技术应用证明或绿色施工证明  文件上传
    handleSuccessImg(index, fileList) {
      fileList.data.name = fileList.data.originalName;
      fileList.data.url = fileList.data.host + fileList.data.url;
      this.parameters.SupplementaryContent.certificate[index].uploadlist = [
        fileList.data,
      ];
      this.parameters.SupplementaryContent.certificate[index].title =
        "建筑业10项新技术应用证明或绿色施工证明";
      console.log(99, this.parameters.SupplementaryContent);
    },
    //省优质主体结构工程创优奖（房屋建筑、市政桥梁工程）  文件上传
    handleSuccessImg2(fileList) {
      fileList.data.name = fileList.data.originalName;
      fileList.data.url = fileList.data.host + fileList.data.url;
      this.parameters.SupplementaryContent.Architecture_msg2_file = [
        fileList.data,
      ];
    },
    //省安全文明样板工地奖（房屋建筑、市政园林）  文件上传
    handleSuccessImg3(fileList) {
      fileList.data.name = fileList.data.originalName;
      fileList.data.url = fileList.data.host + fileList.data.url;
      this.parameters.SupplementaryContent.Architecture_msg3_file = [
        fileList.data,
      ];
      console.log(this.parameters.SupplementaryContent.Architecture_msg3_file);
    },
    //承诺书上传
    onChange2(fileList) {
      // this.parameters.Recommendationform = fileList;
      this.$set(this.parameters, 'Recommendationform', fileList)
    },
    //选项 有无
    // changeTheme(e){
    //   console.log(e);
    // },
    //提交平台审核
    handleClick() {
      return;
    },
    async sumbit() {
      if (this.currentSubmit) {
        return;
      }
      this.currentSubmit = true;
      let data;
      // 每次提交时根据 lefttitlelist 实时计算是否填写完整，避免残留上一次的 false
      this.issumbit = this.lefttitlelist.every(item => item.isok);
      let issubmit = this.issumbit;
      //setTimeout(() => {
      switch (this.$route.query.title) {
        case "贵州省建筑业优秀项目经理":
          if (this.issumbit) {
            return Declare(this.$route.query.id, this.parameters2,this.rId,this.$route.query.award_batch_id).then((res) => {
              this.$router.push("/member/declear");
              this.$message({
                message: "提交审核成功",
                type: "success",
              });
              this.currentSubmit = false;
            }).catch(err => {
              this.currentSubmit = false;
              this.$alert(err, {
                confirmButtonText: '我知道了',
              });
              //this.$message.error(err)
            })
          } else {
            this.currentSubmit = false;
            this.$alert(err, {
              confirmButtonText: '请填写完所有表单在提交审核',
            });
            //this.$message.error("请填写完所有表单在提交审核");
          }
          break;
        case "贵州省优质工程评价":
          if (issubmit) {
              console.log('this.$route.query.award_batch_id',this.$route.query.award_batch_id)
            return Declare_modify(this.rId, this.$route.query.id, this.parameters,this.$route.query.award_batch_id).then((res) => {
              this.$router.push("/member/declear");
              this.$message({
                message: "提交审核成功",
                type: "success",
              });
              this.currentSubmit = false;
            }).catch(err => {
              this.currentSubmit = false;
              this.$alert(err, {
                confirmButtonText: '我知道了',
              });
              //this.$message.error(err)
            });
          } else {
            this.currentSubmit = false;
            this.$message.error("请填写完所有表单在提交审核");
          }
          break;
        case "贵州省优秀施工企业":
          if (this.issumbit) {
            return Declare(this.$route.query.id, this.parameters1,this.rId,this.$route.query.award_batch_id).then((res) => {
              this.$router.push("/member/declear");
              this.$message({
                message: "提交审核成功",
                type: "success",
              });
              this.currentSubmit = false;
            }).catch(err => {
              this.currentSubmit = false;
              this.$alert(err, {
                confirmButtonText: '我知道了',
              });
              //this.$message.error(err)
            });
          } else {
            this.currentSubmit = false;
            this.$alert("请填写完所有表单在提交审核", {
              confirmButtonText: '我知道了',
            });
            //this.$message.error("请填写完所有表单在提交审核");
          }
          break;
        case "建筑与市政工程绿色施工评价":
          if (this.issumbit) {
            this.parameters3.isnew = 1;
            return Declare(this.$route.query.id, this.parameters3,this.rId,this.$route.query.award_batch_id).then((res) => {
              this.$router.push("/member/declear");
              this.$message({
                message: "提交审核成功",
                type: "success",
              });
              this.currentSubmit = false;
            }).catch(err => {
              this.currentSubmit = false;
              this.$alert(err, {
                confirmButtonText: '我知道了',
              });
              //this.$message.error(err)
            });
          } else {
            this.currentSubmit = false;
            this.$alert("请填写完所有表单在提交审核", {
              confirmButtonText: '我知道了',
            });
            //this.$message.error("请填写完所有表单在提交审核");
          }
          break;

        case "省级施工工法":
          if ( this.issumbit) {
            // if (!this.mediaRequirementOk) {
            //     this.$message.error('请至少上传 10 张图片或 1 个视频（≤300MB）后再提交');
            //     return false;
            //   }
            this.$confirm("该项目申报材料一经提交后将无法再进行修改，请各企业务必认真核对好信息后再进行提交！","温馨提示")
                .then((_) => {
                   return Declare(this.$route.query.id, this.parameters4,this.rId,this.$route.query.award_batch_id).then((res) => {
                      this.$router.push("/member/declear");
                      this.$message({
                        message: "提交审核成功",
                        type: "success",
                      });
                      this.currentSubmit = false;
                    }).catch(err => {
                      this.currentSubmit = false;
                      this.$alert(err, {
                        confirmButtonText: '我知道了',
                      });
                      //this.$message.error(err)
                    });
                })
                .catch((_) => {
                    this.currentSubmit = false;
                });


          } else {
            this.currentSubmit = false;
            this.$message.error("请填写完所有表单在提交审核");
          }
          break;
        case "贵州省工程建设工法评定":
          if ( this.issumbit) {
              this.parameters4.info = ensureGongfaEnterpriseInfo(this.parameters4.info);
              const gongfaValidation = validateGongfaEnterpriseInfo(this.parameters4.info);
              if (!gongfaValidation.valid) {
                this.$message.error(gongfaValidation.errors[0]);
                this.currentSubmit = false;
                return false;
              }
              this.parameters4.info.author_names = normalizeGongfaAuthorNames(this.parameters4.info.author_names);
              let filelist12 = (this.parameters4?.info?.filelist12 || []);
              console.log('imageCountlist',this.parameters4?.info?.filelist12.length)
              let imagenum = filelist12.filter(f => this.isImageFile(f)).length;
            
              let videonum =  filelist12.filter(f => this.isVideoFile(f)).length;
              let mediaRequirementOk = imagenum >= 10 || videonum >= 1;
            if ( !mediaRequirementOk ) {
                this.$message.error('请至少上传 10 张图片或 1 个视频（≤300MB）后再提交');
                this.currentSubmit = false;
                return false;
              }
              return Declare(this.$route.query.id, this.parameters4,this.rId,this.$route.query.award_batch_id).then((res) => {
                      this.currentSubmit = false;
                      return this.showGongfaSubmitSuccess().then(() => {
                        if(this.rId){
                            var baid = this.$route.query.id;
                            var btitle = '贵州省工程建设工法评定';
                            this.$router.push("/member/Declar_record?name=申报记录&baid="+baid+'&btitle='+btitle);
                        } else {
                            this.$router.push("/member/declear");
                        }
                      }).catch(() => {
                        // 用户点击×关闭弹窗，不做跳转
                      });
                    }).catch(err => {
                      this.currentSubmit = false;
                      this.$alert(err, {
                        confirmButtonText: '我知道了',
                      });
                      //this.$message.error(err)
                    });
          } else {
            this.currentSubmit = false;
            this.$message.error("请填写完所有表单在提交审核");
          }
          break;
        case "工程建设质量管理小组竞赛活动":
          if (this.issumbit) {
            return Declare(this.$route.query.id,
              this.$refs.groupAward.getData(),
              this.rId,
              this.$route.query.award_batch_id
            ).then((res) => {
              this.$router.push("/member/declear");
              this.$message({
                message: "提交审核成功",
                type: "success",
              });
              this.currentSubmit = false;
            }).catch(err => {
              this.currentSubmit = false;
              this.$alert(err, {
                confirmButtonText: '我知道了',
              });
              //this.$message.error(err)
            });
          } else {
            this.currentSubmit = false;
            this.$alert("请填写完所有表单在提交审核", {
              confirmButtonText: '我知道了',
            });
            //this.$message.error("请填写完所有表单在提交审核");
          }
          break;
      }
      //}, 500);

    },
    changeType(e) {
      console.log(e);
      let lefttitlelist = JSON.parse(JSON.stringify(this.lefttitlelist))
      lefttitlelist[1].isok = false;
      this.lefttitlelist = lefttitlelist;
      console.log(this.lefttitlelist[1])
      this.parameters4.info.type_of_major = "";
      if (e == "房屋建筑工程") {
        this.type_major_arr = this.type_major_arr1;
      }
      if (e == "土木工程") {
        this.type_major_arr = this.type_major_arr2;
      }
      if (e == "工业安装工程") {
        this.type_major_arr = this.type_major_arr3;
        this.type_major_arr3.forEach(item => {
          let key = item
          this.$set(this.form, key, [])
        });
        // this.$set(this.type_major_arr, 0, []);
      }
    },
    changeMajorType(e) {
      console.log(e);
      let lefttitlelist = JSON.parse(JSON.stringify(this.lefttitlelist))
      lefttitlelist[1].isok = true;
      this.lefttitlelist = lefttitlelist;
      // this.parameters4.info.type_of_major = e;
    },
    //保存草稿
    SaveDraftleft() {
      this.btnSaveStatus = true;
      let data;
      let lessonObj;
      let list = {};
      console.log(this.$route.query.title);
      //this.parameters2['award_batch_id'] = this.$route.query.award_batch_id
      switch (this.$route.query.title) {
        case "贵州省建筑业优秀项目经理":
          return SaveBDraft(this.$route.query.id, this.parameters2,this.$route.query.award_batch_id).then(res => {
            this.$message({
              message: "保存草稿成功",
              type: "success",
            });
            this.btnSaveStatus = false;
          }).catch(err => {
            this.btnSaveStatus = false;
            this.$alert(err, {
              confirmButtonText: '我知道了',
            });
            //this.$message.error(err)
          });
        case "贵州省优质工程评价":
          // for (const key in this.parameters.unitinfo[0]) {
          //   list[key] = this.parameters.unitinfo[0][key];
          // }
          // this.parameters.unitinfo[0] = list;
          return SaveBDraft(this.$route.query.id, this.parameters,this.$route.query.award_batch_id).then(res => {
            this.$message({
              message: "保存草稿成功",
              type: "success",
            });
            this.btnSaveStatus = false;
          }).catch(err => {
            this.btnSaveStatus = false;
            this.$alert(err, {
              confirmButtonText: '我知道了',
            });
            //this.$message.error(err)
          });
        case "贵州省优秀施工企业":
          return SaveBDraft(this.$route.query.id, this.parameters1,this.$route.query.award_batch_id).then(res => {
            this.$message({
              message: "保存草稿成功",
              type: "success",
            });
            this.btnSaveStatus = false;
          }).catch(err => {
            this.btnSaveStatus = false;
            this.$alert(err, {
              confirmButtonText: '我知道了',
            });
            //this.$message.error(err)
          });
        case "建筑与市政工程绿色施工评价":
          return SaveBDraft(this.$route.query.id, this.parameters3,this.$route.query.award_batch_id).then(res => {
            this.$message({
              message: "保存草稿成功",
              type: "success",
            })
            this.btnSaveStatus = false;
          }).catch(err => {
            this.btnSaveStatus = false;
            this.$alert(err, {
              confirmButtonText: '我知道了',
            });
          });
        case "新技术示范工程":
          return SaveBDraft(this.$route.query.id, this.parameters6,this.$route.query.award_batch_id).then(res => {
            this.$message({
              message: "保存草稿成功",
              type: "success",
            });
            this.btnSaveStatus = false;
          }).catch(err => {
            this.btnSaveStatus = false;
            this.$alert(err, {
              confirmButtonText: '我知道了',
            });
            //this.$message.error(err)
          });
        case "省级施工工法":
          return SaveBDraft(this.$route.query.id, this.parameters4,this.$route.query.award_batch_id).then(res => {
            this.$message({
              message: "保存草稿成功",
              type: "success",
            });
            this.btnSaveStatus = false;
          }).catch(err => {
            this.btnSaveStatus = false;
            this.$alert(err, {
              confirmButtonText: '我知道了',
            });
            //this.$message.error(err)
          });
         case "贵州省工程建设工法评定":
          return SaveBDraft(this.$route.query.id, this.parameters4,this.$route.query.award_batch_id).then(res => {
            this.$message({
              message: "保存草稿成功",
              type: "success",
            });
            this.btnSaveStatus = false;
          }).catch(err => {
            this.btnSaveStatus = false;
            this.$alert(err, {
              confirmButtonText: '我知道了',
            });
            //this.$message.error(err)
          });
        case "工程建设质量管理小组竞赛活动":
          return SaveDraft(this.$route.query.id,
          this.$refs.groupAward.getData(),
          this.$route.query.award_batch_id).then(res => {
            this.$message({
              message: "保存草稿成功",
              type: "success",
            });
            this.btnSaveStatus = false;
          }).catch(err => {
            this.btnSaveStatus = false;
            this.$alert(err, {
              confirmButtonText: '我知道了',
            });
            //this.$message.error(err)
          });
      }
    },
    //在线预览
    async printPdf() {
      // 实时根据 lefttitlelist 计算是否填写完整，避免残留上一次的 false
      this.issumbit = this.lefttitlelist.every(item => item.isok);
      let data;
      let istrue = true;
      let count = 0;
      //this.parameters2['award_batch_id'] = this.$route.query.award_batch_id
      switch (this.$route.query.title) {
        case "贵州省建筑业优秀项目经理":
          data = await SaveBDraft(this.$route.query.id, this.parameters2,this.$route.query.award_batch_id).catch(err => {
            this.$alert(err, {
              confirmButtonText: '我知道了',
            });
            //this.$message.error(err)
            return false;
          });
          sessionStorage.setItem(
            "parameters",
            JSON.stringify(this.parameters2)
          );
          this.$router.push(`/word_1?awardid=${this.$route.query.id}&awardbatchid=${this.$route.query.award_batch_id}&title=${this.$route.query.title}&issumbit=${this.issumbit}`);
          break;
        case "贵州省优质工程评价":
          for (const key in this.parameters.SupplementaryContent) {
            for (let i = 20; i <= 35; i++) {
              if (this.parameters.SupplementaryContent["is" + i] == "1") {
                if (this.parameters.SupplementaryContent["is" + i + "arr"].length < 1) {
                  istrue = false;
                }
              }
            }
          }
          console.log(this.parameters.SupplementaryContent);
          if (istrue) {
            console.log(this.parameters)
              data = await SaveBDraft(this.$route.query.id, this.parameters,this.$route.query.award_batch_id).catch(err => {
              this.$alert(err, {
                confirmButtonText: '我知道了',
              });
              //this.$message.error(err)
              return false;
            });
            sessionStorage.setItem(
              "parameters",
              JSON.stringify(this.parameters)
            );
            this.$router.push(`/word_1?awardid=${this.$route.query.id}&awardbatchid=${this.$route.query.award_batch_id}&title=${this.$route.query.title}&issumbit=${this.issumbit}`);
          } else {
            this.$alert("请检查！有文件没有上传", {
              confirmButtonText: '我知道了',
            });
            //this.$message.error("请检查！有文件没有上传");
          }
          break;
        case "新技术示范工程":
          data = await SaveBDraft(this.$route.query.id, this.parameters6,this.$route.query.award_batch_id).catch(err => {
              this.$alert(err, {
                confirmButtonText: '我知道了',
              });
              //this.$message.error(err)
              return false;
            });
          sessionStorage.setItem(
            "parameters",
            JSON.stringify(this.parameters3)
          );
          break;
        case "贵州省优秀施工企业":
          data = await SaveBDraft(this.$route.query.id, this.parameters1,this.$route.query.award_batch_id).catch(err => {
              this.$alert(err, {
                confirmButtonText: '我知道了',
              });
              //this.$message.error(err)
              return false;
            });
          sessionStorage.setItem(
            "parameters",
            JSON.stringify(this.parameters1)
          );
          this.$router.push(`/word_1?awardid=${this.$route.query.id}&awardbatchid=${this.$route.query.award_batch_id}&title=${this.$route.query.title}&issumbit=${this.issumbit}`);
          break;
        case "建筑与市政工程绿色施工评价":
          data = await SaveBDraft(this.$route.query.id, this.parameters3,this.$route.query.award_batch_id).catch(err => {
              this.$alert(err, {
                confirmButtonText: '我知道了',
              });
              return false;
            });
          sessionStorage.setItem(
            "parameters",
            JSON.stringify(this.parameters3)
          );
          this.$router.push(`/word_1?awardid=${this.$route.query.id}&awardbatchid=${this.$route.query.award_batch_id}&title=${this.$route.query.title}&issumbit=${this.issumbit}`);
          break;
        case "省级施工工法":
          data = await SaveBDraft(this.$route.query.id, this.parameters4,this.$route.query.award_batch_id).catch(err => {
              this.$alert(err, {
                confirmButtonText: '我知道了',
              });
              //this.$message.error(err)
              return false;
            });
          sessionStorage.setItem(
            "parameters",
            JSON.stringify(this.parameters4)
          );
          this.$router.push(`/word_1?awardid=${this.$route.query.id}&awardbatchid=${this.$route.query.award_batch_id}&title=${this.$route.query.title}&issumbit=${this.issumbit}`);
          break;
        case "贵州省工程建设工法评定":
          data = await SaveBDraft(this.$route.query.id, this.parameters4,this.$route.query.award_batch_id).catch(err => {
              this.$alert(err, {
                confirmButtonText: '我知道了',
              });
              //this.$message.error(err)
              return false;
            });
          sessionStorage.setItem(
            "parameters",
            JSON.stringify(this.parameters4)
          );
          this.$router.push(`/word_1?awardid=${this.$route.query.id}&awardbatchid=${this.$route.query.award_batch_id}&title=${this.$route.query.title}&issumbit=${this.issumbit}`);
          break;
        case "工程建设质量管理小组竞赛活动":
          data = await SaveDraft(this.$route.query.id,
                  this.$refs.groupAward.getData(),
                  this.$route.query.award_batch_id).catch(err => {
                      this.$alert(err, {
                        confirmButtonText: '我知道了',
                      });
              //this.$message.error(err)
              return false;
            });
          sessionStorage.setItem(
            "parameters",
            JSON.stringify(this.$refs.groupAward.getData())
          );
          this.$router.push(`/word_1?awardid=${this.$route.query.id}&awardbatchid=${this.$route.query.award_batch_id}&title=${this.$route.query.title}&issumbit=${this.issumbit}`);
          break;
      }
    },
    //返回上一页
    backpage() {
      this.$router.go(-1);
    },
    //新增参建单位信息
    addnew() {
      this.parameters.unitinfo.push({
        Construction_content: "",
        Construction_proportion: "",
        Construction_workload: "",
        Qualification_level: "",
        Telephone: "",
        brief_introduction: "",
        codeyouzheng: "",
        guding_phone: "",
        leave: "",
        movephone1: "",
        name2: "",
        name3: "",
        name4: "",
        phone2: "",
        phone3: "",
        phoneaddress: "",
        postion: "",
        unitname: "",
        work_department: "",
      });
      this.lefttitlelist.splice(this.parameters.unitinfo.length, 0, {
        name:
          "参建单位信息" +
          (this.parameters.unitinfo.length - 1 == 0
            ? ""
            : this.parameters.unitinfo.length - 1),
        isok: false,
      });
    },
    //删除参建单位信息
    deleteform() {
      if (this.parameters.unitinfo.length == 1) {
        this.lefttitlelist.splice(1, 1);
        this.parameters.unitinfo = [];
        return false;
      }
      this.parameters.unitinfo.splice(this.parameters.unitinfo.length - 1, 1);
      this.lefttitlelist.splice(this.parameters.unitinfo.length + 1, 1);
    },
    deleteunit(states) {
      if (states == 1) {
        this.parameters4.unitarr.splice(this.parameters4.unitarr.length - 1, 1);
      }
      if (states == 2) {
        this.parameters4.Completed_byarr.splice(
          this.parameters4.Completed_byarr.length - 1,
          1
        );
      }
      if (states == 3) {
        console.log(33333)
        this.parameters4.info.author_names.splice(
          this.parameters4.info.author_names.length - 1,
          1
        );
      }
    },
    deleteuser(item) {
      this.parameters4.info.author_names.pop(item);
      this.$forceUpdate();
      this.author_sock_check();
    },
    add_author(event, item,index) {
      var tmp_item = item;
      var name = event.target.value;
      // 仅“贵州省工程建设工法评定”（award_id=21）限制完成人姓名输入。
      if (Number(this.$route.query.id) === 21) {
        name = name.replace(/[0-9\s]/g, '');
        event.target.value = name;
      }
      tmp_item['name'] = name;
      this.parameters4.info.author_names[index] = tmp_item;
      this.author_sock_check();
    },
    author_sock_check() {
      this.lefttitlelist[3].isok = false;
      if (this.parameters4.info.author_names && this.parameters4.info.author_names.length > 0) {
        for (var i = 0; i < this.parameters4.info.author_names.length; i++) {
          if (this.parameters4.info.author_names[i].name.length > 0) {
            this.lefttitlelist[3].isok = true;
            return;
          }
        }
      }
    },
    addunit(states) {
      if (states == 1) {
        this.parameters4.unitarr.push({
          Approval_comments: "",
          address_code: "",
          name_phone: "",
          Office_telephone: "",
        });
      }
      if (states == 2) {
        this.parameters4.Completed_byarr.push({
          Approval_comments: "",
          address_code: "",
          name_phone: "",
          Office_telephone: "",
        });
      }
      if (states == 3) {
        this.upAuthor()
      }
    },
    upAuthor() {
      console.log("upAuthor",this.parameters4.info)
      console.log(this.parameters4.info.author_names)
      console.log('member_name',localStorage.getItem('member_name'))
      if (typeof (this.parameters4.info.author_names) == "undefined") {
          this.parameters4.info.author_names = [{
            "name": "",
            "starttime": Math.floor((Math.random() * 1000) + 1),
          },{
            "name": "",
            "starttime": Math.floor((Math.random() * 1000) + 1),
          },{
            "name": "",
            "starttime": Math.floor((Math.random() * 1000) + 1),
          },{
            "name": "",
            "starttime": Math.floor((Math.random() * 1000) + 1),
          },{
            "name": "",
            "starttime": Math.floor((Math.random() * 1000) + 1),
          }];
        } else {

          let arr = this.parameters4.info.author_names;
          console.log(arr)
          console.log("arr1111")
          console.log(6 - arr.length)
          let newArr = Object.assign([], arr)

          for (let index = 0; index < (5 - arr.length); index++) {
            let data = {
              "name": "",
              "starttime": Math.floor((Math.random() * 1000) + 1),
            };
            newArr.push(data);
          }
          console.log(newArr)
          this.parameters4.info.author_names = newArr;
        }
        if (typeof (this.parameters4.info.unit) == "undefined") {
            
            this.parameters4.info.unit = localStorage.getItem('member_name')
        }
        
        
        this.$forceUpdate();
        console.log(this.parameters4.info.author_names);
        console.log('gf_province',this.parameters4.info.gf_province);
        // if (typeof (this.parameters4.info.gf_province) == "undefined") {
            
        //     this.parameters4.info.gf_province = "1"
        // }
    },
    //左边导航列表点击
    scrollleft(name, id) {
      this.scrollnum(id);
    },
    //锚点滚动
    scrollnum(id) {
      document
        .querySelector(id)
        .scrollIntoView({ behavior: "smooth", block: "start" });

    },

    handleAdd(response, file, fileList) {
      this.fileList = fileList;
      this.ruleForm.business_license = response.data.host + response.data.url;
    },
    handleAdd2(response, file, fileList) {
      this.fileList2 = fileList;
      this.ruleForm.certifications = response.data.host + response.data.url;
    },
    handleAddhead_portrait(response, file, fileList) {
      this.head_portrait = fileList;
      this.ruleForm.head_portrait = response.data.host + response.data.url;
    },
    phandleRemove(file) {
      this.fileList = [];
      this.ruleForm.business_license = "";
    },
    phandleRemove2() {
      this.fileList2 = [];
      this.ruleForm.certifications = "";
    },
    phead_portraitremove(file) {
      console.log(file);
      this.head_portrait = [];
      this.ruleForm.head_portrait = "";
    },
    phandlePictureCardPreview(file) {
      console.log("ok");
      this.dialogImageUrl = file.url;
      this.dialogVisible = true;
    },
    phandleDownload(file) {
      console.log(file);
    },
    phandleExceed() {
      this.$message.warning(`请最多上传 ${this.limit} 个文件。`);
    },
    
    changeText(type,maxLength,index=0){
        var obj = '';
        if(type == 'brief_introduction1'){
            obj = this.parameters.Contractorinfo.brief_introduction1;
        } else if(type == 'project_info'){
            obj = this.parameters.ProjectOverview.project_info;
        } else if(type == 'brief_introduction'){
            this.parameters.unitinfo[index].brief_introduction
        }
        console.log('obj.length',obj.length)
        if (obj.length > maxLength) {
          obj = obj.substring(0, maxLength);
          if(type == 'brief_introduction1'){
                this.parameters.Contractorinfo.brief_introduction1 = obj.substring(0, maxLength);
            } else if(type == 'project_info'){
                this.parameters.ProjectOverview.project_info = obj.substring(0, maxLength);
            } else if(type == 'brief_introduction'){
                this.parameters.unitinfo[index].brief_introduction = obj.substring(0, maxLength);
            }
            
          console.log('obj',obj.length)
        }
    }
  },
};
</script>
<style>
  .tooltip-width {
    max-width: 400px;

  }
  .el-icon-info{
    margin-left: 460px;
  }
</style>
<style lang="less" scoped>
@import './myform.less';
</style>
<style>
.form_error input,.form_error button ,.form_error radio{
    border:1px solid #FF616E !important;
}
.form_error_k {
     border:1px solid #FF616E !important;
     background: #FFEBED !important;
     border-radius: 4px;
}
.wrap .form_box .form_right--green {
  margin-left: 300px;
  width: 918px;
}
.wrap .form_box .form_right--green .flex {
  justify-content: flex-start;
  align-items: stretch;
  flex-wrap: wrap;
}
.el-upload-list__item-name{
  width:250px
}
.el-upload-list {
  min-height: 50px !important;
  height: auto !important;
  display: flex;
  align-items: center;
  flex-wrap: wrap !important;
}

.el-upload-list__item {
  transition: none !important;
}
.upload-demo {
        flex-wrap: wrap;
}

.gongfa-submit-success-dialog .el-message-box__title {
  width: 100%;
  text-align: center;
  font-weight: 700;
}

.gongfa-submit-success-dialog .el-message-box__message {
  line-height: 24px;
}

input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
  -webkit-appearance: none !important;
  margin: 0;
}
</style>


<style lang="less">
.el-tabs__nav-scroll {
  display: flex;
  justify-content: center;

  .el-tabs__item,
  .is-active {
    color: #7c828a;
    font-size: 16px;
    font-family: Source Han Sans CN;
    font-weight: bold;
  }

  .el-tabs__item.is-active {
    color: #194abe;
    font-size: 16px;
    font-family: Source Han Sans CN;
    font-weight: bold;
  }

  .el-tabs__item:hover {
    color: #194abe;
  }

  .el-tabs__active-bar {
    background-color: #194abe;
  }
}

.el-form-item__error {
  margin-left: 140px;
}

.el-form-item__label {
  min-width: 300px;
}

.el-form-item__content {
  text-align: left;
}

.block-solid {
  margin-top: 70px;
}
</style>
<style scoped lang="less">
.flex {
  display: flex;
  align-items: center;
  justify-content: center;
}
.bot-red-border {
  width: 100%;
  border-top: 2px solid #e51725;
  display: flex;
  justify-content: center;
  padding-top: 37px;
  margin-top: 40px;
  .btn-give_up {
    cursor: pointer;
    width: 189px;
    height: 50px;
    line-height: 50px;
    text-align: center;
    background: #ffffff;
    border: 1px solid #194abe;
    opacity: 1;
    border-radius: 4px;
    box-sizing: border-box;
    margin: 0 10px;
    font-size: 16px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #194abe;
  }
  .btn-modify {
    cursor: pointer;
    width: 189px;
    height: 50px;
    background: #194abe;
    opacity: 1;
    border-radius: 4px;
    box-sizing: border-box;
    margin: 0 10px;
    display: flex;
    align-items: center;
    justify-content: center;
    img {
      width: 18px;
      height: 14px;
      margin-right: 10px;
    }
    p {
      font-size: 18px;
      font-family: Microsoft YaHei;
      font-weight: bold;
      line-height: 27px;
      color: #ffffff;
    }
  }
}
.demo-ruleForm {
  width: 100%;
  margin: 30px 0;
  text-align: center;
  .inpyabeb {
    width: 50%;
  }
}
.my_form,
.my_form2 {
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  overflow: auto;
  align-items: stretch;
  .form_title {
    background: #eaf0f6;
    width: 129px;
    min-width: 129px;
    height: auto;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 14px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    line-height: 20px;
    padding: 0 6px;
    box-sizing: border-box;
    color: #0c0d0f;
  }
  .uploadinput {
    display: flex;
    flex-direction: column;
    justify-content: center;
    .uploadlist {
      display: flex;
      align-items: center;
      margin: 10px 0;
    }
    input {
      width: 257px;
      height: 36px;
      background: #ffffff;
      border: 1px solid #bdc3cb;
      opacity: 1;
      border-radius: 4px;
      padding: 0 15px;
      box-sizing: border-box;
      &:focus {
        outline: none;
        border: 1px solid #194abe;
      }
    }
    .input {
      width: 257px;
      display: flex;
      position: relative;
      display: flex;
      align-items: center;
      margin-left: 20px;
      span {
        position: absolute;
        right: 10px;
        top: 50%;
        transform: translateY(-50%);
      }
    }
  }
  .form_content,
  .form_long,
  .form_choice {
    width: 300px;
    padding: 0px 6px;
    background: #f5f8fb;
    display: flex;
    align-items: center;
    justify-content: center;
    box-sizing: border-box;
    input {
      width: 257px;
      height: 36px;
      background: #ffffff;
      border: 1px solid #bdc3cb;
      opacity: 1;
      border-radius: 4px;
      padding: 0 15px;
      box-sizing: border-box;
      &:focus {
        outline: none;
        border: 1px solid #194abe;
      }
    }
    .input {
      width: 257px;
      display: flex;
      position: relative;
      span {
        position: absolute;
        right: 10px;
        top: 50%;
        transform: translateY(-50%);
      }
    }
  }
  .form_choice_long {
    display: flex;
    justify-content: start;
    align-items: center;
    width: 729px;
    padding-left: 20px;
    box-sizing: border-box;
    background: #f5f8fb;
  }
  .form_long {
    width: 729px;
    input {
      width: 688px;
    }
    div{
      display: flex;
      align-items: center;
      /deep/.el-upload-list{
        margin: 0 !important;
		flex-wrap: wrap;
		li{
			width: 200px;
			margin-left: 10px;
		}
      }
    }
  }
  .form_long-1{
    display: flex;
    align-items: left;
    justify-content: left!important;;
	padding-left: 30px!important;
  }
  .form_textarea {
    width: 729px;
    height: 188px;
    display: flex;
    background: #f5f8fb;
    flex-direction: column;
    justify-content: space-evenly;
    padding-left: 20px;
    textarea {
      width: 688px;
      height: 127px;
      background: #ffffff;
      border: 1px solid #bdc3cb;
      opacity: 1;
      border-radius: 4px;
      padding: 9px 15px;
      box-sizing: border-box;
      color: #000;
      &:focus {
        outline: none;
        border: 1px solid #194abe;
      }
    }
  }
  .uploadimg {
    width: 729px;
    padding: 20px;
    background: #f5f8fb;
    box-sizing: border-box;
  }
  .Downinpustyle {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    background: #f5f8fb;
    .nejje {
      color: #194abe !important;
    }
  }
  .upload-demo {
    width: 729px;
    padding-left: 20px;
    background: #f5f8fb;
    display: flex;
    align-items: center;
    box-sizing: border-box;
    height: 100px;
    .el-upload__tip {
      margin-left: 10px;
    }
  }
}
.my_form {
}
.my_form2 {
  .form_title {
    background: #f5f8fb;
  }
  .form_content,
  .form_long,
  .form_textarea,
  .form_choice,
  .form_choice_long,
  .upload-demo,
  .Downinpustyle {
    background: #fbfdff;
  }
}
.from-div{
	padding-bottom: 12px;
}
.form-lable{
	width: 100%;
    display: flex;
	justify-content: left;
	align-items: center;
	margin-bottom: 8px;
	.left{
		font-size: 16px;
		font-weight: bolder;
	}
	.right{
		display: flex;
		flex-direction: row;
		justify-content: center;
		align-items: center;
		border:1px solid #F9656F;
		border-radius: 5px;
		padding: 2px 8px;
		margin-left: 15px;
		img{
			width: 15px;
			height: 15px;
		}
		.delete-txt{
			font-size: 14px;
			font-weight: bolder;
			color: #F9656F;
			margin-left: 5px;
		}
	}
}
.el-upload-list {
	flex-wrap: wrap;
	margin: 0;
	padding: 0;
	list-style: none;
}
  input:disabled, radio:disabled {
     background:#F0F0F0 !important;
 }
.wrap .form_box .form_right {
    margin-left: 280px !important;
}
.input-tip {
  margin-top: 6px;
  font-size: 12px;
  color: #8c8c8c;
}
.input--with-tip {
  flex-direction: column;
  align-items: flex-start !important;
}
.field-tip {
  margin-top: 6px;
  font-size: 12px;
  line-height: 18px;
  color: #8c8c8c;
  text-align: left;
}
.field-tip--error {
  color: #f56c6c;
}
.field-tip--block {
  width: 100%;
}
.gongfa-return-notice {
  margin-top: 10px;
  line-height: 22px;
  color: #e6a23c;
}
.gongfa-province {
  display: flex;
  align-items: center;
  gap: 16px;
  flex-wrap: wrap;
}
.gongfa-province__select {
  width: 180px;
}
/* 整体启用自动编号 */
.gfupload { counter-reset: sec; }

/* 卡片容器 */
.gfupload .my_form {
      background: #fff !important;
    overflow: hidden;
    flex-direction: column !important;
    align-items: flex-start !important;
    width: 99.5%;
    padding-top: 0px !important;
    padding-bottom: 0px !important;
}

/* 错误高亮（保留你的类名） */
.gfupload .form_error_k {
  box-sizing: border-box;
  width: 100%;
  border-right: 1px solid #FF616E !important;
  border-left: 1px solid #FF616E !important;
  border-top: 1px solid #FF616E !important;
  border-bottom: 1px solid #FF616E !important;
  border: 1px solid #FF616E !important;
  background: #FFEBED !important;
  box-shadow: 0 0 0 2px rgba(255,97,110,0.08);
}
.gfupload .form_error_k .form_title,
.gfupload .form_error_k .upload-demo,
.gfupload .form_error_k .dform_title,
.gfupload .form_error_k .uploadcertificate,
.gfupload .form_error_k .gongfa-authorization,
.gfupload .uploadcertificate.form_error_k .upload-demo,
.gfupload .uploadcertificate.form_error_k .form-upload-div {
  background: #FFEBED !important;
}
.gf-modify-opinion {
    display: block;
    width: 100%;
    box-sizing: border-box;
    flex: 0 0 100%;
    margin: 6px 0 8px;
    background: #FFEBED;
    border-radius: 4px;
    border: 1px solid #FF616E;
    font-weight: 400;
    color: #FF3330;
    font-size: 13px;
    padding: 6px 10px;
    line-height: 1.6;
    text-align: left;
}
.dftitle {
   width: 100% !important; 
   text-align: left !important; 
   justify-content: flex-start !important; 
   padding-top: 10px !important; 
   padding-bottom: 10px !important;
}
/* 标题行 */
.gfupload .form_title {
  display:flex !important; 
  align-items:center !important;
  padding:0px 14px !important;
  font-weight:600; color:#303133 !important;
  border-bottom:1px solid #f0f0f0 !important;
}

/* 附件1的浅灰标题背景 */
.gfupload .form_title--soft { background:#f5f8fb; }

/* 自动编号（无需在模板里手写 1、2、3…） */
.gfupload .form_title::before {
  content: counter(sec) '、';
  counter-increment: sec;
  color:#606266;
  margin-right:6px;
}

/* 标题下的说明文字 */
.gfupload .title-desc {
  line-height: 1.7;
    font-weight: 400;
    font-size: 14px;
    color: #595959;
  text-align: left;
}

/* 上传区布局 */
.gfupload .uploadcertificate {
      padding: 12px 0px 14px;
    display: flex;
    gap: 16px;
    align-items: flex-start;
    flex-wrap: wrap;
    width: 100%;
    align-self: flex-start !important;
    background: #f5f8fb;
}

.gfupload .gongfa-authorization {
    width: 100%;
    box-sizing: border-box;
    padding: 12px 21px 16px;
    background: #FEFAF4;
    border: 1px solid #FFB700;
    border-radius: 8px;
    text-align: left;
}

.gfupload .gongfa-authorization .field-tip {
    margin: 0 0 10px;
    color: #606266;
}

.gfupload .gongfa-authorization .el-radio-group {
    display: flex;
    justify-content: flex-start;
    align-items: center;
    width: 100%;
}

.gfupload .gongfa-authorization .el-radio {
    margin-right: 42px;
}

/* 上传按钮主色 */
.gfupload .action_upload { border-color:#409EFF; color:#409EFF; }

/* Element 的上传提示色 */
.gfupload .el-upload__tip { color:#909399; }

/* 照片/视频宫格尺寸（可按需调） */
.gfupload .uploadcertificate.media .el-upload--picture-card { width:112px; height:112px; }
.gfupload .uploadcertificate.media .el-upload-list--picture-card .el-upload-list__item { width:112px; height:112px; }
.gfupload .uploadcertificate.media .media-thumb {
    width: 112px;
    height: 112px;
    border-radius: 6px;
    background: linear-gradient(135deg, #243b53 0%, #4a667f 100%);
    color: #fff;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    font-size: 13px;
    line-height: 1.2;
    cursor: pointer;
    overflow: hidden;
}

.gfupload .uploadcertificate.media .media-thumb i {
    font-size: 30px;
    margin-bottom: 6px;
}

.gfupload .uploadcertificate.media .media-thumb--video {
    box-shadow: inset 0 0 0 1px rgba(255, 255, 255, 0.12);
}

.gfupload .my_form {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    justify-content: flex-start;
}
.gfupload .dform_title {
    display: flex;
    flex-direction: row;
    align-items: flex-start;
    justify-content: flex-start;
    background: #eaf0f6;
    padding-top: 10px;
    padding-bottom: 10px;
}
.gfupload .dform_title .form_title{
    width: 350px;
    height: 100%;
    text-align: left;
    justify-content: flex-start;
}
.gfupload .upload-demo {
    width: 100% !important;
}
  .upload-file--file {
    margin: 5px 20px 20px;
    font-size: 12px;
    color: blue;
  }
</style>
